// @ts-nocheck
import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import PricingPage from "./components/PricingPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import { analytics } from "./lib/analytics";
import { canAccess, isAtItemLimit, type PlanKey } from "./lib/stripe";
import UpgradeGate from "./components/UpgradeGate";
import { BarcodeScanner } from "./BarcodeScanner";
import { lookupProductByBarcode } from "./lib/api-service";

// ─── Icons (inline SVG components) ───
const Icons = {
  Home: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  Box: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>,
  List: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  Book: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>,
  Chart: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  Bell: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></svg>,
  Settings: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"/></svg>,
  Plus: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Search: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  Trash: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>,
  Edit: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  Check: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
  X: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Alert: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  Camera: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>,
  Users: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>,
  Share: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>,
  Arrow: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>,
  Down: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>,
  Scan: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 7V5a2 2 0 012-2h2"/><path d="M17 3h2a2 2 0 012 2v2"/><path d="M21 17v2a2 2 0 01-2 2h-2"/><path d="M7 21H5a2 2 0 01-2-2v-2"/><line x1="7" y1="12" x2="17" y2="12"/></svg>,
  Clock: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  Star: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
  Leaf: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 20A7 7 0 019.8 6.9C15.5 4.9 17 3.5 19 2c1 2 2 4.5 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>,
  Download: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  Cart: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>,
  Refresh: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg>,
  LogOut: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  Calendar: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  ChefHat: (p: React.SVGProps<SVGSVGElement>) => <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 13.87A4 4 0 017.41 6a5.11 5.11 0 019.18 0A4 4 0 0118 13.87V21H6z"/><line x1="6" y1="17" x2="18" y2="17"/></svg>,
};

// ─── Constants ───
const CATEGORIES = ["Produce", "Dairy", "Meat", "Bakery", "Frozen", "Canned", "Beverages", "Snacks", "Condiments", "Grains", "Spices", "Other"];
const LOCATIONS = ["Fridge", "Freezer", "Pantry", "Counter", "Cabinet", "Other"];
const CUISINES = ["All", "Italian", "Asian", "Mexican", "Mediterranean", "American", "Other"];

// Map TheMealDB strArea → our cuisine categories
const AREA_TO_CUISINE: Record<string, string> = {
  Italian: "Italian",
  French: "Mediterranean", Greek: "Mediterranean", Spanish: "Mediterranean",
  Moroccan: "Mediterranean", Turkish: "Mediterranean", Tunisian: "Mediterranean",
  Portuguese: "Mediterranean", Egyptian: "Mediterranean", Lebanese: "Mediterranean",
  Croatian: "Mediterranean",
  Chinese: "Asian", Japanese: "Asian", Thai: "Asian", Vietnamese: "Asian",
  Indian: "Asian", Malaysian: "Asian", Filipino: "Asian", Korean: "Asian",
  Mexican: "Mexican",
  American: "American", Canadian: "American", Irish: "American",
  British: "Other", Jamaican: "Other", Dutch: "Other", Polish: "Other",
  Russian: "Other", Kenyan: "Other", Unknown: "Other",
};

function mapMealDB(meal: Record<string, string>): Record<string, unknown> {
  const ingredients: string[] = [];
  for (let i = 1; i <= 20; i++) {
    const name = (meal[`strIngredient${i}`] || "").trim();
    const measure = (meal[`strMeasure${i}`] || "").trim();
    if (name) ingredients.push(measure ? `${measure} ${name}` : name);
  }
  const steps = (meal.strInstructions || "")
    .split(/\r?\n+/)
    .map((s: string) => s.replace(/^\d+[\.\)]\s*/, "").trim())
    .filter((s: string) => s.length > 10)
    .slice(0, 12);
  const cuisine = meal.strArea || "Other";
  return {
    id: meal.idMeal,
    name: meal.strMeal,
    cuisine,
    prep: 15,
    cook: 30,
    servings: 4,
    difficulty: ingredients.length > 12 ? "Hard" : ingredients.length > 7 ? "Medium" : "Easy",
    rating: 4.5,
    desc: `${meal.strCategory || ""} · ${meal.strArea || "International"}`,
    ingredients,
    steps,
    image: meal.strMealThumb,
    isTemplate: true,
    source: "themealdb",
  };
}

const SAMPLE_RECIPES = [
  { id: 1, name: "Spaghetti Carbonara", cuisine: "Italian", prep: 10, cook: 20, servings: 4, difficulty: "Medium", rating: 4.7, desc: "Classic Roman pasta with eggs, cheese, and pancetta", ingredients: ["400g spaghetti", "200g pancetta", "4 egg yolks", "100g Pecorino Romano", "Black pepper"], steps: ["Boil pasta in salted water", "Crisp pancetta in a pan", "Whisk yolks with cheese and pepper", "Toss hot pasta with pancetta", "Remove from heat, add egg mixture", "Serve immediately with extra cheese"] },
  { id: 2, name: "Chicken Stir Fry", cuisine: "Asian", prep: 15, cook: 10, servings: 3, difficulty: "Easy", rating: 4.3, desc: "Quick weeknight stir fry with crisp vegetables", ingredients: ["500g chicken breast", "2 bell peppers", "1 broccoli head", "3 tbsp soy sauce", "1 tbsp sesame oil", "2 cloves garlic", "Rice"], steps: ["Slice chicken and vegetables", "Heat sesame oil in wok", "Cook chicken until golden", "Add vegetables and garlic", "Pour in soy sauce", "Serve over steamed rice"] },
  { id: 3, name: "Fish Tacos", cuisine: "Mexican", prep: 15, cook: 10, servings: 4, difficulty: "Easy", rating: 4.5, desc: "Baja-style fish tacos with slaw and lime crema", ingredients: ["500g white fish", "8 corn tortillas", "2 cups cabbage slaw", "Lime crema", "Avocado", "Cilantro", "Chili powder"], steps: ["Season fish with chili powder and salt", "Pan-sear fish until flaky", "Warm tortillas", "Assemble with slaw and fish", "Top with crema and avocado", "Garnish with cilantro and lime"] },
  { id: 4, name: "Greek Salad", cuisine: "Mediterranean", prep: 15, cook: 0, servings: 2, difficulty: "Easy", rating: 4.2, desc: "Fresh and vibrant traditional Greek salad", ingredients: ["3 tomatoes", "1 cucumber", "1 red onion", "200g feta cheese", "Kalamata olives", "Olive oil", "Oregano"], steps: ["Chop tomatoes and cucumber", "Slice red onion thinly", "Combine in a bowl", "Add olives and feta", "Drizzle with olive oil", "Season with oregano and salt"] },
  { id: 5, name: "Classic Burger", cuisine: "American", prep: 10, cook: 12, servings: 4, difficulty: "Easy", rating: 4.6, desc: "Juicy smash burgers with all the fixings", ingredients: ["600g ground beef", "4 brioche buns", "4 slices cheddar", "Lettuce", "Tomato", "Pickles", "Special sauce"], steps: ["Form beef into 4 balls", "Smash on hot griddle", "Season with salt and pepper", "Add cheese to melt", "Toast buns on griddle", "Assemble with toppings"] },
  { id: 6, name: "Pad Thai", cuisine: "Asian", prep: 20, cook: 10, servings: 3, difficulty: "Medium", rating: 4.8, desc: "Authentic Thai rice noodles with tamarind sauce", ingredients: ["250g rice noodles", "200g shrimp", "2 eggs", "Bean sprouts", "Tamarind paste", "Fish sauce", "Peanuts", "Lime"], steps: ["Soak noodles in warm water", "Make tamarind sauce", "Stir-fry shrimp until pink", "Push aside, scramble eggs", "Add noodles and sauce", "Toss with sprouts, serve with peanuts and lime"] },
  { id: 7, name: "Margherita Pizza", cuisine: "Italian", prep: 90, cook: 12, servings: 2, difficulty: "Hard", rating: 4.9, desc: "Neapolitan-style pizza with fresh mozzarella and basil", ingredients: ["300g pizza dough", "San Marzano tomatoes", "Fresh mozzarella", "Fresh basil", "Olive oil", "Salt"], steps: ["Stretch dough into rounds", "Spread crushed tomatoes", "Tear mozzarella over top", "Bake at highest oven temp", "Remove when crust is charred", "Top with fresh basil and olive oil"] },
  { id: 8, name: "Guacamole", cuisine: "Mexican", prep: 10, cook: 0, servings: 4, difficulty: "Easy", rating: 4.4, desc: "Chunky fresh guacamole with lime and cilantro", ingredients: ["3 ripe avocados", "1 lime", "1/2 red onion", "1 jalapeño", "Cilantro", "Salt", "Tomato"], steps: ["Halve and pit avocados", "Mash to desired texture", "Dice onion, jalapeño, tomato", "Mix everything together", "Add lime juice and salt", "Serve with chips"] },
];

const INITIAL_INVENTORY = [
  { id: "i1", name: "Whole Milk", category: "Dairy", location: "Fridge", quantity: 1, unit: "gallon", expiry: "2026-03-20", opened: false, addedBy: "You", addedDate: "2026-03-10" },
  { id: "i2", name: "Chicken Breast", category: "Meat", location: "Fridge", quantity: 2, unit: "lbs", expiry: "2026-03-16", opened: false, addedBy: "You", addedDate: "2026-03-12" },
  { id: "i3", name: "Sourdough Bread", category: "Bakery", location: "Counter", quantity: 1, unit: "loaf", expiry: "2026-03-17", opened: true, addedBy: "You", addedDate: "2026-03-11" },
  { id: "i4", name: "Eggs", category: "Dairy", location: "Fridge", quantity: 8, unit: "count", expiry: "2026-03-28", opened: true, addedBy: "Alex", addedDate: "2026-03-09" },
  { id: "i5", name: "Bananas", category: "Produce", location: "Counter", quantity: 5, unit: "count", expiry: "2026-03-18", opened: false, addedBy: "You", addedDate: "2026-03-13" },
  { id: "i6", name: "Frozen Pizza", category: "Frozen", location: "Freezer", quantity: 2, unit: "count", expiry: "2026-06-01", opened: false, addedBy: "Alex", addedDate: "2026-03-08" },
  { id: "i7", name: "Olive Oil", category: "Condiments", location: "Pantry", quantity: 1, unit: "bottle", expiry: "2027-01-15", opened: true, addedBy: "You", addedDate: "2026-02-20" },
  { id: "i8", name: "Canned Tomatoes", category: "Canned", location: "Pantry", quantity: 3, unit: "cans", expiry: "2027-06-01", opened: false, addedBy: "You", addedDate: "2026-03-05" },
  { id: "i9", name: "Greek Yogurt", category: "Dairy", location: "Fridge", quantity: 1, unit: "tub", expiry: "2026-03-15", opened: true, addedBy: "You", addedDate: "2026-03-10" },
  { id: "i10", name: "Rice", category: "Grains", location: "Pantry", quantity: 2, unit: "lbs", expiry: "2027-03-01", opened: false, addedBy: "Alex", addedDate: "2026-02-15" },
  { id: "i11", name: "Cheddar Cheese", category: "Dairy", location: "Fridge", quantity: 1, unit: "block", expiry: "2026-03-22", opened: true, addedBy: "You", addedDate: "2026-03-07" },
  { id: "i12", name: "Orange Juice", category: "Beverages", location: "Fridge", quantity: 1, unit: "carton", expiry: "2026-03-19", opened: true, addedBy: "You", addedDate: "2026-03-11" },
];

// ─── Utility Functions ───
const uid = () => Math.random().toString(36).slice(2, 10);
const today = new Date();
const daysBetween = (d1: string | Date, d2: string | Date) => Math.ceil((new Date(d2).getTime() - new Date(d1).getTime()) / 86400000);
const fmt = (d: string | Date) => new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric" });

function addDaysISO(days: number) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

// Best-effort shelf-life estimate for scanned items.
function getEstimatedScanExpiry(name: string, category: string) {
  const n = (name || "").toLowerCase();
  const c = (category || "").toLowerCase();
  const text = `${n} ${c}`;

  if (text.includes("milk") || text.includes("yogurt") || text.includes("cream")) return addDaysISO(7);
  if (text.includes("cheese")) return addDaysISO(21);
  if (text.includes("egg")) return addDaysISO(21);
  if (text.includes("bread") || text.includes("bakery") || text.includes("bagel") || text.includes("tortilla")) return addDaysISO(6);
  if (text.includes("banana") || text.includes("berry") || text.includes("produce") || text.includes("fruit") || text.includes("vegetable")) return addDaysISO(5);
  if (text.includes("meat") || text.includes("chicken") || text.includes("beef") || text.includes("fish")) return addDaysISO(3);
  if (text.includes("frozen")) return addDaysISO(120);
  if (text.includes("canned")) return addDaysISO(365);
  if (text.includes("grain") || text.includes("rice") || text.includes("pasta") || text.includes("flour")) return addDaysISO(180);
  if (text.includes("snack") || text.includes("cracker") || text.includes("chips")) return addDaysISO(90);
  if (text.includes("beverage") || text.includes("juice") || text.includes("soda")) return addDaysISO(30);
  if (text.includes("condiment") || text.includes("sauce") || text.includes("ketchup")) return addDaysISO(120);

  return addDaysISO(30);
}

function getExpiryStatus(expiry: string) {
  const days = daysBetween(today, expiry);
  if (days < 0) return { label: "Expired", color: "#dc2626", bg: "#fef2f2" };
  if (days <= 3) return { label: `${days}d left`, color: "#ea580c", bg: "#fff7ed" };
  if (days <= 7) return { label: `${days}d left`, color: "#ca8a04", bg: "#fefce8" };
  return { label: `${days}d`, color: "#16a34a", bg: "#f0fdf4" };
}

// ─── Storage Hook ───
function useStore(key, initial) {
  const [data, setData] = useState(initial);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await window.storage.get(key);
        if (r?.value) setData(JSON.parse(r.value));
      } catch {}
      setLoaded(true);
    })();
  }, [key]);

  const save = useCallback(async (val) => {
    const next = typeof val === "function" ? val(data) : val;
    setData(next);
    try { await window.storage.set(key, JSON.stringify(next)); } catch {}
    return next;
  }, [key, data]);

  return [data, save, loaded];
}

// ─── Modal Component ───
function Modal({ open, onClose, title, children, wide }: { open: boolean; onClose: () => void; title: string; children: React.ReactNode; wide?: boolean }) {
  if (!open) return null;
  const mobile = typeof window !== "undefined" && window.innerWidth < 768;
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 1000, display: "flex", alignItems: (mobile ? "flex-end" : "center") as "center" | "flex-end", justifyContent: "center", background: "rgba(0,0,0,0.4)", backdropFilter: "blur(4px)" }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: mobile ? "20px 20px 0 0" : 16, padding: mobile ? "24px 20px" : 28, width: mobile ? "100%" : (wide ? 600 : 440), maxWidth: mobile ? "100%" : "92vw", maxHeight: mobile ? "90vh" : "85vh", overflow: "auto", boxShadow: "0 25px 50px rgba(0,0,0,0.15)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#1a1a1a", margin: 0 }}>{title}</h2>
          <button onClick={onClose} style={{ background: "#f3f4f6", border: "none", borderRadius: 8, width: 32, height: 32, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><Icons.X style={{ width: 16, height: 16 }} /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

// ─── Form Styles ───
const inputStyle = { width: "100%", padding: "10px 14px", border: "2px solid #e5e7eb", borderRadius: 10, fontSize: 14, outline: "none", transition: "border-color 0.2s", boxSizing: "border-box", fontFamily: "inherit" };
const selectStyle = { ...inputStyle, background: "#fff", appearance: "auto" };
const btnPrimary = { background: "#2d5a27", color: "#fff", border: "none", borderRadius: 10, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", transition: "all 0.2s" };
const btnSecondary = { ...btnPrimary, background: "#f3f4f6", color: "#374151" };
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 6, display: "block" };

// ─── Mobile Detection Hook ───
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth < breakpoint : false);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return isMobile;
}

// ─── MAIN APP ───
type SupabasePageProps = {
  inventory: unknown[];
  shopList: unknown[];
  alerts: unknown[];
  wasteLog: unknown[];
  settings: Record<string, string>;
  activeHousehold?: Record<string, unknown> | null;
  householdList?: Array<{ household: Record<string, unknown>; role?: string; joined_at?: string }>;
  switchHousehold?: (id: string) => void;
  createHousehold?: (name: string) => Promise<Record<string, unknown>>;
  joinHousehold?: (inviteCode: string) => Promise<{ id: string }>;
  deleteHousehold?: (id: string) => Promise<void>;
  removeMember?: (householdId: string, userId: string) => Promise<void>;
  currentUserId?: string;
  apiError?: string | null;
  apiRetry?: () => void;
  addItem: (item: Record<string, unknown>) => Promise<unknown>;
  updateItem: (id: string, updates: Record<string, unknown>) => Promise<unknown>;
  removeItem: (id: string, opts?: { logWaste?: boolean; reason?: string }) => Promise<void>;
  addShopItem: (item: Record<string, unknown>) => Promise<unknown>;
  toggleCheck: (id: string) => Promise<unknown>;
  removeShopItem: (id: string) => Promise<void>;
  clearChecked: () => Promise<void>;
  autoGenerateShop: () => Promise<unknown[]>;
  resolveAlert: (id: string) => Promise<void>;
  removeAlert: (id: string) => Promise<void>;
  logWaste: (entry: Record<string, unknown>) => Promise<unknown>;
  onSignOut?: () => Promise<void>;
  logScanResult?: (result: { barcode: string; name: string; category: string; confidence: number }) => Promise<void>;
  scanHistoryList?: Array<{ product_name: string | null; barcode: string | null; created_at: string }>;
  reviewExpiryBeforeAdd?: boolean;
  setReviewExpiryBeforeAdd?: (value: boolean) => void;
  userRecipes?: unknown[];
  setUserRecipes?: (updater: unknown) => void;
  mealPlan?: Record<string, unknown>;
  setMealPlan?: (updater: unknown) => void;
  circles?: unknown[];
  circlesLoading?: boolean;
  onCreateCircle?: (name: string, desc: string) => Promise<unknown>;
  onJoinCircle?: (code: string) => Promise<unknown>;
  onLeaveCircle?: (circleId: string) => Promise<void>;
  onUpdateSharing?: (circleId: string, enabled: boolean, cats?: string[] | null) => Promise<void>;
  itemRequests?: unknown[];
  onCreateRequest?: (req: unknown) => Promise<unknown>;
  onUpdateRequestStatus?: (id: string, status: string) => Promise<void>;
  userPlan?: string;
};

export default function Ingrediable(props: { supabasePageProps?: SupabasePageProps; initialPage?: string; initialJoinCode?: string } = {}) {
  const supabase = props.supabasePageProps;
  const [page, setPage] = useState(() => {
    if (props.initialPage) return props.initialPage;
    try { return localStorage.getItem("sm-last-page") ?? "dashboard"; } catch { return "dashboard"; }
  });
  const [inventoryLocal, setInventoryLocal, invLoaded] = useStore("sm-inventory", INITIAL_INVENTORY);
  const [shopListLocal, setShopListLocal] = useStore("sm-shoplist", []);
  const [alertsLocal, setAlertsLocal] = useStore("sm-alerts", []);
  const [wasteLogLocal, setWasteLogLocal] = useStore("sm-waste", []);
  const [settingsLocal, setSettingsLocal] = useStore("sm-settings", { measurement: "US", massUnit: "lbs", volumeUnit: "cups", household: "My Kitchen", userName: "You" });
  const [scanPrefs, setScanPrefs] = useStore("sm-scan-prefs", { reviewExpiryBeforeAdd: true });
  const [userRecipesLocal, setUserRecipesLocal] = useStore("sm-recipes", []);
  const [mealPlanLocal, setMealPlanLocal] = useStore("sm-mealplan", {});
  const [tutorialStep, setTutorialStep] = useState<number | null>(null);
  const [sideOpen, setSideOpen] = useState(true);
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (props.initialPage && props.initialPage !== page) setPage(props.initialPage);
  }, [props.initialPage]);

  // Persist current page across refreshes & track page view
  useEffect(() => {
    try { localStorage.setItem("sm-last-page", page); } catch {}
    analytics.page(page);
  }, [page]);

  useEffect(() => {
    try {
      if (!localStorage.getItem("sm-tutorial-seen")) setTutorialStep(0);
    } catch {}
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  const inventory = supabase ? supabase.inventory : inventoryLocal;
  const shopList = supabase ? supabase.shopList : shopListLocal;
  const alerts = supabase ? supabase.alerts : alertsLocal;
  const wasteLog = supabase ? supabase.wasteLog : wasteLogLocal;
  const settings = supabase ? supabase.settings : settingsLocal;
  const setInventory = supabase ? (() => {}) : setInventoryLocal;
  const setShopList = supabase ? (() => {}) : setShopListLocal;
  const setAlerts = supabase ? (() => {}) : setAlertsLocal;
  const setWasteLog = supabase ? (() => {}) : setWasteLogLocal;
  const setSettings = supabase ? (() => {}) : setSettingsLocal;

  // Generate alerts from inventory (local mode only)
  useEffect(() => {
    if (supabase || !invLoaded) return;
    const newAlerts = [];
    inventoryLocal.forEach(item => {
      const days = daysBetween(today, item.expiry);
      if (days < 0) newAlerts.push({ id: uid(), itemId: item.id, type: "expired", message: `${item.name} has expired`, severity: "critical", date: today.toISOString().slice(0, 10), resolved: false });
      else if (days <= 3) newAlerts.push({ id: uid(), itemId: item.id, type: "expiring", message: `${item.name} expires in ${days} day${days !== 1 ? "s" : ""}`, severity: "high", date: today.toISOString().slice(0, 10), resolved: false });
      if (item.quantity <= 1) newAlerts.push({ id: uid(), itemId: item.id, type: "low_stock", message: `${item.name} is running low`, severity: "medium", date: today.toISOString().slice(0, 10), resolved: false });
    });
    setAlertsLocal(newAlerts);
  }, [supabase, invLoaded, inventoryLocal]);

  const unreadAlerts = alerts.filter(a => !a.resolved).length;

  const pageProps = {
    inventory,
    setInventory,
    shopList,
    setShopList,
    alerts,
    setAlerts,
    wasteLog,
    setWasteLog,
    settings,
    setSettings,
    reviewExpiryBeforeAdd: scanPrefs?.reviewExpiryBeforeAdd !== false,
    setReviewExpiryBeforeAdd: (value: boolean) => setScanPrefs((prev) => ({ ...(prev || {}), reviewExpiryBeforeAdd: value })),
    userRecipes: supabase?.userRecipes ?? userRecipesLocal,
    setUserRecipes: supabase?.setUserRecipes ?? setUserRecipesLocal,
    mealPlan: supabase?.mealPlan ?? mealPlanLocal,
    setMealPlan: supabase?.setMealPlan ?? setMealPlanLocal,
    setPage,
    isMobile,
    userPlan: (supabase?.userPlan as PlanKey) || "free",
    initialJoinCode: props.initialJoinCode,
    ...(supabase && {
      activeHousehold: supabase.activeHousehold,
      householdList: supabase.householdList,
      switchHousehold: supabase.switchHousehold,
      createHousehold: supabase.createHousehold,
      joinHousehold: supabase.joinHousehold,
      deleteHousehold: supabase.deleteHousehold,
      removeMember: supabase.removeMember,
      currentUserId: supabase.currentUserId,
      onSignOut: supabase.onSignOut,
      addItem: supabase.addItem,
      updateItem: supabase.updateItem,
      removeItem: supabase.removeItem,
      addShopItem: supabase.addShopItem,
      toggleCheck: supabase.toggleCheck,
      removeShopItem: supabase.removeShopItem,
      clearChecked: supabase.clearChecked,
      autoGenerateShop: supabase.autoGenerateShop,
      resolveAlert: supabase.resolveAlert,
      removeAlert: supabase.removeAlert,
      logWaste: supabase.logWaste,
      logScanResult: supabase.logScanResult,
      scanHistoryList: supabase.scanHistoryList,
      circles: supabase.circles,
      circlesLoading: supabase.circlesLoading,
      onCreateCircle: supabase.onCreateCircle,
      onJoinCircle: supabase.onJoinCircle,
      onLeaveCircle: supabase.onLeaveCircle,
      onUpdateSharing: supabase.onUpdateSharing,
      itemRequests: supabase.itemRequests,
      requests: supabase.itemRequests,
      onCreateRequest: supabase.onCreateRequest,
      onUpdateRequestStatus: supabase.onUpdateRequestStatus,
      onUpdateStatus: supabase.onUpdateRequestStatus,
    }),
  };

  const navItems = [
    { id: "dashboard", label: "Dashboard", icon: Icons.Home },
    { id: "inventory", label: "Inventory", icon: Icons.Box },
    { id: "scan", label: "Scan", icon: Icons.Scan },
    { id: "shopping", label: "Shopping", icon: Icons.Cart },
    { id: "recipes", label: "Recipes", icon: Icons.Book },
    { id: "planner", label: "Planner", icon: Icons.Calendar },
    { id: "waste", label: "Waste", icon: Icons.Chart },
    { id: "alerts", label: "Alerts", icon: Icons.Bell, badge: unreadAlerts },
    { id: "circles", label: "Circles", icon: Icons.Share },
    { id: "household", label: "Household", icon: Icons.Users },
    { id: "settings", label: "Settings", icon: Icons.Settings },
  ];

  // Mobile: show only key nav items in bottom bar
  const mobileNavItems = [
    { id: "dashboard", label: "Home", icon: Icons.Home },
    { id: "inventory", label: "Inventory", icon: Icons.Box },
    { id: "scan", label: "Scan", icon: Icons.Scan },
    { id: "recipes", label: "Recipes", icon: Icons.Book },
    { id: "planner", label: "Planner", icon: Icons.Calendar },
  ];

  // Mobile more menu
  const [moreOpen, setMoreOpen] = useState(false);
  const moreItems = navItems.filter(n => !mobileNavItems.some(m => m.id === n.id));
  const mainRef = useRef<HTMLElement>(null);

  // Scroll main content area back to top whenever the active tab changes
  useEffect(() => {
    if (mainRef.current) mainRef.current.scrollTop = 0;
  }, [page]);

  // PWA install prompt
  const [pwaReady, setPwaReady] = useState(false);
  const [pwaDismissed, setPwaDismissed] = useState(() => { try { return !!localStorage.getItem("sm-pwa-dismissed"); } catch { return false; } });
  useEffect(() => {
    const handler = () => setPwaReady(true);
    window.addEventListener("pwa-install-available", handler);
    if ((window as any).__pwaInstallPrompt) setPwaReady(true);
    return () => window.removeEventListener("pwa-install-available", handler);
  }, []);
  const showPwaBanner = pwaReady && !pwaDismissed && isMobile;
  function triggerPwaInstall() {
    const prompt = (window as any).__pwaInstallPrompt;
    if (prompt) { prompt.prompt(); prompt.userChoice.then(() => { setPwaReady(false); }); }
  }
  function dismissPwa() {
    try { localStorage.setItem("sm-pwa-dismissed", "1"); } catch {}
    setPwaDismissed(true);
  }

  return (
    <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", height: "100%", fontFamily: "'DM Sans', 'Segoe UI', system-ui, sans-serif", background: "#f8f7f4", color: "#1a1a1a", overflow: "hidden", paddingTop: isMobile ? "env(safe-area-inset-top, 0px)" : 0, paddingLeft: "env(safe-area-inset-left, 0px)", paddingRight: "env(safe-area-inset-right, 0px)", boxSizing: "border-box" }}>
      {/* Accessibility: skip to main content link */}
      <a href="#main-content" style={{ position: "absolute", left: "-9999px", top: "auto", width: "1px", height: "1px", overflow: "hidden", zIndex: 9999 }} onFocus={(e) => { e.currentTarget.style.position = "fixed"; e.currentTarget.style.left = "16px"; e.currentTarget.style.top = "16px"; e.currentTarget.style.width = "auto"; e.currentTarget.style.height = "auto"; e.currentTarget.style.padding = "12px 20px"; e.currentTarget.style.background = "#2d5a27"; e.currentTarget.style.color = "#fff"; e.currentTarget.style.borderRadius = "10px"; e.currentTarget.style.fontWeight = "700"; e.currentTarget.style.fontSize = "14px"; e.currentTarget.style.textDecoration = "none"; }} onBlur={(e) => { e.currentTarget.style.position = "absolute"; e.currentTarget.style.left = "-9999px"; e.currentTarget.style.width = "1px"; e.currentTarget.style.height = "1px"; }}>Skip to main content</a>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&family=DM+Serif+Display&display=swap" rel="stylesheet" />
      
      {/* Desktop Sidebar */}
      {!isMobile && (
        <nav aria-label="Main navigation" style={{ width: sideOpen ? 220 : 64, background: "#1a1f16", color: "#fff", display: "flex", flexDirection: "column", transition: "width 0.3s cubic-bezier(0.4,0,0.2,1)", overflow: "hidden", flexShrink: 0 }}>
          <div style={{ padding: sideOpen ? "24px 20px" : "24px 12px", borderBottom: "1px solid rgba(255,255,255,0.08)", display: "flex", alignItems: "center", gap: 12, cursor: "pointer", minHeight: 72 }} onClick={() => setSideOpen(!sideOpen)}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: "linear-gradient(135deg, #4ade80, #2d5a27)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icons.Leaf style={{ width: 20, height: 20, color: "#fff" }} />
            </div>
            {sideOpen && <div><div style={{ fontSize: 17, fontWeight: 700, fontFamily: "'DM Serif Display', serif", letterSpacing: "-0.01em" }}>Ingrediable</div><div style={{ fontSize: 11, opacity: 0.5, marginTop: 1 }}>{settings.household}</div></div>}
          </div>
          <div style={{ flex: 1, padding: "12px 8px", display: "flex", flexDirection: "column", gap: 2 }}>
            {navItems.map(n => (
              <button key={n.id} onClick={() => setPage(n.id)} style={{ display: "flex", alignItems: "center", gap: 12, padding: sideOpen ? "10px 12px" : "10px 14px", borderRadius: 10, border: "none", background: page === n.id ? "rgba(74,222,128,0.15)" : "transparent", color: page === n.id ? "#4ade80" : "rgba(255,255,255,0.6)", cursor: "pointer", fontSize: 14, fontWeight: page === n.id ? 600 : 400, fontFamily: "inherit", transition: "all 0.2s", position: "relative", justifyContent: sideOpen ? "flex-start" : "center" }}>
                <n.icon style={{ width: 20, height: 20, flexShrink: 0 }} />
                {sideOpen && <span>{n.label}</span>}
                {n.badge > 0 && <span style={{ position: "absolute", top: 4, right: sideOpen ? 8 : 2, background: "#ef4444", color: "#fff", fontSize: 10, fontWeight: 700, borderRadius: 10, padding: "1px 6px", minWidth: 18, textAlign: "center" }}>{n.badge}</span>}
              </button>
            ))}
          </div>
        </nav>
      )}

      {/* Main Content */}
      <main id="main-content" ref={mainRef} role="main" aria-label="Main content" style={{ flex: 1, overflow: "auto", padding: isMobile ? "16px 16px 80px" : 32 }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          {supabase && supabase.apiError && (
            <div style={{ marginBottom: 16, padding: "12px 16px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 12, color: "#dc2626", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
              <span>Something went wrong. Check your connection and try again.</span>
              <button type="button" onClick={supabase.apiRetry} style={{ ...btnPrimary, background: "#dc2626", padding: "8px 16px", fontSize: 13 }}>Retry</button>
            </div>
          )}
          {!online && (
            <div style={{ marginBottom: 16, padding: "10px 16px", background: "#fef3c7", border: "1px solid #fcd34d", borderRadius: 12, color: "#92400e", fontSize: 14 }}>
              You&apos;re offline. Changes may not sync until you&apos;re back online.
            </div>
          )}
          {showPwaBanner && (
            <div style={{ marginBottom: 16, padding: "12px 16px", background: "linear-gradient(135deg, #f0fdf4, #dcfce7)", border: "1px solid #86efac", borderRadius: 14, display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: "linear-gradient(135deg, #4ade80, #2d5a27)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icons.Leaf style={{ width: 18, height: 18, color: "#fff" }} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1f16" }}>Add Ingrediable to your home screen</div>
                <div style={{ fontSize: 12, color: "#4b7a40", marginTop: 1 }}>Works offline · Feels like a native app</div>
              </div>
              <button onClick={triggerPwaInstall} style={{ background: "#2d5a27", color: "#fff", border: "none", borderRadius: 10, padding: "8px 14px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", flexShrink: 0 }}>Install</button>
              <button onClick={dismissPwa} style={{ background: "none", border: "none", cursor: "pointer", padding: 4, flexShrink: 0, color: "#6b7280" }}><Icons.X style={{ width: 16, height: 16 }} /></button>
            </div>
          )}
          {page === "dashboard" && <Dashboard {...pageProps} />}
          {page === "inventory" && <Inventory {...pageProps} />}
          {page === "scan" && <ScanPage {...pageProps} />}
          {page === "shopping" && <Shopping {...pageProps} />}
          {page === "recipes" && <Recipes {...pageProps} />}
          {page === "planner" && (
            canAccess((pageProps.userPlan || "free") as PlanKey, "mealPlanner")
              ? <PlannerPage {...pageProps} />
              : <UpgradeGate feature="Meal Planner" description="Plan your meals for the week, schedule recipes, and automatically generate shopping lists. Upgrade to Pro to unlock the full meal planner." onUpgrade={() => setPage("pricing")} isMobile={isMobile} />
          )}
          {page === "waste" && (
            canAccess((pageProps.userPlan || "free") as PlanKey, "wasteAnalytics")
              ? <WastePage {...pageProps} />
              : <UpgradeGate feature="Waste Analytics" description="Track how much food and money you're wasting, see trends over time, and get actionable insights. Upgrade to Pro to unlock waste analytics." onUpgrade={() => setPage("pricing")} isMobile={isMobile} />
          )}
          {page === "alerts" && <AlertsPage {...pageProps} />}
          {page === "circles" && (
            canAccess((pageProps.userPlan || "free") as PlanKey, "circles")
              ? <CirclesPage {...pageProps} />
              : <UpgradeGate feature="Circles" description="Share surplus food with trusted neighbors, request items, and reduce waste together. Upgrade to Pro to unlock Circles." onUpgrade={() => setPage("pricing")} isMobile={isMobile} />
          )}
          {page === "household" && <HouseholdPage {...pageProps} />}
          {page === "settings" && <SettingsPage {...pageProps} />}
          {page === "pricing" && <PricingPage currentPlan={(supabase?.userPlan as PlanKey) || "free"} userId={supabase?.currentUserId as string} isMobile={isMobile} onClose={() => setPage("settings")} />}
          {page === "privacy" && <PrivacyPolicy onBack={() => setPage("settings")} />}
          {page === "terms" && <TermsOfService onBack={() => setPage("settings")} />}
        </div>
      </main>

      {/* Mobile Bottom Nav */}
      {isMobile && (
        <>
          <nav style={{
            position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 100,
            background: "#1a1f16", display: "flex", justifyContent: "space-around",
            padding: "8px 0 env(safe-area-inset-bottom, 8px)", borderTop: "1px solid rgba(255,255,255,0.08)",
          }}>
            {mobileNavItems.map(n => (
              <button key={n.id} onClick={() => { setPage(n.id); setMoreOpen(false); }} style={{
                display: "flex", flexDirection: "column", alignItems: "center", gap: 2,
                background: "none", border: "none", cursor: "pointer", fontFamily: "inherit",
                color: page === n.id ? "#4ade80" : "rgba(255,255,255,0.5)",
                fontSize: 10, fontWeight: page === n.id ? 700 : 400, padding: "4px 8px",
                position: "relative", transition: "color 0.2s",
              }}>
                <n.icon style={{ width: 22, height: 22 }} />
                {n.label}
                {n.badge > 0 && <span style={{ position: "absolute", top: 0, right: 2, background: "#ef4444", color: "#fff", fontSize: 9, fontWeight: 700, borderRadius: 8, padding: "0 4px", minWidth: 14, textAlign: "center" }}>{n.badge}</span>}
              </button>
            ))}
            <button onClick={() => setMoreOpen(!moreOpen)} style={{
              display: "flex", flexDirection: "column", alignItems: "center", gap: 2,
              background: "none", border: "none", cursor: "pointer", fontFamily: "inherit",
              color: moreOpen || moreItems.some(n => n.id === page) ? "#4ade80" : "rgba(255,255,255,0.5)",
              fontSize: 10, fontWeight: 400, padding: "4px 8px",
            }}>
              <Icons.Settings style={{ width: 22, height: 22 }} />
              More
            </button>
          </nav>

          {/* More menu overlay */}
          {moreOpen && (
            <div style={{ position: "fixed", inset: 0, zIndex: 99, background: "rgba(0,0,0,0.4)" }} onClick={() => setMoreOpen(false)}>
              <div onClick={e => e.stopPropagation()} style={{
                position: "absolute",
                bottom: "calc(58px + env(safe-area-inset-bottom, 0px))",
                left: 8, right: 8,
                background: "#fff", borderRadius: 16, padding: 8,
                boxShadow: "0 -8px 30px rgba(0,0,0,0.15)",
                maxHeight: "55vh", overflowY: "auto",
              }}>
                {moreItems.map(n => (
                  <button key={n.id} onClick={() => { setPage(n.id); setMoreOpen(false); }} style={{
                    display: "flex", alignItems: "center", gap: 12, width: "100%",
                    padding: "12px 16px", borderRadius: 10, border: "none",
                    background: page === n.id ? "#f0fdf4" : "transparent",
                    color: page === n.id ? "#2d5a27" : "#374151",
                    cursor: "pointer", fontSize: 14, fontWeight: page === n.id ? 600 : 400,
                    fontFamily: "inherit", textAlign: "left",
                  }}>
                    <n.icon style={{ width: 20, height: 20 }} />
                    {n.label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </>
      )}

      {/* Tutorial Overlay */}
      {tutorialStep !== null && (() => {
        const steps = [
          { icon: Icons.Leaf, title: "Welcome to Ingrediable!", body: "Your smart kitchen companion. Track what's in your fridge, reduce waste, and plan meals — all in one place. It takes about 3 minutes to get set up." },
          { icon: Icons.Scan, title: "Scan to add items", body: "Use the Scan tab to scan any barcode. We'll look up the product automatically and add it to your inventory — including an estimated expiry date." },
          { icon: Icons.Box, title: "Track your inventory", body: "See everything in your fridge, freezer, and pantry at a glance. Get alerts before food expires so nothing goes to waste." },
          { icon: Icons.Bell, title: "Alerts keep you ahead", body: "Ingrediable watches your inventory for you. Get notified when items are expiring soon, running low, or out of stock — before it's too late." },
          { icon: Icons.Cart, title: "Smart shopping lists", body: "Your shopping list auto-generates from low stock and expired items. Check things off as you shop, or export the whole list in one tap." },
          { icon: Icons.Book, title: "Recipes & meal planning", body: "Browse recipes and see exactly what you have vs. what you need. Schedule meals for the week — cooking a recipe automatically deducts the ingredients." },
          { icon: Icons.Chart, title: "See what you're wasting", body: "The Waste tab shows how much food (and money) you're throwing away and why. Most households save over $1,500 a year once they start tracking." },
          { icon: Icons.Share, title: "Circles — share with neighbors", body: "Create a Circle with trusted households to share surplus food. Request items from neighbors, chat in real time, and reduce waste together." },
          { icon: Icons.Users, title: "Invite your household", body: "Head to the Household tab to invite family or roommates. Everyone sees the same inventory in real time — no more buying duplicates or missing what's already there." },
        ];
        const step = steps[tutorialStep];
        const isLast = tutorialStep === steps.length - 1;
        const finish = () => {
          try { localStorage.setItem("sm-tutorial-seen", "1"); } catch {}
          setTutorialStep(null);
        };
        return (
          <div style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
            <div style={{ background: "#fff", borderRadius: 20, padding: 32, maxWidth: 380, width: "100%", textAlign: "center", boxShadow: "0 24px 60px rgba(0,0,0,0.25)" }}>
              <div style={{ width: 64, height: 64, borderRadius: 20, background: "linear-gradient(135deg, #4ade80, #2d5a27)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
                <step.icon style={{ width: 32, height: 32, color: "#fff" }} />
              </div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 6, fontWeight: 500 }}>{tutorialStep + 1} of {steps.length}</div>
              <h2 style={{ fontSize: 22, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 10px", color: "#1a1f16" }}>{step.title}</h2>
              <p style={{ fontSize: 15, color: "#6b7280", margin: "0 0 28px", lineHeight: 1.6 }}>{step.body}</p>
              {/* Progress dots */}
              <div style={{ display: "flex", justifyContent: "center", gap: 6, marginBottom: 24 }}>
                {steps.map((_, i) => <div key={i} style={{ width: i === tutorialStep ? 20 : 8, height: 8, borderRadius: 4, background: i === tutorialStep ? "#2d5a27" : "#e5e7eb", transition: "all 0.3s" }} />)}
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                {tutorialStep > 0
                  ? <button onClick={() => setTutorialStep(tutorialStep - 1)} style={{ flex: 1, padding: "12px", border: "1px solid #e5e7eb", borderRadius: 12, background: "#fff", color: "#6b7280", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>← Back</button>
                  : <button onClick={finish} style={{ flex: 1, padding: "12px", border: "1px solid #e5e7eb", borderRadius: 12, background: "#fff", color: "#6b7280", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>Skip</button>
                }
                <button onClick={() => isLast ? finish() : setTutorialStep(tutorialStep + 1)} style={{ flex: 2, padding: "12px", border: "none", borderRadius: 12, background: "#2d5a27", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>{isLast ? "Let's go! →" : "Next →"}</button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

// ─── Card Component ───
function Card({ children, style, onClick }) {
  return <div onClick={onClick} style={{ background: "#fff", borderRadius: 16, padding: 24, boxShadow: "0 1px 3px rgba(0,0,0,0.04)", border: "1px solid #eee", ...style }}>{children}</div>;
}

// ═══════════════════════════════════════
// DASHBOARD
// ═══════════════════════════════════════
function Dashboard({ inventory, alerts, wasteLog, setPage, isMobile }) {
  const totalItems = inventory.length;
  const expiringSoon = inventory.filter(i => { const d = daysBetween(today, i.expiry); return d >= 0 && d <= 3; }).length;
  const expired = inventory.filter(i => daysBetween(today, i.expiry) < 0).length;
  const lowStock = inventory.filter(i => i.quantity <= 1).length;
  const locations = {};
  inventory.forEach(i => { locations[i.location] = (locations[i.location] || 0) + 1; });

  const stats = [
    { label: "Total Items", value: totalItems, color: "#2d5a27", bg: "#f0fdf4" },
    { label: "Expiring Soon", value: expiringSoon, color: "#ea580c", bg: "#fff7ed" },
    { label: "Expired", value: expired, color: "#dc2626", bg: "#fef2f2" },
    { label: "Low Stock", value: lowStock, color: "#ca8a04", bg: "#fefce8" },
  ];

  const recentItems = [...inventory].sort((a, b) => b.addedDate.localeCompare(a.addedDate)).slice(0, 5);
  const expiringItems = inventory.filter(i => { const d = daysBetween(today, i.expiry); return d >= 0 && d <= 7; }).sort((a, b) => a.expiry.localeCompare(b.expiry)).slice(0, 5);

  return (
    <div>
      <div style={{ marginBottom: isMobile ? 20 : 32 }}>
        <h1 style={{ fontSize: isMobile ? 24 : 32, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: 0, color: "#1a1f16" }}>Good afternoon</h1>
        <p style={{ color: "#6b7280", margin: "6px 0 0", fontSize: isMobile ? 13 : 15 }}>Here's what's happening in your kitchen today.</p>
      </div>

      {/* Stats */}
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(4, 1fr)", gap: isMobile ? 10 : 16, marginBottom: isMobile ? 20 : 28 }}>
        {stats.map(s => (
          <Card key={s.label} style={{ padding: isMobile ? 14 : 20, background: s.bg, border: `1px solid ${s.color}20` }}>
            <div style={{ fontSize: isMobile ? 10 : 12, fontWeight: 600, color: s.color, textTransform: "uppercase", letterSpacing: "0.05em" }}>{s.label}</div>
            <div style={{ fontSize: isMobile ? 28 : 36, fontWeight: 700, color: s.color, fontFamily: "'DM Serif Display', serif", marginTop: 4 }}>{s.value}</div>
          </Card>
        ))}
      </div>

      {/* Quick Actions */}
      <div style={{ display: "flex", gap: isMobile ? 8 : 12, marginBottom: isMobile ? 20 : 28, flexWrap: isMobile ? "wrap" : "nowrap" }}>
        {[{ label: "Add Item", icon: Icons.Plus, page: "inventory" }, { label: "Shopping List", icon: Icons.Cart, page: "shopping" }, { label: "View Recipes", icon: Icons.Book, page: "recipes" }].map(a => (
          <button key={a.label} onClick={() => setPage(a.page)} style={{ ...btnPrimary, display: "flex", alignItems: "center", gap: 6, padding: isMobile ? "10px 14px" : "12px 20px", fontSize: isMobile ? 12 : 14, background: a.page === "inventory" ? "#2d5a27" : "#fff", color: a.page === "inventory" ? "#fff" : "#2d5a27", border: a.page === "inventory" ? "none" : "2px solid #2d5a27", flex: isMobile ? "1 1 45%" : undefined }}>
            <a.icon style={{ width: 16, height: 16 }} />{a.label}
          </button>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: isMobile ? 12 : 20 }}>
        {/* Recent Items */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 16px", color: "#1a1f16" }}>Recently Added</h3>
          {recentItems.map(item => {
            const exp = getExpiryStatus(item.expiry);
            return (
              <div key={item.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "1px solid #f3f4f6" }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{item.name}</div>
                  <div style={{ fontSize: 12, color: "#9ca3af" }}>{item.category} · {item.location}</div>
                </div>
                <span style={{ fontSize: 12, fontWeight: 600, color: exp.color, background: exp.bg, padding: "3px 10px", borderRadius: 20 }}>{exp.label}</span>
              </div>
            );
          })}
        </Card>

        {/* Expiring Soon */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 16px", color: "#1a1f16" }}>Expiring Soon</h3>
          {expiringItems.length === 0 ? <p style={{ color: "#9ca3af", fontSize: 14 }}>Nothing expiring in the next 7 days!</p> :
            expiringItems.map(item => {
              const exp = getExpiryStatus(item.expiry);
              return (
                <div key={item.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "1px solid #f3f4f6" }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{item.name}</div>
                    <div style={{ fontSize: 12, color: "#9ca3af" }}>Expires {fmt(item.expiry)}</div>
                  </div>
                  <span style={{ fontSize: 12, fontWeight: 600, color: exp.color, background: exp.bg, padding: "3px 10px", borderRadius: 20 }}>{exp.label}</span>
                </div>
              );
            })
          }
        </Card>

        {/* Storage Breakdown */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 16px", color: "#1a1f16" }}>Storage Breakdown</h3>
          {Object.entries(locations).sort((a, b) => b[1] - a[1]).map(([loc, count]) => (
            <div key={loc} style={{ marginBottom: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 4 }}>
                <span style={{ fontWeight: 600 }}>{loc}</span>
                <span style={{ color: "#6b7280" }}>{count} items</span>
              </div>
              <div style={{ height: 8, background: "#f3f4f6", borderRadius: 4, overflow: "hidden" }}>
                <div style={{ height: "100%", width: `${(count / totalItems) * 100}%`, background: "linear-gradient(90deg, #2d5a27, #4ade80)", borderRadius: 4, transition: "width 0.5s" }} />
              </div>
            </div>
          ))}
        </Card>

        {/* Active Alerts */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 16px", color: "#1a1f16" }}>Active Alerts</h3>
          {alerts.filter(a => !a.resolved).slice(0, 5).map(a => {
            const sevColors = { critical: "#dc2626", high: "#ea580c", medium: "#ca8a04", low: "#6b7280" };
            return (
              <div key={a.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 0", borderBottom: "1px solid #f3f4f6" }}>
                <div style={{ width: 8, height: 8, borderRadius: 4, background: sevColors[a.severity], flexShrink: 0 }} />
                <div style={{ fontSize: 13 }}>{a.message}</div>
              </div>
            );
          })}
          {alerts.filter(a => !a.resolved).length === 0 && <p style={{ color: "#9ca3af", fontSize: 14 }}>All clear!</p>}
        </Card>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════
// INVENTORY
// ═══════════════════════════════════════
function Inventory({ inventory, setInventory, wasteLog, setWasteLog, shopList, setShopList, addItem, updateItem, removeItem, logWaste, addShopItem, isMobile, userPlan, setPage }) {
  const [search, setSearch] = useState("");
  const [catFilter, setCatFilter] = useState("All");
  const [locFilter, setLocFilter] = useState("All");
  const [sortBy, setSortBy] = useState("name");
  const [modalOpen, setModalOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [formError, setFormError] = useState("");
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [selectMode, setSelectMode] = useState(false);
  const [confirmModal, setConfirmModal] = useState<{ ids: string[], label: string } | null>(null);

  const emptyForm = { name: "", category: "Produce", location: "Fridge", quantity: 1, unit: "count", expiry: "2026-04-01", opened: false };
  const [form, setForm] = useState(emptyForm);

  const filtered = useMemo(() => {
    let items = [...inventory];
    if (search) items = items.filter(i => i.name.toLowerCase().includes(search.toLowerCase()));
    if (catFilter !== "All") items = items.filter(i => i.category === catFilter);
    if (locFilter !== "All") items = items.filter(i => i.location === locFilter);
    items.sort((a, b) => {
      if (sortBy === "name") return a.name.localeCompare(b.name);
      if (sortBy === "expiry") return (a.expiry || "").localeCompare(b.expiry || "");
      if (sortBy === "quantity") return a.quantity - b.quantity;
      if (sortBy === "added") return (b.addedDate || "").localeCompare(a.addedDate || "");
      return 0;
    });
    return items;
  }, [inventory, search, catFilter, locFilter, sortBy]);

  function openAdd() {
    setEditItem(null);
    setForm(emptyForm);
    setFormError("");
    setModalOpen(true);
  }

  function openEdit(item) {
    setEditItem(item);
    setForm({ name: item.name, category: item.category, location: item.location, quantity: item.quantity, unit: item.unit, expiry: item.expiry || "", opened: item.opened });
    setFormError("");
    setModalOpen(true);
  }

  async function saveItem() {
    setFormError("");
    if (!form.name.trim()) {
      setFormError("Please enter an item name.");
      return;
    }
    if (!Number.isFinite(Number(form.quantity)) || Number(form.quantity) <= 0) {
      setFormError("Quantity must be greater than 0.");
      return;
    }
    // Enforce item limit for free-tier users (only on new items, not edits)
    if (!editItem && isAtItemLimit((userPlan || "free") as PlanKey, inventory.length)) {
      setFormError(`You've reached the ${inventory.length}-item limit on the Free plan. Upgrade to Pro for unlimited items.`);
      return;
    }
    try {
      if (addItem && updateItem) {
        if (editItem) {
          await updateItem(editItem.id, form);
        } else {
          const created = await addItem({ ...form, expiry: form.expiry, opened: form.opened });
          if (!created) throw new Error("No active household selected.");
        }
      } else {
        if (editItem) setInventory(prev => prev.map(i => i.id === editItem.id ? { ...i, ...form } : i));
        else setInventory(prev => [...prev, { id: uid(), ...form, addedBy: "You", addedDate: today.toISOString().slice(0, 10) }]);
      }
      setModalOpen(false);
    } catch (err) {
      const message = err instanceof Error ? err.message : "Could not save item. Please try again.";
      setFormError(message);
    }
  }

  async function deleteItem(id: string) {
    const item = inventory.find(i => i.id === id);
    if (removeItem) {
      if (item && logWaste) await logWaste({ name: item.name, category: item.category, reason: "removed", date: today.toISOString().slice(0, 10) });
      await removeItem(id, { logWaste: !!item });
    } else {
      if (item) setWasteLog(prev => [...prev, { id: uid(), name: item.name, category: item.category, reason: "removed", cost: (Math.random() * 5 + 1).toFixed(2), date: today.toISOString().slice(0, 10) }]);
      setInventory(prev => prev.filter(i => i.id !== id));
    }
  }

  function confirmDeleteItem(id: string) {
    const item = inventory.find(i => i.id === id);
    setConfirmModal({ ids: [id], label: item?.name || "this item" });
  }

  function confirmDeleteSelected() {
    setConfirmModal({ ids: [...selected], label: `${selected.size} item${selected.size !== 1 ? "s" : ""}` });
  }

  async function executeDelete() {
    if (!confirmModal) return;
    for (const id of confirmModal.ids) await deleteItem(id);
    setSelected(new Set());
    setConfirmModal(null);
  }

  function toggleSelect(id: string) {
    setSelected(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  }

  function toggleSelectAll() {
    if (selected.size === filtered.length) setSelected(new Set());
    else setSelected(new Set(filtered.map(i => i.id)));
  }

  async function addToShopList(item) {
    if (addShopItem) await addShopItem({ name: item.name, quantity: 1, unit: item.unit, priority: "medium", estCost: (Math.random() * 8 + 2).toFixed(2) });
    else setShopList(prev => [...prev, { id: uid(), name: item.name, quantity: 1, unit: item.unit, priority: "medium", estCost: (Math.random() * 8 + 2).toFixed(2), checked: false }]);
  }

  async function toggleLowStock(item) {
    const next = !item.is_low_stock;
    if (updateItem) await updateItem(item.id, { is_low_stock: next });
    else setInventory(prev => prev.map(i => i.id === item.id ? { ...i, is_low_stock: next } : i));
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <h1 style={{ fontSize: 28, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: 0 }}>Inventory</h1>
          <p style={{ color: "#6b7280", margin: "4px 0 0", fontSize: 14 }}>{inventory.length} items tracked</p>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          {isMobile && (
            <button onClick={() => { setSelectMode(s => !s); setSelected(new Set()); }} style={{ ...btnSecondary, padding: "8px 14px", fontSize: 13, fontWeight: 600, background: selectMode ? "#f0fdf4" : undefined, color: selectMode ? "#2d5a27" : undefined, border: selectMode ? "1px solid #86efac" : undefined }}>Select</button>
          )}
          <button onClick={openAdd} style={{ ...btnPrimary, display: "flex", alignItems: "center", gap: 8 }}><Icons.Plus style={{ width: 16, height: 16 }} />Add Item</button>
        </div>
      </div>

      {inventory.length === 0 ? (
        <Card style={{ padding: 48, textAlign: "center" }}>
          <div style={{ width: 72, height: 72, borderRadius: 20, background: "#f0fdf4", color: "#2d5a27", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <Icons.Box style={{ width: 36, height: 36 }} />
          </div>
          <h2 style={{ fontSize: 22, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 8px", color: "#1a1f16" }}>No items yet</h2>
          <p style={{ fontSize: 15, color: "#6b7280", margin: "0 0 24px", maxWidth: 360, marginLeft: "auto", marginRight: "auto" }}>Add your first item to start tracking your kitchen and get expiry alerts.</p>
          <button onClick={openAdd} style={{ ...btnPrimary, display: "inline-flex", alignItems: "center", gap: 8, padding: "14px 28px", fontSize: 15 }}>
            <Icons.Plus style={{ width: 18, height: 18 }} /> Add your first item
          </button>
        </Card>
      ) : (
        <>
      {/* Filters */}
      <Card style={{ padding: 16, marginBottom: 20 }}>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
          <div style={{ position: "relative", flex: 1, minWidth: 200 }}>
            <Icons.Search style={{ width: 16, height: 16, position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }} />
            <input placeholder="Search items..." value={search} onChange={e => setSearch(e.target.value)} style={{ ...inputStyle, paddingLeft: 36 }} />
          </div>
          <select value={catFilter} onChange={e => setCatFilter(e.target.value)} style={{ ...selectStyle, width: 150 }}>
            <option value="All">All Categories</option>
            {CATEGORIES.map(c => <option key={c}>{c}</option>)}
          </select>
          <select value={locFilter} onChange={e => setLocFilter(e.target.value)} style={{ ...selectStyle, width: 140 }}>
            <option value="All">All Locations</option>
            {LOCATIONS.map(l => <option key={l}>{l}</option>)}
          </select>
          <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ ...selectStyle, width: 140 }}>
            <option value="name">Sort: Name</option>
            <option value="expiry">Sort: Expiry</option>
            <option value="quantity">Sort: Quantity</option>
            <option value="added">Sort: Date Added</option>
          </select>
        </div>
      </Card>

      {/* Select-all bar */}
      {isMobile && selectMode && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", marginBottom: 8, background: selected.size > 0 ? "#f0fdf4" : "#f9fafb", borderRadius: 12, border: `1px solid ${selected.size > 0 ? "#bbf7d0" : "#e5e7eb"}` }}>
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", color: "#1a1f16" }}>
            <input type="checkbox" checked={filtered.length > 0 && selected.size === filtered.length} onChange={toggleSelectAll} style={{ width: 17, height: 17, cursor: "pointer", accentColor: "#2d5a27" }} />
            {selected.size > 0 ? `${selected.size} selected` : "Select all"}
          </label>
          {selected.size > 0 && (
            <button onClick={confirmDeleteSelected} style={{ background: "#dc2626", color: "#fff", border: "none", borderRadius: 8, padding: "6px 14px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
              Delete {selected.size}
            </button>
          )}
        </div>
      )}

      {/* Inventory list/table */}
      <Card style={{ padding: 0, overflow: "hidden" }}>
        {isMobile ? (
          <div style={{ display: "grid", gap: 0, gridTemplateColumns: "1fr" }}>
            {filtered.length === 0 && <div style={{ padding: 40, textAlign: "center", color: "#9ca3af" }}>No items found. Try adjusting your filters.</div>}
            {filtered.map((item) => {
              const exp = getExpiryStatus(item.expiry);
              return (
                <div key={item.id} style={{ padding: "12px 14px", borderBottom: "1px solid #f3f4f6", overflow: "hidden", minWidth: 0, background: selectMode && selected.has(item.id) ? "#f0fdf4" : undefined }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}>
                    {selectMode && <input type="checkbox" checked={selected.has(item.id)} onChange={() => toggleSelect(item.id)} style={{ width: 17, height: 17, flexShrink: 0, cursor: "pointer", accentColor: "#2d5a27" }} />}
                    <div style={{ fontWeight: 700, fontSize: 15, lineHeight: 1.25, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0, flexShrink: 1 }}>
                      {item.name}
                      {item.opened && <span style={{ fontSize: 10, background: "#dbeafe", color: "#2563eb", padding: "2px 6px", borderRadius: 6, marginLeft: 8, fontWeight: 600 }}>OPENED</span>}
                    </div>
                    <button onClick={() => openEdit(item)} style={{ ...btnSecondary, width: 26, height: 26, minWidth: 26, padding: 0, display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }} title="Edit"><Icons.Edit style={{ width: 12, height: 12 }} /></button>
                    <button onClick={() => confirmDeleteItem(item.id)} style={{ background: "#fef2f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 8, width: 26, height: 26, cursor: "pointer", fontFamily: "inherit", display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }} title="Delete"><Icons.Trash style={{ width: 12, height: 12 }} /></button>
                  </div>
                  <div style={{ marginTop: 4, fontSize: 12, color: "#6b7280" }}>
                    {item.category} · {item.location} · {item.addedBy}
                  </div>
                  <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ flex: 1, minWidth: 0, fontSize: 13 }}>
                      <span style={{ fontWeight: 700 }}>{item.quantity}</span>
                      <span style={{ color: "#9ca3af", marginLeft: 4 }}>{item.unit}</span>
                      {(item.quantity <= 1 || item.is_low_stock) && <span style={{ fontSize: 10, background: "#fef2f2", color: "#dc2626", padding: "2px 6px", borderRadius: 6, marginLeft: 6, fontWeight: 600 }}>LOW</span>}
                      <span style={{ marginLeft: 8, fontSize: 11, color: exp.color, fontWeight: 700 }}>Expires in: {exp.label}</span>
                    </div>
                    <button
                      onClick={() => addToShopList(item)}
                      style={{
                        flexShrink: 0,
                        background: "#2d5a27",
                        color: "#fff",
                        border: "none",
                        borderRadius: 8,
                        padding: "6px 10px",
                        height: 30,
                        fontSize: 12,
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 4,
                        cursor: "pointer",
                        fontFamily: "inherit",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span>+</span>
                      <Icons.Cart style={{ width: 13, height: 13 }} />
                      <span>List</span>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
              <thead>
                <tr style={{ background: "#f9fafb", borderBottom: "2px solid #e5e7eb" }}>
                  {["Name", "Category", "Location", "Qty", "Status", "Expiry", "Added By", "Actions"].map(h => (
                    <th key={h} style={{ padding: "12px 16px", textAlign: "left", fontSize: 11, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(item => {
                  const exp = getExpiryStatus(item.expiry);
                  return (
                    <tr key={item.id} style={{ borderBottom: "1px solid #f3f4f6", transition: "background 0.15s" }} onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"} onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <td style={{ padding: "14px 16px", fontWeight: 600 }}>
                        {item.name}
                        {item.opened && <span style={{ fontSize: 10, background: "#dbeafe", color: "#2563eb", padding: "2px 6px", borderRadius: 6, marginLeft: 8, fontWeight: 600 }}>OPENED</span>}
                      </td>
                      <td style={{ padding: "14px 16px", color: "#6b7280" }}>{item.category}</td>
                      <td style={{ padding: "14px 16px", color: "#6b7280" }}>{item.location}</td>
                      <td style={{ padding: "14px 16px" }}>
                        <span style={{ fontWeight: 700 }}>{item.quantity}</span>
                        <span style={{ color: "#9ca3af", marginLeft: 4, fontSize: 12 }}>{item.unit}</span>
                        {(item.quantity <= 1 || item.is_low_stock) && <span style={{ fontSize: 10, background: "#fef2f2", color: "#dc2626", padding: "2px 6px", borderRadius: 6, marginLeft: 6, fontWeight: 600 }}>LOW</span>}
                      </td>
                      <td style={{ padding: "14px 16px" }}>
                        <span style={{ fontSize: 12, fontWeight: 600, color: exp.color, background: exp.bg, padding: "3px 10px", borderRadius: 20 }}>{exp.label}</span>
                      </td>
                      <td style={{ padding: "14px 16px", color: "#6b7280", fontSize: 13 }}>{fmt(item.expiry)}</td>
                      <td style={{ padding: "14px 16px", color: "#6b7280", fontSize: 13 }}>{item.addedBy}</td>
                      <td style={{ padding: "14px 16px" }}>
                        <div style={{ display: "flex", gap: 6 }}>
                          <button onClick={() => openEdit(item)} style={{ background: "#f3f4f6", border: "none", borderRadius: 6, width: 30, height: 30, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }} title="Edit"><Icons.Edit style={{ width: 14, height: 14, color: "#6b7280" }} /></button>
                          <button onClick={() => addToShopList(item)} style={{ background: "#f0fdf4", border: "none", borderRadius: 6, minWidth: 38, height: 30, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", padding: "0 6px" }} title="Add to shopping list"><span style={{ position: "relative", display: "inline-flex", width: 16, height: 16, alignItems: "center", justifyContent: "center" }}><Icons.Cart style={{ width: 14, height: 14, color: "#2d5a27" }} /><span style={{ position: "absolute", right: -5, top: -5, fontSize: 10, fontWeight: 700, color: "#2d5a27", lineHeight: 1 }}>+</span></span></button>
                          <button onClick={() => confirmDeleteItem(item.id)} style={{ background: "#fef2f2", border: "none", borderRadius: 6, width: 30, height: 30, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }} title="Delete"><Icons.Trash style={{ width: 14, height: 14, color: "#dc2626" }} /></button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {filtered.length === 0 && <div style={{ padding: 40, textAlign: "center", color: "#9ca3af" }}>No items found. Try adjusting your filters.</div>}
          </div>
        )}
      </Card>
        </>
      )}

      {/* Add/Edit Modal */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)} title={editItem ? "Edit Item" : "Add Item"}>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: isMobile ? 12 : 16 }}>
          <div style={{ gridColumn: "span 2" }}>
            <label style={labelStyle}>Name</label>
            <input style={inputStyle} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="e.g. Whole Milk" />
          </div>
          <div>
            <label style={labelStyle}>Category</label>
            <select style={selectStyle} value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))}>{CATEGORIES.map(c => <option key={c}>{c}</option>)}</select>
          </div>
          <div>
            <label style={labelStyle}>Location</label>
            <select style={selectStyle} value={form.location} onChange={e => setForm(f => ({ ...f, location: e.target.value }))}>{LOCATIONS.map(l => <option key={l}>{l}</option>)}</select>
          </div>
          <div>
            <label style={labelStyle}>Quantity</label>
            <input type="number" min="0" style={inputStyle} value={form.quantity} onChange={e => setForm(f => ({ ...f, quantity: Number(e.target.value) }))} />
          </div>
          <div>
            <label style={labelStyle}>Unit</label>
            <input style={inputStyle} value={form.unit} onChange={e => setForm(f => ({ ...f, unit: e.target.value }))} placeholder="e.g. lbs, count, bottle" />
          </div>
          <div>
            <label style={labelStyle}>Expiry Date</label>
            <input type="date" style={inputStyle} value={form.expiry} onChange={e => setForm(f => ({ ...f, expiry: e.target.value }))} />
          </div>
          <div style={{ display: "flex", alignItems: "end", paddingBottom: 2 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, cursor: "pointer" }}>
              <input type="checkbox" checked={form.opened} onChange={e => setForm(f => ({ ...f, opened: e.target.checked }))} style={{ width: 18, height: 18 }} />
              <span>Opened</span>
            </label>
          </div>
        </div>
        {formError && (
          <div style={{ marginTop: 14, fontSize: 13, color: "#b91c1c", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "8px 10px" }}>
            {formError}
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 24 }}>
          <button onClick={() => setModalOpen(false)} style={btnSecondary}>Cancel</button>
          <button onClick={saveItem} style={btnPrimary}>{editItem ? "Save Changes" : "Add Item"}</button>
        </div>
      </Modal>

      {/* Delete confirmation modal */}
      {confirmModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
          <div style={{ background: "#fff", borderRadius: 16, padding: 28, maxWidth: 340, width: "100%", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" }}>
            <div style={{ width: 48, height: 48, borderRadius: 12, background: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
              <Icons.Trash style={{ width: 22, height: 22, color: "#dc2626" }} />
            </div>
            <h3 style={{ margin: "0 0 8px", fontSize: 18, fontWeight: 700, fontFamily: "'DM Serif Display', serif" }}>Delete {confirmModal.label}?</h3>
            <p style={{ margin: "0 0 24px", fontSize: 14, color: "#6b7280" }}>This will permanently remove {confirmModal.ids.length === 1 ? "this item" : `these ${confirmModal.ids.length} items`} from your inventory.</p>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={() => setConfirmModal(null)} style={{ ...btnSecondary, flex: 1 }}>Cancel</button>
              <button onClick={executeDelete} style={{ flex: 1, background: "#dc2626", color: "#fff", border: "none", borderRadius: 10, padding: "10px 0", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════
// ═══════════════════════════════════════
// RECEIPT SCAN RESULT — editable item list
// ═══════════════════════════════════════
type ReceiptItem = { name: string; quantity: number; unit: string; category: string; expiry: string; include: boolean };

function ReceiptReview({ items: initial, onConfirm, onCancel, isMobile }: {
  items: Omit<ReceiptItem, "expiry" | "include">[];
  onConfirm: (items: ReceiptItem[]) => void;
  onCancel: () => void;
  isMobile: boolean;
}) {
  const [items, setItems] = useState<ReceiptItem[]>(() =>
    initial.map(i => ({ ...i, expiry: getEstimatedScanExpiry(i.name, i.category), include: true }))
  );

  const included = items.filter(i => i.include);

  function update(idx: number, patch: Partial<ReceiptItem>) {
    setItems(prev => prev.map((it, i) => i === idx ? { ...it, ...patch } : it));
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
      <div style={{ background: "#fff", borderRadius: isMobile ? "20px 20px 0 0" : 16, width: "100%", maxWidth: 560, maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
        {/* Header */}
        <div style={{ padding: "20px 20px 12px", borderBottom: "1px solid #f3f4f6", flexShrink: 0 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div style={{ fontSize: 18, fontWeight: 700 }}>Review receipt items</div>
              <div style={{ fontSize: 13, color: "#6b7280", marginTop: 2 }}>{included.length} of {items.length} items selected</div>
            </div>
            <button onClick={onCancel} style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}>
              <Icons.X style={{ width: 20, height: 20, color: "#6b7280" }} />
            </button>
          </div>
        </div>

        {/* Items list */}
        <div style={{ flex: 1, overflowY: "auto", padding: "8px 16px" }}>
          {items.map((item, idx) => (
            <div key={idx} style={{ display: "flex", gap: 10, alignItems: "flex-start", padding: "10px 0", borderBottom: "1px solid #f9fafb", opacity: item.include ? 1 : 0.4 }}>
              {/* Checkbox */}
              <button onClick={() => update(idx, { include: !item.include })} style={{ marginTop: 2, width: 22, height: 22, borderRadius: 6, border: `2px solid ${item.include ? "#2d5a27" : "#d1d5db"}`, background: item.include ? "#2d5a27" : "#fff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0, padding: 0 }}>
                {item.include && <Icons.Check style={{ width: 13, height: 13, color: "#fff" }} />}
              </button>
              {/* Fields */}
              <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
                <input
                  value={item.name}
                  onChange={e => update(idx, { name: e.target.value })}
                  style={{ ...inputStyle, padding: "6px 10px", fontSize: 14, fontWeight: 600 }}
                />
                <div style={{ display: "flex", gap: 6 }}>
                  <input
                    type="number"
                    value={item.quantity}
                    min={1}
                    onChange={e => update(idx, { quantity: Math.max(1, parseInt(e.target.value) || 1) })}
                    style={{ ...inputStyle, padding: "5px 8px", fontSize: 13, width: 60 }}
                  />
                  <select value={item.category} onChange={e => update(idx, { category: e.target.value })} style={{ ...inputStyle, padding: "5px 8px", fontSize: 13, flex: 1 }}>
                    {CATEGORIES.map(c => <option key={c}>{c}</option>)}
                  </select>
                  <input
                    type="date"
                    value={item.expiry}
                    onChange={e => update(idx, { expiry: e.target.value })}
                    style={{ ...inputStyle, padding: "5px 8px", fontSize: 13, flex: 1 }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{ padding: "12px 16px", borderTop: "1px solid #f3f4f6", display: "flex", gap: 10, flexShrink: 0 }}>
          <button onClick={onCancel} style={{ ...btnSecondary, flex: 1 }}>Cancel</button>
          <button
            onClick={() => onConfirm(items.filter(i => i.include))}
            disabled={included.length === 0}
            style={{ ...btnPrimary, flex: 2, opacity: included.length === 0 ? 0.5 : 1 }}
          >
            Add {included.length} item{included.length !== 1 ? "s" : ""} to inventory
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════
// SCAN PAGE — barcode + receipt scanning
// ═══════════════════════════════════════
function ScanPage({ inventory, setInventory, addItem, updateItem, isMobile, logScanResult, scanHistoryList, reviewExpiryBeforeAdd, userPlan, setPage }) {
  const [mode, setMode] = useState<"barcode" | "receipt">("barcode");

  // Barcode state
  const [scanResult, setScanResult] = useState<{ name: string; brand?: string; barcode: string; category: string; confidence: number; imageUrl?: string; servingSize?: string; nutrition?: { calories?: number; protein?: number; carbs?: number; fat?: number; fiber?: number; sugar?: number } } | null>(null);
  const [scannerActive, setScannerActive] = useState(false);
  const [lookupLoading, setLookupLoading] = useState(false);
  const [scanExpiry, setScanExpiry] = useState("");
  const [manualBarcode, setManualBarcode] = useState("");
  const [localHistory, setLocalHistory] = useState<Array<{ name: string; barcode: string; category: string; confidence: number; time: string }>>([]);

  // Receipt state
  const [receiptLoading, setReceiptLoading] = useState(false);
  const [receiptError, setReceiptError] = useState<string | null>(null);
  const [receiptItems, setReceiptItems] = useState<Omit<ReceiptItem, "expiry" | "include">[] | null>(null);

  async function handleReceiptPhoto() {
    setReceiptLoading(true);
    setReceiptError(null);
    setReceiptItems(null);

    try {
      // Use CameraResultType.Uri so the bridge only returns a tiny file path —
      // Base64 mode sends the full image through the JS bridge JSON, which crashes
      // on full-resolution iPhone photos (~7 MB). Uri mode avoids that entirely.
      const { Camera, CameraResultType, CameraSource } = await import("@capacitor/camera");
      const photo = await Camera.getPhoto({
        quality: 85,
        allowEditing: false,
        resultType: CameraResultType.Uri,
        source: CameraSource.Camera,
        width: 1200,
        saveToGallery: false,
      });

      const webPath = photo.webPath;
      if (!webPath) throw new Error("Camera did not return a photo. Please try again.");

      // Fetch the image from the capacitor:// URL (WKWebView can access these),
      // then compress with canvas before sending to the edge function.
      const resp = await fetch(webPath);
      if (!resp.ok) throw new Error(`Could not load photo (${resp.status}). Please try again.`);
      const blob = await resp.blob();

      // Compress: createImageBitmap on a Blob is reliable in WKWebView (no data URL needed)
      const bitmap = await createImageBitmap(blob);
      const MAX = 1200;
      let { width, height } = bitmap;
      if (width > MAX || height > MAX) {
        if (width > height) { height = Math.round(height * MAX / width); width = MAX; }
        else { width = Math.round(width * MAX / height); height = MAX; }
      }
      const canvas = document.createElement("canvas");
      canvas.width = width; canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (!ctx) throw new Error("Canvas not available on this device.");
      ctx.drawImage(bitmap, 0, 0, width, height);
      bitmap.close();
      const dataUrl = canvas.toDataURL("image/jpeg", 0.75);
      const base64 = dataUrl.split(",")[1];
      if (!base64) throw new Error("Failed to compress photo. Please try again.");
      const mimeType = "image/jpeg";

      // Call the Supabase Edge Function
      const { supabase: sb } = await import("./lib/supabase-client").catch(() => ({ supabase: null }));
      if (!sb) {
        setReceiptError("Not connected to server. Please check your setup.");
        return;
      }

      const timeout = new Promise<never>((_, reject) =>
        setTimeout(() => reject(new Error("Request timed out. Check your connection and try again.")), 30000)
      );
      const { data, error } = await Promise.race([
        sb.functions.invoke("scan-receipt", { body: { imageBase64: base64, mimeType } }),
        timeout,
      ]) as Awaited<ReturnType<typeof sb.functions.invoke>>;

      if (error) {
        // Try to extract the actual message from the edge function response body
        let msg = error.message || "Failed to scan receipt.";
        try {
          const body = await (error as unknown as { context?: Response }).context?.json?.();
          if (body?.error) msg = body.error;
        } catch { /* ignore */ }
        setReceiptError(msg);
        return;
      }

      if (data?.error) {
        setReceiptError(data.error);
        return;
      }

      const items = (data?.items ?? []) as Omit<ReceiptItem, "expiry" | "include">[];
      if (items.length === 0) {
        setReceiptError("No food items found on this receipt. Try a clearer photo.");
        return;
      }

      setReceiptItems(items);
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : String(err);
      setReceiptError(msg || "Something went wrong. Please try again.");
      console.error("Receipt scan error:", err);
    } finally {
      setReceiptLoading(false);
    }
  }

  function handleReceiptConfirm(confirmedItems: ReceiptItem[]) {
    for (const item of confirmedItems) {
      const category = item.category;
      const location = /Dairy|Meat|Produce|Beverages/.test(category) ? "Fridge" : /Frozen/.test(category) ? "Freezer" : "Pantry";
      const nameNorm = item.name.trim().toLowerCase();
      const existing = inventory.find(i => i.name?.trim().toLowerCase() === nameNorm);

      if (existing && updateItem) {
        updateItem(existing.id, { quantity: (existing.quantity ?? 1) + item.quantity });
      } else if (existing && setInventory) {
        setInventory(prev => prev.map(i => i.id === existing.id ? { ...i, quantity: (i.quantity ?? 1) + item.quantity } : i));
      } else if (addItem) {
        addItem({
          name: item.name,
          category,
          location,
          quantity: item.quantity,
          unit: item.unit,
          expiry: item.expiry,
          opened: false,
          barcode: null,
        });
      } else {
        setInventory(prev => [...prev, {
          id: uid(),
          name: item.name,
          category,
          location,
          quantity: item.quantity,
          unit: item.unit,
          expiry: item.expiry,
          opened: false,
          addedBy: "You",
          addedDate: today.toISOString().slice(0, 10),
          barcode: null,
        }]);
      }
    }
    setReceiptItems(null);
  }

  const history = scanHistoryList?.length ? scanHistoryList.map((s) => ({ name: s.product_name || "Unknown", barcode: s.barcode || "", category: "Other", confidence: 90, time: new Date(s.created_at).toLocaleString() })) : localHistory;

  const handleBarcode = useCallback(
    async (barcode: string) => {
      setScannerActive(false);
      setLookupLoading(true);
      try {
        const product = await lookupProductByBarcode(barcode);
        if (product) {
          setScanResult({ name: product.name, brand: product.brand, barcode: product.barcode, category: product.category, confidence: product.confidence, imageUrl: product.imageUrl, servingSize: product.servingSize, nutrition: product.nutrition });
          if (logScanResult) await logScanResult({ barcode: product.barcode, name: product.name, category: product.category, confidence: product.confidence });
          else setLocalHistory((prev) => [{ ...product, time: new Date().toLocaleTimeString() }, ...prev].slice(0, 20));
        } else {
          setScanResult({ name: `Not in database (${barcode})`, barcode, category: "Other", confidence: 0 });
          if (logScanResult) await logScanResult({ barcode, name: "Not in database", category: "Other", confidence: 0 });
        }
      } catch {
        setScanResult({ name: "Lookup failed", barcode, category: "Other", confidence: 0 });
      } finally {
        setLookupLoading(false);
      }
    },
    [logScanResult]
  );

  // Safety step: always prefill a per-item estimate, but allow user edit before add.
  useEffect(() => {
    if (!scanResult) {
      setScanExpiry("");
      return;
    }
    setScanExpiry(getEstimatedScanExpiry(scanResult.name, scanResult.category));
  }, [scanResult]);

  function addScannedItem() {
    if (!scanResult) return;
    const category = scanResult.category;
    const location = /Dairy|Meat|Produce|Beverages/.test(category) ? "Fridge" : /Frozen/.test(category) ? "Freezer" : "Pantry";
    const selectedExpiry = scanExpiry || getEstimatedScanExpiry(scanResult.name, scanResult.category);
    const barcodeNorm = scanResult.barcode.replace(/\D/g, "");
    const nameNorm = scanResult.name.trim().toLowerCase();
    // Prefer match by barcode+name; if none, match by name only (e.g. item added before we stored barcode)
    const existingByBarcodeAndName = inventory.find(
      (i) =>
        i.name?.trim().toLowerCase() === nameNorm &&
        i.barcode &&
        i.barcode.replace(/\D/g, "") === barcodeNorm
    );
    const existingByNameOnly = inventory.find(
      (i) => i.name?.trim().toLowerCase() === nameNorm
    );
    const existing = existingByBarcodeAndName ?? existingByNameOnly;
    if (existing && (addItem && updateItem)) {
      const updates: Record<string, unknown> = { quantity: (existing.quantity ?? 1) + 1 };
      if (!existing.barcode && scanResult.barcode) updates.barcode = scanResult.barcode;
      updateItem(existing.id, updates);
    } else if (existing && setInventory) {
      setInventory((prev) =>
        prev.map((i) =>
          i.id === existing.id
            ? { ...i, quantity: (i.quantity ?? 1) + 1, barcode: i.barcode || scanResult.barcode || null }
            : i
        )
      );
    } else if (addItem) {
      addItem({
        name: scanResult.name,
        category: scanResult.category,
        location,
        quantity: 1,
        unit: "count",
        expiry: selectedExpiry,
        opened: false,
        barcode: scanResult.barcode || null,
      });
    } else {
      setInventory((prev) => [
        ...prev,
        {
          id: uid(),
          name: scanResult.name,
          category: scanResult.category,
          location,
          quantity: 1,
          unit: "count",
          expiry: selectedExpiry,
          opened: false,
          addedBy: "You",
          addedDate: today.toISOString().slice(0, 10),
          barcode: scanResult.barcode || null,
        },
      ]);
    }
    setScanResult(null);
  }

  return (
    <div>
      {/* Receipt review modal */}
      {receiptItems && (
        <ReceiptReview
          items={receiptItems}
          onConfirm={handleReceiptConfirm}
          onCancel={() => setReceiptItems(null)}
          isMobile={isMobile}
        />
      )}


      <h1 style={{ fontSize: 28, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 16px" }}>Scan</h1>

      {/* Mode toggle */}
      <div style={{ display: "flex", gap: 4, background: "#f3f4f6", borderRadius: 12, padding: 4, marginBottom: 20, width: "fit-content" }}>
        <button
          onClick={() => { setMode("barcode"); setScannerActive(false); }}
          style={{ padding: "8px 20px", borderRadius: 10, border: "none", cursor: "pointer", fontWeight: 600, fontSize: 14, transition: "all 0.15s", background: mode === "barcode" ? "#fff" : "transparent", color: mode === "barcode" ? "#1a2e1a" : "#6b7280", boxShadow: mode === "barcode" ? "0 1px 4px rgba(0,0,0,0.12)" : "none" }}
        >
          <Icons.Scan style={{ width: 14, height: 14, display: "inline", verticalAlign: "middle", marginRight: 6 }} />
          Barcode
        </button>
        <button
          onClick={() => {
            if (!canAccess((userPlan || "free") as PlanKey, "receiptScanning")) {
              setMode("receipt");
              setScannerActive(false);
            } else {
              setMode("receipt");
              setScannerActive(false);
            }
          }}
          style={{ padding: "8px 20px", borderRadius: 10, border: "none", cursor: "pointer", fontWeight: 600, fontSize: 14, transition: "all 0.15s", background: mode === "receipt" ? "#fff" : "transparent", color: mode === "receipt" ? "#1a2e1a" : "#6b7280", boxShadow: mode === "receipt" ? "0 1px 4px rgba(0,0,0,0.12)" : "none", position: "relative" }}
        >
          <Icons.Camera style={{ width: 14, height: 14, display: "inline", verticalAlign: "middle", marginRight: 6 }} />
          Receipt
          {!canAccess((userPlan || "free") as PlanKey, "receiptScanning") && (
            <span style={{ marginLeft: 4, fontSize: 10, background: "#f59e0b", color: "#fff", borderRadius: 4, padding: "1px 5px", fontWeight: 700, verticalAlign: "middle" }}>PRO</span>
          )}
        </button>
      </div>

      {mode === "barcode" && (
        <>
          <p style={{ color: "#6b7280", margin: "0 0 20px", fontSize: 14 }}>Scan food barcodes to add items from the Open Food Facts database.</p>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: isMobile ? 12 : 20 }}>
            <Card style={{ textAlign: "center" }}>
              {!scannerActive ? (
                <>
                  <div style={{ width: "100%", minHeight: 200, marginBottom: 16, background: "#f9fafb", borderRadius: 16, border: "2px dashed #d1d5db", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12 }}>
                    <Icons.Scan style={{ width: 48, height: 48, color: "#9ca3af" }} />
                    <span style={{ color: "#6b7280", fontSize: 14 }}>Use your camera to scan a barcode</span>
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center" }}>
                    <button onClick={() => setScannerActive(true)} style={btnPrimary}><Icons.Scan style={{ width: 16, height: 16, display: "inline", verticalAlign: "middle", marginRight: 6 }} />Scan with camera</button>
                    <div style={{ display: "flex", gap: 8, alignItems: "center", flex: "1 1 100%", justifyContent: "center", marginTop: 8 }}>
                      <input value={manualBarcode} onChange={(e) => setManualBarcode(e.target.value)} placeholder="Or enter barcode" style={{ padding: "10px 14px", border: "2px solid #e5e7eb", borderRadius: 12, fontSize: 14, width: 180, fontFamily: "monospace" }} />
                      <button onClick={() => manualBarcode.trim() && handleBarcode(manualBarcode.trim())} style={{ ...btnPrimary, padding: "10px 16px" }}>Look up</button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <BarcodeScanner onScan={handleBarcode} active={scannerActive} style={{ marginBottom: 12 }} />
                  <button onClick={() => setScannerActive(false)} style={btnSecondary}>Cancel</button>
                </>
              )}

              {lookupLoading && <p style={{ marginTop: 12, fontSize: 14, color: "#6b7280" }}>Looking up product…</p>}
              {scanResult && !lookupLoading && (
                <div style={{ marginTop: 20, padding: 16, background: "#f0fdf4", borderRadius: 12, textAlign: "left" }}>
                  <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 12 }}>
                    {scanResult.imageUrl && (
                      <img src={scanResult.imageUrl} alt={scanResult.name} style={{ width: 64, height: 64, objectFit: "contain", borderRadius: 8, background: "#fff", border: "1px solid #e5e7eb", flexShrink: 0 }} onError={e => { (e.target as HTMLImageElement).style.display = "none"; }} />
                    )}
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontWeight: 700, fontSize: 15, lineHeight: 1.3 }}>{scanResult.name}</div>
                      {scanResult.brand && <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>{scanResult.brand}</div>}
                      <div style={{ display: "flex", gap: 6, marginTop: 4, flexWrap: "wrap" }}>
                        <span style={{ fontSize: 11, fontWeight: 600, background: "#dcfce7", color: "#2d5a27", padding: "2px 8px", borderRadius: 20 }}>{scanResult.category}</span>
                        {scanResult.servingSize && <span style={{ fontSize: 11, color: "#6b7280", padding: "2px 6px", background: "#f3f4f6", borderRadius: 20 }}>per {scanResult.servingSize}</span>}
                      </div>
                    </div>
                  </div>

                  {scanResult.nutrition && (
                    <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
                      {[
                        { label: "Cal", value: scanResult.nutrition.calories, unit: "" },
                        { label: "Protein", value: scanResult.nutrition.protein, unit: "g" },
                        { label: "Carbs", value: scanResult.nutrition.carbs, unit: "g" },
                        { label: "Fat", value: scanResult.nutrition.fat, unit: "g" },
                        { label: "Fiber", value: scanResult.nutrition.fiber, unit: "g" },
                      ].filter(n => n.value !== undefined).map(n => (
                        <div key={n.label} style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "6px 10px", textAlign: "center", minWidth: 48 }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1f16" }}>{n.value}{n.unit}</div>
                          <div style={{ fontSize: 10, color: "#9ca3af", marginTop: 1 }}>{n.label}</div>
                        </div>
                      ))}
                    </div>
                  )}

                  {reviewExpiryBeforeAdd !== false && (
                    <div style={{ marginBottom: 12 }}>
                      <label style={{ ...labelStyle, marginBottom: 4 }}>Expiry date <span style={{ fontWeight: 400, color: "#9ca3af" }}>(check your package)</span></label>
                      <input type="date" value={scanExpiry} onChange={(e) => setScanExpiry(e.target.value)} style={{ ...inputStyle, padding: "8px 10px", fontSize: 13 }} />
                    </div>
                  )}

                  <div style={{ display: "flex", gap: 8 }}>
                    <button onClick={addScannedItem} style={{ ...btnPrimary, flex: 1, fontSize: 13 }}>Add to inventory</button>
                    <button onClick={() => setScanResult(null)} style={{ ...btnSecondary, fontSize: 13 }}>Dismiss</button>
                  </div>
                </div>
              )}
            </Card>

            <Card>
              <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 16px" }}>Recent scans</h3>
              {history.length === 0 ? <p style={{ color: "#9ca3af", fontSize: 14 }}>No scans yet. Scan a barcode or enter one manually.</p> :
                history.slice(0, 10).map((s, i) => (
                  <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "1px solid #f3f4f6" }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14 }}>{s.name}</div>
                      <div style={{ fontSize: 12, color: "#9ca3af" }}>{s.time}</div>
                    </div>
                    <button onClick={() => setScanResult({ name: s.name, barcode: s.barcode, category: s.category, confidence: s.confidence })} style={{ ...btnSecondary, padding: "4px 10px", fontSize: 12 }}>Add again</button>
                  </div>
                ))
              }
            </Card>
          </div>
        </>
      )}

      {mode === "receipt" && !canAccess((userPlan || "free") as PlanKey, "receiptScanning") && (
        <UpgradeGate
          feature="Receipt Scanning"
          description="Snap a photo of your grocery receipt and we'll add every item to your inventory automatically using AI. Upgrade to Pro to unlock receipt scanning."
          onUpgrade={() => setPage("pricing")}
          isMobile={isMobile}
        />
      )}
      {mode === "receipt" && canAccess((userPlan || "free") as PlanKey, "receiptScanning") && (
        <>
          <p style={{ color: "#6b7280", margin: "0 0 20px", fontSize: 14 }}>Take a photo of your grocery receipt and we'll add everything automatically.</p>
          <Card style={{ textAlign: "center" }}>

            {receiptLoading ? (
              <div style={{ width: "100%", minHeight: 200, marginBottom: 20, background: "#f9fafb", borderRadius: 16, border: "2px dashed #d1d5db", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12 }}>
                <div style={{ width: 40, height: 40, border: "3px solid #e5e7eb", borderTopColor: "#2d5a27", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
                <span style={{ color: "#6b7280", fontSize: 14 }}>Reading your receipt…</span>
              </div>
            ) : (
              <div
                onClick={handleReceiptPhoto}
                style={{ display: "block", cursor: "pointer", marginBottom: 20 }}
              >
                <div style={{ width: "100%", minHeight: 200, background: "#f9fafb", borderRadius: 16, border: `2px dashed ${receiptError ? "#fca5a5" : "#d1d5db"}`, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, transition: "border-color 0.15s" }}>
                  <Icons.Camera style={{ width: 48, height: 48, color: "#9ca3af" }} />
                  <span style={{ color: "#6b7280", fontSize: 14 }}>Tap to photograph your receipt</span>
                  <span style={{ color: "#9ca3af", fontSize: 12 }}>Up to 10 scans per day</span>
                </div>
              </div>
            )}

            {receiptError && (
              <div style={{ marginBottom: 16, padding: "12px 16px", background: "#fef2f2", borderRadius: 10, border: "1px solid #fecaca", color: "#dc2626", fontSize: 14, textAlign: "left" }}>
                {receiptError}
              </div>
            )}

            {!receiptLoading && (
              <button onClick={handleReceiptPhoto} style={{ ...btnPrimary, display: "inline-flex", alignItems: "center", gap: 6 }}>
                <Icons.Camera style={{ width: 16, height: 16 }} />
                Scan receipt
              </button>
            )}
            {receiptLoading && (
              <div style={{ ...btnPrimary, opacity: 0.5, display: "inline-flex", alignItems: "center", gap: 6 }}>
                <Icons.Camera style={{ width: 16, height: 16 }} />
                Scanning…
              </div>
            )}

            <p style={{ marginTop: 16, fontSize: 12, color: "#9ca3af", lineHeight: 1.5 }}>
              Works best with good lighting. Non-food items (cleaning products, etc.) are automatically skipped.
            </p>
          </Card>
        </>
      )}
    </div>
  );
}

// ═══════════════════════════════════════
// SHOPPING LIST
// ═══════════════════════════════════════
function Shopping({ inventory, setInventory, shopList, setShopList, addItem, updateItem, addShopItem, toggleCheck: toggleCheckProp, removeShopItem, clearChecked: clearCheckedProp, autoGenerateShop, isMobile }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({ name: "", quantity: 1, unit: "count", priority: "medium", estCost: "" });

  async function addItem() {
    if (!form.name.trim()) return;
    if (addShopItem) {
      await addShopItem({ ...form, estCost: form.estCost || (Math.random() * 8 + 2).toFixed(2) });
    } else {
      setShopList(prev => [...prev, { id: uid(), ...form, estCost: form.estCost || (Math.random() * 8 + 2).toFixed(2), checked: false }]);
    }
    setForm({ name: "", quantity: 1, unit: "count", priority: "medium", estCost: "" });
    setModalOpen(false);
  }

  async function toggleCheck(id) {
    const existing = shopList.find((i) => i.id === id);
    const nextChecked = !existing?.checked;

    if (toggleCheckProp) await toggleCheckProp(id);
    else setShopList(prev => prev.map(i => i.id === id ? { ...i, checked: !i.checked } : i));

    // When an item is checked off, add it to inventory.
    if (nextChecked && existing?.name) {
      const expiry = new Date(Date.now() + 14 * 86400000).toISOString().slice(0, 10);
      const qtyToAdd = Number(existing.quantity ?? 1) || 1;
      const payload = {
        name: existing.name,
        category: "Other",
        location: "Pantry",
        quantity: qtyToAdd,
        unit: existing.unit ?? "count",
        expiry,
        opened: false,
      };

      const match = Array.isArray(inventory)
        ? (inventory as any[]).find((inv) => typeof inv?.name === "string" && inv.name.toLowerCase() === existing.name.toLowerCase())
        : null;

      if (match?.id && typeof match?.quantity === "number" && updateItem) {
        await updateItem(match.id as string, { quantity: (match.quantity as number) + qtyToAdd });
      } else if (addItem) {
        await addItem(payload);
      } else if (setInventory) {
        setInventory((prev) => {
          const idx = prev.findIndex((inv) => typeof inv?.name === "string" && inv.name.toLowerCase() === existing.name.toLowerCase());
          if (idx >= 0) {
            const next = [...prev];
            next[idx] = { ...next[idx], quantity: Number(next[idx].quantity ?? 0) + qtyToAdd };
            return next;
          }
          return [...prev, { id: uid(), ...payload, addedBy: "You", addedDate: today.toISOString().slice(0, 10) }];
        });
      }
    }
  }

  async function clearChecked() {
    if (clearCheckedProp) await clearCheckedProp();
    else setShopList(prev => prev.filter(i => !i.checked));
  }

  async function autoGenerate() {
    if (autoGenerateShop) await autoGenerateShop();
    else {
      const lowItems = inventory.filter(i => i.quantity <= 1);
      const expiredItems = inventory.filter(i => daysBetween(today, i.expiry) < 0);
      const itemsToAdd = [...lowItems, ...expiredItems].filter(i => !shopList.some(s => s.name === i.name));
      const newItems = itemsToAdd.map(i => ({ id: uid(), name: i.name, quantity: 1, unit: i.unit, priority: i.quantity <= 1 ? "high" : "medium", estCost: (Math.random() * 8 + 2).toFixed(2), checked: false }));
      setShopList(prev => [...prev, ...newItems]);
    }
  }

  function exportList() {
    const text = shopList.map(i => `${i.checked ? "✓" : "○"} ${i.name} (${i.quantity} ${i.unit}) - $${i.estCost} [${i.priority}]`).join("\n");
    const totalCost = shopList.reduce((s, i) => s + parseFloat(i.estCost || 0), 0).toFixed(2);
    const blob = new Blob([`Shopping List\n${"=".repeat(40)}\n${text}\n\nEstimated Total: $${totalCost}`], { type: "text/plain" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "shopping-list.txt";
    a.click();
  }

  const totalCost = shopList.reduce((s, i) => s + parseFloat(i.estCost || 0), 0).toFixed(2);
  const priorityColors = { high: "#dc2626", medium: "#ca8a04", low: "#6b7280" };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <h1 style={{ fontSize: 28, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: 0 }}>Shopping List</h1>
          <p style={{ color: "#6b7280", margin: "4px 0 0", fontSize: 14 }}>{shopList.length} items · Est. ${totalCost}</p>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={autoGenerate} style={{ ...btnSecondary, display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}><Icons.Refresh style={{ width: 14, height: 14 }} />Auto-Generate</button>
          <button onClick={exportList} style={{ ...btnSecondary, display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}><Icons.Download style={{ width: 14, height: 14 }} />Export</button>
          <button onClick={() => setModalOpen(true)} style={{ ...btnPrimary, display: "flex", alignItems: "center", gap: 6 }}><Icons.Plus style={{ width: 16, height: 16 }} />Add</button>
        </div>
      </div>

      <Card style={{ padding: 0 }}>
        {shopList.length === 0 ? (
          <div style={{ padding: 48, textAlign: "center" }}>
            <div style={{ width: 64, height: 64, borderRadius: 20, background: "#f0fdf4", color: "#2d5a27", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
              <Icons.Cart style={{ width: 32, height: 32 }} />
            </div>
            <p style={{ fontSize: 18, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 6px", color: "#1a1f16" }}>Your shopping list is empty</p>
            <p style={{ fontSize: 14, color: "#6b7280", margin: "0 0 20px" }}>Add items manually or auto-generate from low stock.</p>
            <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
              <button type="button" onClick={() => setModalOpen(true)} style={{ ...btnPrimary, display: "inline-flex", alignItems: "center", gap: 6 }}><Icons.Plus style={{ width: 16, height: 16 }} /> Add item</button>
              <button type="button" onClick={autoGenerate} style={{ ...btnSecondary, display: "inline-flex", alignItems: "center", gap: 6 }}><Icons.Refresh style={{ width: 14, height: 14 }} /> Auto-generate</button>
            </div>
          </div>
        ) : (
          <div>
            {shopList.map(item => (
              <div key={item.id} style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 20px", borderBottom: "1px solid #f3f4f6", opacity: item.checked ? 0.5 : 1, transition: "opacity 0.2s" }}>
                <button onClick={() => toggleCheck(item.id)} style={{ width: 24, height: 24, borderRadius: 6, border: `2px solid ${item.checked ? "#2d5a27" : "#d1d5db"}`, background: item.checked ? "#2d5a27" : "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, transition: "all 0.2s" }}>
                  {item.checked && <Icons.Check style={{ width: 14, height: 14, color: "#fff" }} />}
                </button>
                <div style={{ flex: 1 }}>
                  <span style={{ fontWeight: 600, fontSize: 14, textDecoration: item.checked ? "line-through" : "none" }}>{item.name}</span>
                  <span style={{ color: "#9ca3af", fontSize: 12, marginLeft: 8 }}>{item.quantity} {item.unit}</span>
                </div>
                <span style={{ fontSize: 11, fontWeight: 700, color: priorityColors[item.priority], textTransform: "uppercase", letterSpacing: "0.05em" }}>{item.priority}</span>
                <span style={{ fontWeight: 600, fontSize: 14, color: "#374151", minWidth: 50, textAlign: "right" }}>${item.estCost}</span>
                <button onClick={() => removeShopItem ? removeShopItem(item.id) : setShopList(prev => prev.filter(i => i.id !== item.id))} style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}><Icons.X style={{ width: 14, height: 14, color: "#9ca3af" }} /></button>
              </div>
            ))}
            {shopList.some(i => i.checked) && (
              <div style={{ padding: "12px 20px", textAlign: "center" }}>
                <button onClick={clearChecked} style={{ ...btnSecondary, fontSize: 13 }}>Clear Checked Items</button>
              </div>
            )}
          </div>
        )}
      </Card>

      {/* ── Affiliate Order Strip ── */}
      {shopList.length > 0 && (
        <div style={{ marginTop: 16, padding: "16px 20px", background: "#fff", borderRadius: 16, border: "1px solid #e5e7eb", boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1f16", marginBottom: 12 }}>Order your list online</div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <a
              href={`https://www.instacart.com/?utm_source=ingrediable&utm_medium=app&utm_campaign=shoplist`}
              target="_blank" rel="noopener noreferrer"
              style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "10px 16px", background: "#43b02a", color: "#fff", borderRadius: 10, fontSize: 13, fontWeight: 700, textDecoration: "none", flex: "1 1 auto", justifyContent: "center", minWidth: 140 }}
            >
              <Icons.Cart style={{ width: 15, height: 15 }} /> Order via Instacart
            </a>

          </div>
          <p style={{ fontSize: 11, color: "#9ca3af", margin: "10px 0 0" }}>We may earn a small commission on orders — at no extra cost to you.</p>
        </div>
      )}

      <Modal open={modalOpen} onClose={() => setModalOpen(false)} title="Add Shopping Item">
        <div style={{ display: "grid", gap: 14 }}>
          <div>
            <label style={labelStyle}>Item Name</label>
            <input style={inputStyle} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="e.g. Whole Milk" />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr", gap: 12 }}>
            <div>
              <label style={labelStyle}>Quantity</label>
              <input type="number" min="1" style={inputStyle} value={form.quantity} onChange={e => setForm(f => ({ ...f, quantity: Number(e.target.value) }))} />
            </div>
            <div>
              <label style={labelStyle}>Unit</label>
              <input style={inputStyle} value={form.unit} onChange={e => setForm(f => ({ ...f, unit: e.target.value }))} />
            </div>
            <div>
              <label style={labelStyle}>Priority</label>
              <select style={selectStyle} value={form.priority} onChange={e => setForm(f => ({ ...f, priority: e.target.value }))}>
                <option value="high">High</option>
                <option value="medium">Medium</option>
                <option value="low">Low</option>
              </select>
            </div>
          </div>
          <div>
            <label style={labelStyle}>Estimated Cost ($)</label>
            <input type="number" step="0.01" style={inputStyle} value={form.estCost} onChange={e => setForm(f => ({ ...f, estCost: e.target.value }))} placeholder="Auto-estimated if blank" />
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 20 }}>
          <button onClick={() => setModalOpen(false)} style={btnSecondary}>Cancel</button>
          <button onClick={addItem} style={btnPrimary}>Add Item</button>
        </div>
      </Modal>
    </div>
  );
}

// ═══════════════════════════════════════
// RECIPES
// ═══════════════════════════════════════
function Recipes({ inventory, setInventory, shopList, setShopList, addShopItem, userRecipes, setUserRecipes, mealPlan, setMealPlan, setPage, isMobile, removeItem, updateItem }) {
  const [tab, setTab] = useState<"browse" | "mine">("browse");
  const [search, setSearch] = useState("");
  const [cuisine, setCuisine] = useState("All");
  const [selected, setSelected] = useState<Record<string, unknown> | null>(null);
  const [showCreate, setShowCreate] = useState(false);
  const [cookConfirm, setCookConfirm] = useState<Record<string, unknown> | null>(null);
  const [addToPlannerModal, setAddToPlannerModal] = useState<Record<string, unknown> | null>(null);
  const [plannerDay, setPlannerDay] = useState("");
  const [plannerMeal, setPlannerMeal] = useState<"breakfast" | "lunch" | "dinner">("dinner");

  // Optimistic local saved set — gives instant visual feedback without waiting for Supabase
  const [localSaved, setLocalSaved] = useState<Set<string>>(new Set());
  // Sync from DB whenever userRecipes loads or updates
  useEffect(() => {
    if ((userRecipes || []).length > 0) {
      setLocalSaved(prev => {
        const fromDB = new Set((userRecipes as Record<string, unknown>[]).map(r => r.name as string));
        return new Set([...fromDB, ...prev]);
      });
    }
  }, [userRecipes]);

  function isSaved(name: string) {
    return localSaved.has(name);
  }

  function toggleSaveRecipe(recipe: Record<string, unknown>) {
    const name = recipe.name as string;
    const list = (userRecipes || []) as Record<string, unknown>[];
    if (isSaved(name)) {
      setLocalSaved(prev => { const s = new Set(prev); s.delete(name); return s; });
      setUserRecipes(list.filter((r: Record<string, unknown>) => r.name !== name));
    } else {
      setLocalSaved(prev => new Set([...prev, name]));
      setUserRecipes([...list, { ...recipe, id: uid(), isTemplate: false }]);
    }
  }

  // Create recipe form
  const blankRecipe = { name: "", cuisine: "Italian", prep: 10, cook: 20, servings: 2, difficulty: "Easy", desc: "", ingredients: [{ name: "", qty: "", unit: "" }], steps: [""] };
  const [form, setForm] = useState<typeof blankRecipe>(blankRecipe);

  // TheMealDB live recipes
  const [mealdbRecipes, setMealdbRecipes] = useState<Record<string, unknown>[]>([]);
  const [mealdbLoading, setMealdbLoading] = useState(true);

  // Initial batch load — varied searches across cuisines for a diverse, shuffled feed
  useEffect(() => {
    const searches = ["chicken", "pasta", "beef", "salmon", "curry", "noodle", "steak", "shrimp", "tacos", "rice"];
    setMealdbLoading(true);
    Promise.all(
      searches.map(s =>
        fetch(`https://www.themealdb.com/api/json/v1/1/search.php?s=${s}`)
          .then(r => r.json()).then(d => (d.meals || []) as Record<string, string>[])
          .catch(() => [] as Record<string, string>[])
      )
    ).then(results => {
      const seen = new Set<string>();
      const unique = results.flat().filter(m => { if (seen.has(m.idMeal)) return false; seen.add(m.idMeal); return true; });
      // Sort by meal ID so the order is always the same across page visits
      unique.sort((a, b) => Number(a.idMeal) - Number(b.idMeal));
      setMealdbRecipes(unique.map(mapMealDB));
    }).catch(() => {}).finally(() => setMealdbLoading(false));
  }, []);

  // Live search against TheMealDB
  useEffect(() => {
    if (!search.trim()) return;
    const timer = setTimeout(() => {
      setMealdbLoading(true);
      fetch(`https://www.themealdb.com/api/json/v1/1/search.php?s=${encodeURIComponent(search.trim())}`)
        .then(r => r.json())
        .then(d => setMealdbRecipes(((d.meals || []) as Record<string, string>[]).map(mapMealDB)))
        .catch(() => {})
        .finally(() => setMealdbLoading(false));
    }, 400);
    return () => clearTimeout(timer);
  }, [search]);

  const baseRecipes = mealdbRecipes.length > 0 ? mealdbRecipes : SAMPLE_RECIPES.map(r => ({ ...r, isTemplate: true }));
  const allRecipes = [...baseRecipes, ...(userRecipes || []).map((r: Record<string, unknown>) => ({ ...r, isTemplate: false }))];

  // Build dynamic cuisine dropdown from all recipes in the current view
  const cuisineOptions = useMemo(() => {
    const seen = new Set<string>();
    for (const r of allRecipes) {
      const c = r.cuisine as string;
      if (c && c !== "Other") seen.add(c);
    }
    return ["All", ...[...seen].sort(), "Other"];
  }, [allRecipes]);

  const filtered = allRecipes.filter((r: Record<string, unknown>) => {
    if (tab === "mine" && r.isTemplate) return false;
    if (tab === "browse" && !r.isTemplate && mealdbRecipes.length > 0) return false;
    if (search && !((r.name as string) || "").toLowerCase().includes(search.toLowerCase()) && !((r.desc as string) || "").toLowerCase().includes(search.toLowerCase())) return false;
    if (cuisine !== "All" && r.cuisine !== cuisine) return false;
    return true;
  });

  // Appeal score — dishes people most want to eat come first
  const APPEAL: Record<string, number> = {
    Beef: 10, Chicken: 10, Lamb: 9, Seafood: 9, Pork: 8,
    Pasta: 8, Vegetarian: 7, Vegan: 7, Dessert: 6, Breakfast: 6,
    Starter: 5, Side: 4, Miscellaneous: 3,
  };
  function appealScore(r: Record<string, unknown>): number {
    const cat = ((r.desc as string) || "").split("·")[0].trim();
    return APPEAL[cat] ?? 5;
  }

  // Daily seed — integer that increments once per 24h, stable within the day
  const dailySeed = Math.floor(Date.now() / 86400000);

  // Seeded pseudo-random: given a stable int input, returns a deterministic 0–1 float
  function seededRand(n: number): number {
    let t = (n ^ (n >>> 15)) * 0x9e3779b9;
    t = (t ^ (t >>> 13)) * 0x85ebca6b;
    return ((t ^ (t >>> 16)) >>> 0) / 0xffffffff;
  }

  // Primary: images first. Secondary: appeal score (high = top). Tertiary: daily-seeded
  // shuffle within each appeal tier so the feed rotates every 24 hours.
  const displayed = [...filtered].sort((a, b) => {
    if (a.image && !b.image) return -1;
    if (!a.image && b.image) return 1;
    const scoreDiff = appealScore(b) - appealScore(a);
    if (scoreDiff !== 0) return scoreDiff;
    // Same tier — vary by day using recipe ID as stable per-recipe seed
    return seededRand(Number(a.id) + dailySeed * 1000) - seededRand(Number(b.id) + dailySeed * 1000);
  });

  const diffColors = { Easy: "#16a34a", Medium: "#ca8a04", Hard: "#dc2626" };

  // Pantry check: does inventory have this ingredient?
  function hasIngredient(ingName: string) {
    const n = ingName.toLowerCase().replace(/[^a-z ]/g, "").trim();
    return (inventory || []).some((item: Record<string, unknown>) => {
      const name = ((item.name as string) || "").toLowerCase();
      const words = n.split(" ").filter(w => w.length > 3);
      return words.length > 0 && words.some(w => name.includes(w));
    });
  }

  function getIngredientName(ing: string | Record<string, unknown>) {
    if (typeof ing === "string") return ing;
    return `${ing.qty || ""} ${ing.unit || ""} ${ing.name || ""}`.trim();
  }

  function getIngredientRawName(ing: string | Record<string, unknown>) {
    if (typeof ing === "string") return ing;
    return (ing.name as string) || "";
  }

  async function addMissingToShop(recipe: Record<string, unknown>) {
    for (const ing of (recipe.ingredients as Array<string | Record<string, unknown>>)) {
      const name = getIngredientName(ing);
      if (!shopList.some((s: Record<string, unknown>) => (s.name as string).toLowerCase() === name.toLowerCase())) {
        if (addShopItem) await addShopItem({ name, quantity: 1, unit: "count", priority: "medium", estCost: (Math.random() * 5 + 1).toFixed(2) });
        else setShopList((prev: unknown[]) => [...prev, { id: uid(), name, quantity: 1, unit: "count", priority: "medium", estCost: (Math.random() * 5 + 1).toFixed(2), checked: false }]);
      }
    }
  }

  async function cookRecipe(recipe: Record<string, unknown>) {
    // Deduct matching ingredients from inventory
    for (const ing of (recipe.ingredients as Array<string | Record<string, unknown>>)) {
      const rawName = getIngredientRawName(ing).toLowerCase();
      const match = (inventory || []).find((item: Record<string, unknown>) => {
        const name = ((item.name as string) || "").toLowerCase();
        const words = rawName.split(" ").filter((w: string) => w.length > 3);
        return words.length > 0 && words.some((w: string) => name.includes(w));
      }) as Record<string, unknown> | undefined;
      if (match) {
        const newQty = (match.quantity as number) - 1;
        if (newQty <= 0) {
          if (removeItem) await removeItem(match.id as string, { logWaste: false, reason: "used in recipe" });
          else if (setInventory) setInventory((prev: unknown[]) => prev.filter((i: Record<string, unknown>) => i.id !== match.id));
        } else {
          if (updateItem) await updateItem(match.id as string, { quantity: newQty });
          else if (setInventory) setInventory((prev: unknown[]) => prev.map((i: Record<string, unknown>) => i.id === match.id ? { ...i, quantity: newQty } : i));
        }
      }
    }
    setCookConfirm(null);
    setSelected(null);
  }

  function addToPlanner(recipe: Record<string, unknown>) {
    if (!plannerDay) return;
    setMealPlan((prev: Record<string, unknown>) => ({
      ...prev,
      [plannerDay]: { ...(((prev || {}) as Record<string, unknown>)[plannerDay] || {}), [plannerMeal]: { recipeId: recipe.id, recipeName: recipe.name } },
    }));
    setAddToPlannerModal(null);
    setPlannerDay("");
  }

  function saveRecipe() {
    if (!form.name.trim()) return;
    const newRecipe = { ...form, id: uid(), rating: 4.5, isTemplate: false, ingredients: form.ingredients.filter(i => i.name.trim()), steps: form.steps.filter(s => s.trim()) };
    setUserRecipes([...(userRecipes || []), newRecipe]);
    setShowCreate(false);
    setForm(blankRecipe);
    setTab("mine");
  }

  function deleteUserRecipe(id: string) {
    setUserRecipes((userRecipes || []).filter((r: Record<string, unknown>) => r.id !== id));
    if (selected && (selected as Record<string, unknown>).id === id) setSelected(null);
  }

  // Next 7 days for planner dropdown
  const next7Days = Array.from({ length: 7 }, (_, i) => {
    const d = new Date();
    d.setDate(d.getDate() + i);
    return { value: d.toISOString().slice(0, 10), label: i === 0 ? "Today" : i === 1 ? "Tomorrow" : d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" }) };
  });

  // ── DETAIL VIEW ──
  if (selected) {
    const recipe = selected as Record<string, unknown>;
    const ingredients = recipe.ingredients as Array<string | Record<string, unknown>>;
    const steps = recipe.steps as string[];
    const pantryMatches = ingredients.map(ing => hasIngredient(getIngredientRawName(ing)));
    const haveCount = pantryMatches.filter(Boolean).length;

    const alreadySaved = isSaved(recipe.name as string);

    return (
      <div>
        {/* Header row: Back ← on left, Save toggle on right */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <button onClick={() => setSelected(null)} style={{ ...btnSecondary, fontSize: 13 }}>← Back to recipes</button>
          {recipe.isTemplate ? (
            <button
              onClick={() => toggleSaveRecipe(recipe)}
              style={{ background: alreadySaved ? "#15803d" : "#f3f4f6", border: "none", borderRadius: 20, padding: "8px 16px", cursor: "pointer", fontSize: 13, fontWeight: 700, color: alreadySaved ? "#fff" : "#374151", display: "flex", alignItems: "center", gap: 6, fontFamily: "inherit", transition: "all 0.2s" }}
            >
              {alreadySaved ? "✓ Saved to My Recipes" : "+ Save to My Recipes"}
            </button>
          ) : (
            <button onClick={() => deleteUserRecipe(recipe.id as string)} style={{ background: "#fef2f2", border: "none", borderRadius: 20, padding: "8px 14px", cursor: "pointer", display: "flex", alignItems: "center", gap: 5, fontFamily: "inherit", fontSize: 13, fontWeight: 600, color: "#dc2626" }}>
              <Icons.Trash style={{ width: 14, height: 14 }} /> Delete recipe
            </button>
          )}
        </div>
        <Card style={{ overflow: "hidden" }}>
          {/* Hero image — clean, no overlay buttons */}
          <div style={{ width: "100%", maxHeight: 300, overflow: "hidden", background: "#f3f4f6" }}>
            {recipe.image
              ? <img src={recipe.image as string} alt={recipe.name as string} style={{ width: "100%", objectFit: "cover", display: "block" }} />
              : <div style={{ height: 180, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 64 }}>🍽️</div>
            }
          </div>
          <div style={{ padding: 24 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: 12, flexWrap: "wrap", gap: 8 }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <h2 style={{ fontSize: 22, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 4px" }}>{recipe.name as string}</h2>
              <p style={{ color: "#6b7280", margin: 0, fontSize: 13 }}>{recipe.desc as string}</p>
            </div>
            {typeof recipe.rating === "number" && <div style={{ display: "flex", alignItems: "center", gap: 4, flexShrink: 0 }}><Icons.Star style={{ width: 15, height: 15, color: "#f59e0b" }} /><span style={{ fontWeight: 700, fontSize: 14 }}>{recipe.rating}</span></div>}
          </div>

          <div style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap" }}>
            {[{ icon: Icons.Clock, label: `Prep: ${recipe.prep}min` }, { icon: Icons.Clock, label: `Cook: ${recipe.cook}min` }, { icon: Icons.Users, label: `${recipe.servings} servings` }].map((m, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "#6b7280" }}><m.icon style={{ width: 14, height: 14 }} />{m.label}</div>
            ))}
            <span style={{ fontSize: 12, fontWeight: 700, color: diffColors[(recipe.difficulty as string)] || "#6b7280", background: `${diffColors[(recipe.difficulty as string)] || "#6b7280"}15`, padding: "3px 12px", borderRadius: 20 }}>{recipe.difficulty as string}</span>
            <span style={{ fontSize: 12, fontWeight: 600, color: "#2d5a27", background: "#f0fdf4", padding: "3px 12px", borderRadius: 20 }}>{recipe.cuisine as string}</span>
          </div>

          {/* Pantry status */}
          <div style={{ padding: "10px 14px", borderRadius: 10, background: haveCount === ingredients.length ? "#f0fdf4" : "#fefce8", border: `1px solid ${haveCount === ingredients.length ? "#4ade8040" : "#fcd34d"}`, marginBottom: 20, fontSize: 13, color: haveCount === ingredients.length ? "#15803d" : "#92400e" }}>
            {haveCount === ingredients.length ? "✓ You have all ingredients!" : `You have ${haveCount} of ${ingredients.length} ingredients in your pantry`}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 2fr", gap: isMobile ? 16 : 24 }}>
            <div>
              <h3 style={{ fontSize: 15, fontWeight: 700, margin: "0 0 12px" }}>Ingredients</h3>
              {ingredients.map((ing, i) => {
                const inPantry = pantryMatches[i];
                return (
                  <div key={i} style={{ padding: "8px 0", borderBottom: "1px solid #f3f4f6", fontSize: 14, display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ fontSize: 16 }}>{inPantry ? "✓" : "✗"}</span>
                    <span style={{ color: inPantry ? "#15803d" : "#374151" }}>{getIngredientName(ing)}</span>
                  </div>
                );
              })}
              <div style={{ marginTop: 16 }}>
                {/* Primary actions: 2-up */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 12 }}>
                  <button onClick={() => setCookConfirm(recipe)} style={{ ...btnPrimary, fontSize: 13, display: "flex", alignItems: "center", justifyContent: "center", gap: 5, padding: "10px 0" }}>
                    <Icons.ChefHat style={{ width: 14, height: 14 }} /> Cook this
                  </button>
                  <button onClick={() => { setAddToPlannerModal(recipe); setPlannerDay(next7Days[0].value); }} style={{ ...btnSecondary, fontSize: 13, display: "flex", alignItems: "center", justifyContent: "center", gap: 5, padding: "10px 0" }}>
                    <Icons.Calendar style={{ width: 14, height: 14 }} /> Plan it
                  </button>
                </div>
                {/* Get ingredients section */}
                <div style={{ background: "#f8f7f4", borderRadius: 12, padding: 12 }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: "#9ca3af", letterSpacing: "0.06em", marginBottom: 8, textTransform: "uppercase" }}>Get ingredients</div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                    <a
                      href={`https://www.instacart.com/store?utm_source=ingrediable&utm_medium=recipe&utm_campaign=${encodeURIComponent((recipe.name as string) || "recipe")}`}
                      target="_blank" rel="noopener noreferrer"
                      style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, padding: "9px 0", background: "#43b02a", color: "#fff", borderRadius: 10, fontSize: 12, fontWeight: 700, textDecoration: "none" }}
                    >
                      🛒 Instacart
                    </a>
                    <a
                      href={`https://www.hellofresh.com/recipes?search=${encodeURIComponent(recipe.name as string)}&utm_source=ingrediable&utm_medium=recipe_detail`}
                      target="_blank" rel="noopener noreferrer"
                      style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, padding: "9px 0", background: "#fff", border: "2px solid #f97316", color: "#f97316", borderRadius: 10, fontSize: 12, fontWeight: 700, textDecoration: "none" }}
                    >
                      🥗 HelloFresh
                    </a>
                  </div>
                  {haveCount < ingredients.length && (
                    <button
                      onClick={() => addMissingToShop(recipe)}
                      style={{ width: "100%", fontSize: 12, marginTop: 8, display: "flex", alignItems: "center", justifyContent: "center", gap: 5, padding: "9px 0", background: "#fff", border: "1.5px solid #d1d5db", borderRadius: 10, cursor: "pointer", fontWeight: 600, color: "#374151", fontFamily: "inherit" }}
                    >
                      <Icons.Cart style={{ width: 13, height: 13 }} /> Add {ingredients.length - haveCount} missing to my shop list
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div>
              <h3 style={{ fontSize: 15, fontWeight: 700, margin: "0 0 12px" }}>Instructions</h3>
              {steps.map((step, i) => (
                <div key={i} style={{ display: "flex", gap: 14, marginBottom: 16 }}>
                  <div style={{ width: 28, height: 28, borderRadius: 14, background: "#2d5a27", color: "#fff", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{i + 1}</div>
                  <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6, paddingTop: 4 }}>{step}</p>
                </div>
              ))}
            </div>
          </div>
          </div>
        </Card>

        {/* Cook confirmation */}
        {cookConfirm && (() => {
          const _r = cookConfirm as Record<string, unknown>;
          const _ings = (_r.ingredients as Array<string | Record<string, unknown>>) || [];
          const _seen = new Set<string>();
          const _matches = _ings.map(ing => {
            const raw = getIngredientRawName(ing).toLowerCase();
            return (inventory || []).find((item: Record<string, unknown>) => {
              const n = ((item.name as string) || "").toLowerCase();
              const words = raw.split(" ").filter((w: string) => w.length > 3);
              return words.length > 0 && words.some((w: string) => n.includes(w));
            }) as Record<string, unknown> | undefined;
          }).filter((m): m is Record<string, unknown> => !!m && !_seen.has(m.id as string) && (_seen.add(m.id as string), true));
          return (
            <div style={{ position: "fixed", inset: 0, zIndex: 200, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
              <div style={{ background: "#fff", borderRadius: 16, padding: 28, maxWidth: 400, width: "100%", boxShadow: "0 24px 60px rgba(0,0,0,0.2)" }}>
                <h3 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 6px" }}>Cook {_r.name as string}?</h3>
                <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 14px" }}>Matching inventory items will be automatically deducted.</p>
                {_matches.length > 0 ? (
                  <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10, padding: "10px 12px", marginBottom: 16 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: "#15803d", marginBottom: 7, textTransform: "uppercase", letterSpacing: "0.04em" }}>Will deduct from inventory:</div>
                    <div style={{ display: "grid", gap: 4 }}>
                      {_matches.map(m => (
                        <div key={m.id as string} style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
                          <span style={{ fontWeight: 600 }}>{m.name as string}</span>
                          <span style={{ color: "#6b7280" }}>{m.quantity as number} {m.unit as string} → {Math.max(0, (m.quantity as number) - 1)} {m.unit as string}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 10, padding: "10px 12px", marginBottom: 16, fontSize: 13, color: "#6b7280" }}>
                    No matching items found in your inventory.
                  </div>
                )}
                <div style={{ display: "flex", gap: 10 }}>
                  <button onClick={() => setCookConfirm(null)} style={{ ...btnSecondary, flex: 1 }}>Cancel</button>
                  <button onClick={() => cookRecipe(_r)} style={{ ...btnPrimary, flex: 1 }}>Yes, cook it!</button>
                </div>
              </div>
            </div>
          );
        })()}

        {/* Add to planner modal */}
        {addToPlannerModal && (
          <div style={{ position: "fixed", inset: 0, zIndex: 200, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
            <div style={{ background: "#fff", borderRadius: 16, padding: 28, maxWidth: 380, width: "100%", boxShadow: "0 24px 60px rgba(0,0,0,0.2)" }}>
              <h3 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 16px" }}>Add to Planner</h3>
              <div style={{ marginBottom: 14 }}>
                <label style={labelStyle}>Day</label>
                <select style={selectStyle} value={plannerDay} onChange={e => setPlannerDay(e.target.value)}>
                  {next7Days.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>Meal</label>
                <div style={{ display: "flex", gap: 8 }}>
                  {(["breakfast", "lunch", "dinner"] as const).map(m => (
                    <button key={m} onClick={() => setPlannerMeal(m)} style={{ flex: 1, padding: "8px", borderRadius: 8, border: "none", background: plannerMeal === m ? "#2d5a27" : "#f3f4f6", color: plannerMeal === m ? "#fff" : "#6b7280", fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "inherit", textTransform: "capitalize" }}>{m}</button>
                  ))}
                </div>
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <button onClick={() => setAddToPlannerModal(null)} style={{ ...btnSecondary, flex: 1 }}>Cancel</button>
                <button onClick={() => addToPlanner(addToPlannerModal as Record<string, unknown>)} style={{ ...btnPrimary, flex: 1 }}>Add</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ── CREATE RECIPE FORM ──
  if (showCreate) {
    return (
      <div>
        <button onClick={() => { setShowCreate(false); setForm(blankRecipe); }} style={{ ...btnSecondary, marginBottom: 16, fontSize: 13 }}>← Back</button>
        <Card>
          <h2 style={{ fontSize: 20, fontWeight: 700, margin: "0 0 20px" }}>Create Recipe</h2>
          <div style={{ display: "grid", gap: 14 }}>
            <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "2fr 1fr 1fr", gap: 12 }}>
              <div><label style={labelStyle}>Recipe Name</label><input style={inputStyle} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="e.g. Chicken Stir Fry" /></div>
              <div><label style={labelStyle}>Cuisine</label><select style={selectStyle} value={form.cuisine} onChange={e => setForm(f => ({ ...f, cuisine: e.target.value }))}>{CUISINES.filter(c => c !== "All").map(c => <option key={c}>{c}</option>)}</select></div>
              <div><label style={labelStyle}>Difficulty</label><select style={selectStyle} value={form.difficulty} onChange={e => setForm(f => ({ ...f, difficulty: e.target.value }))}>{["Easy", "Medium", "Hard"].map(d => <option key={d}>{d}</option>)}</select></div>
            </div>
            <div><label style={labelStyle}>Description</label><input style={inputStyle} value={form.desc} onChange={e => setForm(f => ({ ...f, desc: e.target.value }))} placeholder="Short description..." /></div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
              <div><label style={labelStyle}>Prep (min)</label><input style={inputStyle} type="number" value={form.prep} onChange={e => setForm(f => ({ ...f, prep: parseInt(e.target.value) || 0 }))} /></div>
              <div><label style={labelStyle}>Cook (min)</label><input style={inputStyle} type="number" value={form.cook} onChange={e => setForm(f => ({ ...f, cook: parseInt(e.target.value) || 0 }))} /></div>
              <div><label style={labelStyle}>Servings</label><input style={inputStyle} type="number" value={form.servings} onChange={e => setForm(f => ({ ...f, servings: parseInt(e.target.value) || 1 }))} /></div>
            </div>

            <div>
              <label style={labelStyle}>Ingredients</label>
              {form.ingredients.map((ing, i) => (
                <div key={i} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                  <input style={{ ...inputStyle, flex: 1 }} placeholder="Ingredient name" value={ing.name} onChange={e => setForm(f => ({ ...f, ingredients: f.ingredients.map((x, j) => j === i ? { ...x, name: e.target.value } : x) }))} />
                  <input style={{ ...inputStyle, width: 70 }} placeholder="Qty" value={ing.qty} onChange={e => setForm(f => ({ ...f, ingredients: f.ingredients.map((x, j) => j === i ? { ...x, qty: e.target.value } : x) }))} />
                  <input style={{ ...inputStyle, width: 80 }} placeholder="Unit" value={ing.unit} onChange={e => setForm(f => ({ ...f, ingredients: f.ingredients.map((x, j) => j === i ? { ...x, unit: e.target.value } : x) }))} />
                  {form.ingredients.length > 1 && <button onClick={() => setForm(f => ({ ...f, ingredients: f.ingredients.filter((_, j) => j !== i) }))} style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}><Icons.X style={{ width: 16, height: 16, color: "#9ca3af" }} /></button>}
                </div>
              ))}
              <button onClick={() => setForm(f => ({ ...f, ingredients: [...f.ingredients, { name: "", qty: "", unit: "" }] }))} style={{ ...btnSecondary, fontSize: 13, padding: "8px 14px" }}>+ Add ingredient</button>
            </div>

            <div>
              <label style={labelStyle}>Steps</label>
              {form.steps.map((step, i) => (
                <div key={i} style={{ display: "flex", gap: 8, marginBottom: 8, alignItems: "flex-start" }}>
                  <div style={{ width: 28, height: 28, borderRadius: 14, background: "#2d5a27", color: "#fff", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 8 }}>{i + 1}</div>
                  <textarea style={{ ...inputStyle, resize: "vertical", minHeight: 56 }} placeholder={`Step ${i + 1}...`} value={step} onChange={e => setForm(f => ({ ...f, steps: f.steps.map((x, j) => j === i ? e.target.value : x) }))} />
                  {form.steps.length > 1 && <button onClick={() => setForm(f => ({ ...f, steps: f.steps.filter((_, j) => j !== i) }))} style={{ background: "none", border: "none", cursor: "pointer", padding: 4, marginTop: 8 }}><Icons.X style={{ width: 16, height: 16, color: "#9ca3af" }} /></button>}
                </div>
              ))}
              <button onClick={() => setForm(f => ({ ...f, steps: [...f.steps, ""] }))} style={{ ...btnSecondary, fontSize: 13, padding: "8px 14px" }}>+ Add step</button>
            </div>

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", paddingTop: 8 }}>
              <button onClick={() => { setShowCreate(false); setForm(blankRecipe); }} style={btnSecondary}>Cancel</button>
              <button onClick={saveRecipe} disabled={!form.name.trim()} style={{ ...btnPrimary, opacity: form.name.trim() ? 1 : 0.5 }}>Save Recipe</button>
            </div>
          </div>
        </Card>
      </div>
    );
  }

  // ── RECIPE LIST ──
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: isMobile ? 16 : 24, gap: 12, flexWrap: "wrap" }}>
        <div>
          <h1 style={{ fontSize: isMobile ? 24 : 28, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 4px" }}>Recipes</h1>
          <p style={{ color: "#6b7280", margin: 0, fontSize: 14 }}>Browse recipes and plan your meals.</p>
        </div>
        <button onClick={() => setShowCreate(true)} style={{ ...btnPrimary, display: "flex", alignItems: "center", gap: 6, fontSize: 13, flexShrink: 0 }}>
          <Icons.Plus style={{ width: 15, height: 15 }} /> New Recipe
        </button>
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", gap: 4, marginBottom: 16, background: "#f3f4f6", padding: 4, borderRadius: 12, width: "fit-content" }}>
        {[["browse", "Browse"], ["mine", "My Recipes"]].map(([t, label]) => (
          <button key={t} onClick={() => setTab(t as "browse" | "mine")} style={{ padding: "8px 18px", borderRadius: 8, border: "none", background: tab === t ? "#fff" : "transparent", color: tab === t ? "#1a1f16" : "#6b7280", fontWeight: tab === t ? 700 : 400, fontSize: 13, cursor: "pointer", fontFamily: "inherit", boxShadow: tab === t ? "0 1px 4px rgba(0,0,0,0.08)" : "none", transition: "all 0.2s" }}>{label}</button>
        ))}
      </div>

      {/* Filters */}
      <div style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap", alignItems: "center" }}>
        <div style={{ position: "relative", flex: "1 1 200px" }}>
          <Icons.Search style={{ width: 16, height: 16, position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }} />
          <input placeholder="Search recipes..." value={search} onChange={e => setSearch(e.target.value)} style={{ ...inputStyle, paddingLeft: 36 }} />
        </div>
        {/* Cuisine dropdown — all distinct areas from loaded recipes */}
        <div style={{ position: "relative" }}>
          <select
            value={cuisine}
            onChange={e => setCuisine(e.target.value)}
            style={{ appearance: "none", background: cuisine !== "All" ? "#2d5a27" : "#fff", color: cuisine !== "All" ? "#fff" : "#374151", border: `1.5px solid ${cuisine !== "All" ? "#2d5a27" : "#d1d5db"}`, borderRadius: 20, padding: "9px 36px 9px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", outline: "none" }}
          >
            {cuisineOptions.map(c => <option key={c} value={c}>{c === "All" ? "🌍 All Cuisines" : c}</option>)}
          </select>
          <span style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", fontSize: 16, color: cuisine !== "All" ? "#fff" : "#374151" }}>▾</span>
        </div>
      </div>

      {tab === "mine" && (userRecipes || []).length === 0 && (
        <Card style={{ textAlign: "center", padding: 48 }}>
          <div style={{ width: 64, height: 64, borderRadius: 20, background: "#f0fdf4", color: "#2d5a27", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}><Icons.ChefHat style={{ width: 32, height: 32 }} /></div>
          <h3 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 8px" }}>No recipes yet</h3>
          <p style={{ fontSize: 14, color: "#6b7280", margin: "0 0 20px" }}>Create your first recipe to check pantry availability and plan meals.</p>
          <button onClick={() => setShowCreate(true)} style={{ ...btnPrimary, fontSize: 13 }}>Create Recipe</button>
        </Card>
      )}

      {mealdbLoading && tab === "browse" && filtered.length === 0 && (
        <div style={{ textAlign: "center", padding: 48, color: "#9ca3af", fontSize: 14 }}>Loading recipes…</div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)", gap: isMobile ? 10 : 16 }}>
        {displayed.map((r: Record<string, unknown>) => {
          const ingredients = r.ingredients as Array<string | Record<string, unknown>>;
          const haveCount = ingredients.filter(ing => hasIngredient(getIngredientRawName(ing))).length;
          const pct = ingredients.length > 0 ? Math.round((haveCount / ingredients.length) * 100) : 0;
          return (
            <Card key={r.id as string} onClick={() => setSelected(r)} style={{ cursor: "pointer", padding: 0, overflow: "hidden" }}>
              {/* Recipe image with overlaid save/badge */}
              <div style={{ position: "relative", width: "100%", aspectRatio: "16/9", overflow: "hidden", background: "#f3f4f6" }}>
                {r.image
                  ? <img src={r.image as string} alt={r.name as string} style={{ width: "100%", height: "100%", objectFit: "cover" }} loading="lazy" />
                  : <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 32 }}>🍽️</div>
                }
                {/* Cuisine badge — bottom-left */}
                <span style={{ position: "absolute", bottom: 8, left: 8, fontSize: 10, fontWeight: 700, color: "#fff", background: "rgba(0,0,0,0.55)", padding: "3px 8px", borderRadius: 8, backdropFilter: "blur(4px)" }}>{r.cuisine as string}</span>
                {/* Save / My Recipe button — top-right */}
                {r.isTemplate ? (
                  (() => {
                    const cardSaved = isSaved(r.name as string);
                    return (
                      <button
                        onClick={e => { e.stopPropagation(); toggleSaveRecipe(r); }}
                        title={cardSaved ? "Saved — tap to remove" : "Save recipe"}
                        style={{ position: "absolute", top: 8, right: 8, background: cardSaved ? "#15803d" : "rgba(255,255,255,0.9)", border: "none", borderRadius: 20, padding: "4px 10px", cursor: "pointer", fontSize: 11, fontWeight: 700, color: cardSaved ? "#fff" : "#374151", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", gap: 4, transition: "all 0.2s" }}
                      >
                        {cardSaved ? "✓ Saved" : "+ Save"}
                      </button>
                    );
                  })()
                ) : (
                  <span style={{ position: "absolute", top: 8, right: 8, fontSize: 10, fontWeight: 700, color: "#6366f1", background: "rgba(238,242,255,0.92)", padding: "3px 8px", borderRadius: 8 }}>My Recipe</span>
                )}
              </div>
              <div style={{ padding: isMobile ? 10 : 14 }}>
                <h3 style={{ fontSize: 14, fontWeight: 700, margin: "0 0 4px", lineHeight: 1.3 }}>{r.name as string}</h3>
                <p style={{ fontSize: 11, color: "#6b7280", margin: "0 0 8px", lineHeight: 1.4, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{r.desc as string}</p>
                {/* Pantry bar */}
                <div style={{ marginBottom: 6 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: "#9ca3af", marginBottom: 2 }}>
                    <span>Pantry</span>
                    <span style={{ color: pct === 100 ? "#16a34a" : pct >= 50 ? "#ca8a04" : "#dc2626", fontWeight: 600 }}>{pct}%</span>
                  </div>
                  <div style={{ height: 3, background: "#f3f4f6", borderRadius: 2, overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${pct}%`, background: pct === 100 ? "#4ade80" : pct >= 50 ? "#fbbf24" : "#f87171", borderRadius: 2 }} />
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8, fontSize: 10, color: "#9ca3af" }}>
                  <span>{(r.prep as number) + (r.cook as number)}min</span>
                  <span>·</span>
                  <span style={{ color: diffColors[(r.difficulty as string)] || "#6b7280" }}>{r.difficulty as string}</span>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════
// PLANNER
// ═══════════════════════════════════════
function PlannerPage({ inventory, mealPlan, setMealPlan, userRecipes, setPage, isMobile }) {
  const [weekOffset, setWeekOffset] = useState(0);
  const [selectedDay, setSelectedDay] = useState<string | null>(null);
  const [addMealModal, setAddMealModal] = useState<{ day: string; meal: "breakfast" | "lunch" | "dinner" } | null>(null);
  const [recipeSearch, setRecipeSearch] = useState("");

  // Build 7-day window
  const days = useMemo(() => {
    return Array.from({ length: 7 }, (_, i) => {
      const d = new Date();
      d.setDate(d.getDate() + weekOffset * 7 + i);
      const iso = d.toISOString().slice(0, 10);
      const isToday = iso === new Date().toISOString().slice(0, 10);
      const label = i === 0 && weekOffset === 0 ? "Today" : d.toLocaleDateString("en-US", { weekday: "short" });
      const dateLabel = d.toLocaleDateString("en-US", { month: "short", day: "numeric" });

      // Items expiring on this day
      const expiringItems = (inventory || []).filter((item: Record<string, unknown>) => {
        const diff = daysBetween(d, item.expiry as string);
        return diff >= 0 && diff <= 0;
      });
      // Items expiring within 2 days of this date (show as dots)
      const warnItems = (inventory || []).filter((item: Record<string, unknown>) => {
        const itemDate = new Date(item.expiry as string);
        const dayDate = new Date(iso);
        const diff = Math.round((itemDate.getTime() - dayDate.getTime()) / 86400000);
        return diff >= 0 && diff <= 1;
      });

      const plan = ((mealPlan || {}) as Record<string, unknown>)[iso] as Record<string, unknown> | undefined;
      return { iso, label, dateLabel, isToday, expiringItems, warnItems, plan };
    });
  }, [weekOffset, inventory, mealPlan]);

  const allRecipes = [...SAMPLE_RECIPES.map(r => ({ ...r })), ...(userRecipes || [])];
  const filteredRecipes = allRecipes.filter(r => !recipeSearch || r.name.toLowerCase().includes(recipeSearch.toLowerCase()));

  function assignRecipe(day: string, meal: "breakfast" | "lunch" | "dinner", recipe: Record<string, unknown>) {
    setMealPlan((prev: Record<string, unknown>) => ({
      ...prev,
      [day]: { ...((prev || {})[day] || {}), [meal]: { recipeId: recipe.id, recipeName: recipe.name } },
    }));
    setAddMealModal(null);
    setRecipeSearch("");
  }

  function clearMeal(day: string, meal: string) {
    setMealPlan((prev: Record<string, unknown>) => {
      const dayPlan = { ...(((prev || {}) as Record<string, unknown>)[day] as Record<string, unknown> || {}) };
      delete dayPlan[meal];
      return { ...prev, [day]: dayPlan };
    });
  }

  const selectedDayData = selectedDay ? days.find(d => d.iso === selectedDay) : null;

  const MEAL_ICONS = { breakfast: "☀️", lunch: "🌤️", dinner: "🌙" };
  const MEAL_COLORS = { breakfast: "#fef3c7", lunch: "#ecfdf5", dinner: "#eff6ff" };
  const MEAL_BORDER = { breakfast: "#fcd34d", lunch: "#4ade80", dinner: "#93c5fd" };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: isMobile ? 16 : 24, flexWrap: "wrap", gap: 12 }}>
        <div>
          <h1 style={{ fontSize: isMobile ? 24 : 28, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 4px" }}>Meal Planner</h1>
          <p style={{ color: "#6b7280", margin: 0, fontSize: 14 }}>Plan your meals for the week and use up what's expiring.</p>
        </div>
        <button onClick={() => setPage("recipes")} style={{ ...btnSecondary, display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}>
          <Icons.Book style={{ width: 15, height: 15 }} /> Browse Recipes
        </button>
      </div>

      {/* Week navigation */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
        <button onClick={() => setWeekOffset(w => w - 1)} style={{ ...btnSecondary, padding: "8px 14px", fontSize: 13 }}>← Prev</button>
        <span style={{ fontSize: 14, fontWeight: 600, color: "#374151", flex: 1, textAlign: "center" }}>
          {weekOffset === 0 ? "This Week" : weekOffset === 1 ? "Next Week" : weekOffset === -1 ? "Last Week" : `Week of ${days[0]?.dateLabel}`}
        </span>
        <button onClick={() => setWeekOffset(w => w + 1)} style={{ ...btnSecondary, padding: "8px 14px", fontSize: 13 }}>Next →</button>
        {weekOffset !== 0 && <button onClick={() => setWeekOffset(0)} style={{ ...btnSecondary, padding: "8px 14px", fontSize: 12, color: "#6b7280" }}>Today</button>}
      </div>

      {/* Calendar grid */}
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(7, 1fr)" : "repeat(7, 1fr)", gap: isMobile ? 4 : 8, marginBottom: 24 }}>
        {days.map(day => {
          const meals = ["breakfast", "lunch", "dinner"] as const;
          const filledMeals = meals.filter(m => day.plan?.[m]);
          const isSelected = selectedDay === day.iso;
          return (
            <div
              key={day.iso}
              onClick={() => setSelectedDay(isSelected ? null : day.iso)}
              style={{
                background: isSelected ? "#1a1f16" : day.isToday ? "#f0fdf4" : "#fff",
                border: `2px solid ${isSelected ? "#4ade80" : day.isToday ? "#4ade8040" : "#e5e7eb"}`,
                borderRadius: 12, padding: isMobile ? "8px 4px" : "12px 10px", cursor: "pointer",
                transition: "all 0.2s", textAlign: "center",
                display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                gap: 3,
                minHeight: isMobile ? 72 : 90,
              }}
            >
              <div style={{ fontSize: isMobile ? 10 : 11, fontWeight: 600, color: isSelected ? "#9ca3af" : day.isToday ? "#2d5a27" : "#9ca3af", textTransform: "uppercase", letterSpacing: "0.05em" }}>{day.label}</div>
              <div style={{ fontSize: isMobile ? 15 : 18, fontWeight: 700, color: isSelected ? "#fff" : day.isToday ? "#2d5a27" : "#1a1f16" }}>{new Date(day.iso + "T12:00:00").getDate()}</div>
              {day.warnItems.length > 0 ? (
                <div style={{ fontSize: 9, fontWeight: 700, color: "#fff", background: "#dc2626", borderRadius: 8, padding: "1px 6px", lineHeight: 1.7 }}>
                  ⚠ {day.warnItems.length}
                </div>
              ) : isMobile && filledMeals.length > 0 ? (
                <div style={{ fontSize: 9, color: isSelected ? "#9ca3af" : "#6b7280" }}>{filledMeals.length} meal{filledMeals.length > 1 ? "s" : ""}</div>
              ) : !isMobile ? (
                <div style={{ display: "flex", gap: 3 }}>
                  {meals.map(m => (
                    <div key={m} style={{ width: 6, height: 6, borderRadius: 3, background: day.plan?.[m] ? (m === "breakfast" ? "#fbbf24" : m === "lunch" ? "#4ade80" : "#60a5fa") : "#e5e7eb" }} />
                  ))}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>

      {/* Day detail panel */}
      {selectedDayData && (
        <Card style={{ marginBottom: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>
              {selectedDayData.isToday ? "Today" : new Date(selectedDayData.iso + "T12:00:00").toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" })}
            </h3>
            {selectedDayData.warnItems.length > 0 && (
              <div style={{ fontSize: 12, color: "#dc2626", background: "#fef2f2", padding: "4px 10px", borderRadius: 20, fontWeight: 600 }}>
                {selectedDayData.warnItems.length} item{selectedDayData.warnItems.length > 1 ? "s" : ""} expiring
              </div>
            )}
          </div>

          {/* Expiring items warning */}
          {selectedDayData.warnItems.length > 0 && (
            <div style={{ padding: "10px 14px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 10, marginBottom: 16 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#dc2626", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.04em" }}>⚠ Expiring soon — plan a meal to use these up</div>
              <div style={{ display: "grid", gap: 5 }}>
                {selectedDayData.warnItems.map((item: Record<string, unknown>) => {
                  const daysLeft = daysBetween(new Date(selectedDayData.iso + "T12:00:00"), item.expiry as string);
                  const expiryLabel = daysLeft === 0 ? "expires today!" : daysLeft === 1 ? "expires tomorrow" : `expires ${fmt(item.expiry as string)}`;
                  return (
                    <div key={item.id as string} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", border: "1px solid #fecaca", padding: "6px 10px", borderRadius: 8 }}>
                      <span style={{ fontWeight: 600, fontSize: 13, color: "#1a1f16" }}>{item.name as string}</span>
                      <span style={{ fontSize: 11, fontWeight: 700, color: daysLeft === 0 ? "#dc2626" : "#ea580c" }}>{expiryLabel}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Meal slots */}
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: 12 }}>
            {(["breakfast", "lunch", "dinner"] as const).map(meal => {
              const planned = selectedDayData.plan?.[meal] as { recipeId: string; recipeName: string } | undefined;
              return (
                <div key={meal} style={{ background: MEAL_COLORS[meal], border: `1px solid ${MEAL_BORDER[meal]}`, borderRadius: 12, padding: 14, minHeight: 90 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 8, display: "flex", alignItems: "center", gap: 6, textTransform: "capitalize" }}>
                    <span>{MEAL_ICONS[meal]}</span> {meal}
                  </div>
                  {planned ? (
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 600, color: "#1a1f16", marginBottom: 8, lineHeight: 1.3 }}>{planned.recipeName}</div>
                      <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
                        <button onClick={() => { const r = allRecipes.find(x => x.id === planned.recipeId || String(x.id) === String(planned.recipeId)); if (r) { setSelectedDay(null); setPage("recipes"); } }} style={{ fontSize: 11, padding: "4px 10px", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", cursor: "pointer", color: "#374151", fontFamily: "inherit" }}>View</button>
                        <button onClick={() => clearMeal(selectedDayData.iso, meal)} style={{ fontSize: 11, padding: "4px 10px", borderRadius: 8, border: "1px solid #fecaca", background: "#fff", cursor: "pointer", color: "#dc2626", fontFamily: "inherit" }}>Remove</button>
                      </div>
                      <a
                        href={`https://www.hellofresh.com/recipes?search=${encodeURIComponent(planned.recipeName)}&utm_source=ingrediable&utm_medium=planner`}
                        target="_blank" rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 5, padding: "5px 0", background: "#fff", border: "2px solid #f97316", color: "#f97316", borderRadius: 8, fontSize: 11, fontWeight: 700, textDecoration: "none", width: "100%" }}
                      >
                        🥗 HelloFresh kit
                      </a>
                    </div>
                  ) : (
                    <button onClick={() => setAddMealModal({ day: selectedDayData.iso, meal })} style={{ fontSize: 12, color: "#6b7280", background: "rgba(255,255,255,0.6)", border: "1px dashed #d1d5db", borderRadius: 8, padding: "8px 12px", cursor: "pointer", width: "100%", fontFamily: "inherit" }}>
                      + Add {meal}
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </Card>
      )}

      {/* Weekly summary */}
      <Card>
        <h3 style={{ fontSize: 15, fontWeight: 700, margin: "0 0 14px" }}>This Week at a Glance</h3>
        <div style={{ display: "grid", gap: 6 }}>
          {days.map(day => {
            const meals = ["breakfast", "lunch", "dinner"] as const;
            const anyMeal = meals.some(m => day.plan?.[m]);
            if (!anyMeal && day.warnItems.length === 0) return null;
            return (
              <div key={day.iso} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 12px", background: "#f8f7f4", borderRadius: 10, cursor: "pointer" }} onClick={() => setSelectedDay(day.iso)}>
                <div style={{ minWidth: 60 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: "#9ca3af" }}>{day.label}</div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1f16" }}>{day.dateLabel}</div>
                </div>
                <div style={{ flex: 1, display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {meals.map(m => day.plan?.[m] && (
                    <span key={m} style={{ fontSize: 12, background: MEAL_COLORS[m], border: `1px solid ${MEAL_BORDER[m]}`, padding: "2px 10px", borderRadius: 20, color: "#374151" }}>
                      {MEAL_ICONS[m]} {(day.plan[m] as { recipeName: string }).recipeName}
                    </span>
                  ))}
                  {day.warnItems.length > 0 && (
                    <span style={{ fontSize: 12, background: "#fef2f2", border: "1px solid #fecaca", padding: "2px 10px", borderRadius: 20, color: "#dc2626" }}>
                      ⚠ {day.warnItems.length} expiring
                    </span>
                  )}
                </div>
              </div>
            );
          })}
          {days.every(day => !["breakfast", "lunch", "dinner"].some(m => day.plan?.[m]) && day.warnItems.length === 0) && (
            <p style={{ color: "#9ca3af", fontSize: 14, margin: 0, textAlign: "center", padding: "16px 0" }}>No meals planned yet. Click a day above to start!</p>
          )}
        </div>
      </Card>

      {/* Add meal modal */}
      {addMealModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 200, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: isMobile ? "flex-end" : "center", justifyContent: "center", padding: isMobile ? 0 : 24 }}>
          <div style={{ background: "#fff", borderRadius: isMobile ? "20px 20px 0 0" : 16, padding: 24, width: "100%", maxWidth: isMobile ? "100%" : 440, maxHeight: "80vh", overflow: "auto", boxShadow: "0 24px 60px rgba(0,0,0,0.2)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <h3 style={{ fontSize: 17, fontWeight: 700, margin: 0, textTransform: "capitalize" }}>Add {addMealModal.meal}</h3>
              <button onClick={() => { setAddMealModal(null); setRecipeSearch(""); }} style={{ background: "#f3f4f6", border: "none", borderRadius: 8, width: 32, height: 32, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><Icons.X style={{ width: 15, height: 15 }} /></button>
            </div>
            <input placeholder="Search recipes..." value={recipeSearch} onChange={e => setRecipeSearch(e.target.value)} style={{ ...inputStyle, marginBottom: 14 }} />
            <div style={{ display: "grid", gap: 8 }}>
              {filteredRecipes.map((r: Record<string, unknown>) => (
                <button key={r.id as string} onClick={() => assignRecipe(addMealModal.day, addMealModal.meal, r)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 14px", borderRadius: 10, border: "1px solid #e5e7eb", background: "#fff", cursor: "pointer", fontFamily: "inherit", textAlign: "left", width: "100%" }}>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#1a1f16" }}>{r.name as string}</div>
                    <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>{r.cuisine as string} · {(r.prep as number) + (r.cook as number)}min</div>
                  </div>
                  <Icons.Plus style={{ width: 16, height: 16, color: "#2d5a27", flexShrink: 0 }} />
                </button>
              ))}
              {filteredRecipes.length === 0 && <p style={{ color: "#9ca3af", fontSize: 14, textAlign: "center", margin: "16px 0" }}>No recipes found</p>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════
// WASTE TRACKING
// ═══════════════════════════════════════
function WastePage({ wasteLog, setWasteLog, inventory, setPage, isMobile }) {
  const [period, setPeriod] = useState("month");

  const sampleWaste = useMemo(() => {
    if (wasteLog.length > 0) return wasteLog;
    return [
      { id: "w1", name: "Spinach", category: "Produce", reason: "expired", cost: "3.49", date: "2026-03-10" },
      { id: "w2", name: "Yogurt", category: "Dairy", reason: "expired", cost: "4.29", date: "2026-03-08" },
      { id: "w3", name: "Bread", category: "Bakery", reason: "expired", cost: "3.99", date: "2026-03-05" },
      { id: "w4", name: "Avocados", category: "Produce", reason: "damaged", cost: "5.98", date: "2026-03-03" },
      { id: "w5", name: "Chicken Thighs", category: "Meat", reason: "expired", cost: "7.99", date: "2026-02-28" },
      { id: "w6", name: "Milk", category: "Dairy", reason: "expired", cost: "4.59", date: "2026-02-25" },
      { id: "w7", name: "Leftovers", category: "Other", reason: "removed", cost: "6.00", date: "2026-02-20" },
      { id: "w8", name: "Berries", category: "Produce", reason: "damaged", cost: "5.99", date: "2026-02-15" },
    ];
  }, [wasteLog]);

  const totalCost = sampleWaste.reduce((s, w) => s + parseFloat(w.cost), 0).toFixed(2);
  const byReason = {};
  sampleWaste.forEach(w => { byReason[w.reason] = (byReason[w.reason] || 0) + parseFloat(w.cost); });
  const reasonColors = { expired: "#dc2626", removed: "#ca8a04", damaged: "#6366f1" };

  // Risk assessment for current inventory
  const riskItems = inventory.filter(i => {
    const d = daysBetween(today, i.expiry);
    return d >= 0 && d <= 7;
  }).map(i => {
    const d = daysBetween(today, i.expiry);
    const prob = Math.max(10, Math.min(95, 100 - d * 13));
    const cat = (i.category || "").toLowerCase();
    const baseEstLoss =
      cat.includes("meat") || cat.includes("poultry") || cat.includes("seafood") || cat.includes("fish") ? 10.0 :
      cat.includes("dairy") || cat.includes("cheese") || cat.includes("egg") ? 5.0 :
      cat.includes("produce") || cat.includes("fruit") || cat.includes("vegetable") || cat.includes("veg") ? 4.0 :
      cat.includes("bakery") || cat.includes("bread") ? 3.0 :
      cat.includes("frozen") ? 7.0 :
      cat.includes("deli") || cat.includes("prepared") ? 6.0 :
      4.5; // default
    const qty = typeof i.quantity === "number" && i.quantity > 1 ? Math.min(i.quantity, 4) : 1;
    const estLoss = (baseEstLoss * qty * (prob / 100)).toFixed(2);
    return { ...i, risk: d <= 2 ? "High" : d <= 4 ? "Medium" : "Low", probability: prob, estLoss };
  }).sort((a, b) => b.probability - a.probability);

  const riskColors = { High: "#dc2626", Medium: "#ca8a04", Low: "#16a34a" };
  const maxCost = Math.max(...Object.values(byReason), 1);

  if (wasteLog.length === 0) {
    return (
      <div>
        <h1 style={{ fontSize: 28, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 6px" }}>Waste Tracking</h1>
        <p style={{ color: "#6b7280", margin: "0 0 24px", fontSize: 14 }}>Monitor and reduce food waste with insights and predictions.</p>
        <Card style={{ padding: 48, textAlign: "center" }}>
          <div style={{ width: 72, height: 72, borderRadius: 20, background: "#f0fdf4", color: "#2d5a27", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <Icons.Chart style={{ width: 36, height: 36 }} />
          </div>
          <h2 style={{ fontSize: 22, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 8px", color: "#1a1f16" }}>No waste logged yet</h2>
          <p style={{ fontSize: 15, color: "#6b7280", margin: "0 0 24px", maxWidth: 360, marginLeft: "auto", marginRight: "auto" }}>When you remove items from inventory or mark them as wasted, they&apos;ll show up here so you can track cost and reduce waste.</p>
          {setPage && <button type="button" onClick={() => setPage("inventory")} style={{ ...btnPrimary, display: "inline-flex", alignItems: "center", gap: 8 }}><Icons.Box style={{ width: 18, height: 18 }} /> Go to Inventory</button>}
        </Card>
      </div>
    );
  }

  return (
    <div>
      <h1 style={{ fontSize: 28, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 6px" }}>Waste Tracking</h1>
      <p style={{ color: "#6b7280", margin: "0 0 24px", fontSize: 14 }}>Monitor and reduce food waste with insights and predictions.</p>

      {/* Period Toggle */}
      <div style={{ display: "flex", gap: 6, marginBottom: 20 }}>
        {["week", "month", "quarter", "year"].map(p => (
          <button key={p} onClick={() => setPeriod(p)} style={{ padding: "8px 16px", borderRadius: 20, border: "none", background: period === p ? "#2d5a27" : "#f3f4f6", color: period === p ? "#fff" : "#6b7280", fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "inherit", textTransform: "capitalize" }}>{p}</button>
        ))}
      </div>

      {/* Stats Row */}
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: isMobile ? 10 : 16, marginBottom: 24 }}>
        <Card style={{ padding: 20 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#dc2626", textTransform: "uppercase", letterSpacing: "0.05em" }}>Total Waste Cost</div>
          <div style={{ fontSize: 32, fontWeight: 700, fontFamily: "'DM Serif Display', serif", color: "#dc2626" }}>${totalCost}</div>
        </Card>
        <Card style={{ padding: 20 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em" }}>Items Wasted</div>
          <div style={{ fontSize: 32, fontWeight: 700, fontFamily: "'DM Serif Display', serif" }}>{sampleWaste.length}</div>
        </Card>
        <Card style={{ padding: 20 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#16a34a", textTransform: "uppercase", letterSpacing: "0.05em" }}>Potential Savings</div>
          <div style={{ fontSize: 32, fontWeight: 700, fontFamily: "'DM Serif Display', serif", color: "#16a34a" }}>${(totalCost * 0.6).toFixed(2)}</div>
        </Card>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: isMobile ? 12 : 20, marginBottom: 24 }}>
        {/* Waste by Reason Chart */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 20px" }}>Waste by Reason</h3>
          {Object.entries(byReason).map(([reason, cost]) => (
            <div key={reason} style={{ marginBottom: 16 }}>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 6 }}>
                <span style={{ fontWeight: 600, textTransform: "capitalize" }}>{reason}</span>
                <span style={{ fontWeight: 700, color: reasonColors[reason] }}>${cost.toFixed(2)}</span>
              </div>
              <div style={{ height: 12, background: "#f3f4f6", borderRadius: 6, overflow: "hidden" }}>
                <div style={{ height: "100%", width: `${(cost / maxCost) * 100}%`, background: reasonColors[reason], borderRadius: 6, transition: "width 0.5s" }} />
              </div>
            </div>
          ))}
        </Card>

        {/* Top Wasted Items */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 16px" }}>Top Wasted Items</h3>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ borderBottom: "2px solid #e5e7eb" }}>
                {["Item", "Reason", "Cost"].map(h => <th key={h} style={{ padding: "8px 0", textAlign: "left", fontSize: 11, fontWeight: 700, color: "#6b7280", textTransform: "uppercase" }}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {sampleWaste.slice(0, 6).map(w => (
                <tr key={w.id} style={{ borderBottom: "1px solid #f3f4f6" }}>
                  <td style={{ padding: "10px 0", fontWeight: 600 }}>{w.name}</td>
                  <td style={{ padding: "10px 0" }}><span style={{ fontSize: 11, fontWeight: 600, color: reasonColors[w.reason], textTransform: "capitalize" }}>{w.reason}</span></td>
                  <td style={{ padding: "10px 0", fontWeight: 600 }}>${w.cost}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>

      {/* Risk Predictions */}
      <Card>
        <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 4px" }}>Waste Risk Predictions</h3>
        <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 16px" }}>ML-powered predictions for items at risk of being wasted.</p>
        {riskItems.length === 0 ? <p style={{ color: "#9ca3af", fontSize: 14 }}>No items currently at risk.</p> :
          <div style={{ display: "grid", gap: 8 }}>
            {riskItems.map(item => (
              <div key={item.id} style={{ display: "flex", alignItems: "center", gap: 16, padding: "12px 16px", background: "#f9fafb", borderRadius: 10 }}>
                <span style={{ fontWeight: 600, flex: 1 }}>{item.name}</span>
                <span style={{ fontSize: 12, fontWeight: 700, color: riskColors[item.risk], background: `${riskColors[item.risk]}15`, padding: "3px 12px", borderRadius: 20 }}>{item.risk} Risk</span>
                <div style={{ width: 100, display: "flex", alignItems: "center", gap: 6 }}>
                  <div style={{ flex: 1, height: 6, background: "#e5e7eb", borderRadius: 3, overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${item.probability}%`, background: riskColors[item.risk], borderRadius: 3 }} />
                  </div>
                  <span style={{ fontSize: 11, fontWeight: 700, color: "#6b7280" }}>{item.probability}%</span>
                </div>
                <span style={{ fontSize: 13, fontWeight: 600, color: "#dc2626", minWidth: 50 }}>~${item.estLoss}</span>
              </div>
            ))}
          </div>
        }
      </Card>
    </div>
  );
}

// ═══════════════════════════════════════
// ALERTS PAGE
// ═══════════════════════════════════════
function AlertsPage({ alerts, setAlerts, resolveAlert: resolveAlertProp, removeAlert: removeAlertProp, isMobile }) {
  const [filter, setFilter] = useState("all");
  const sevColors = { critical: "#dc2626", high: "#ea580c", medium: "#ca8a04", low: "#6b7280" };
  const sevBg = { critical: "#fef2f2", high: "#fff7ed", medium: "#fefce8", low: "#f9fafb" };

  const filtered = alerts.filter(a => {
    if (filter === "unresolved") return !a.resolved;
    if (filter === "resolved") return a.resolved;
    return true;
  });

  async function resolveAlert(id) {
    if (resolveAlertProp) await resolveAlertProp(id);
    else setAlerts(prev => prev.map(a => a.id === id ? { ...a, resolved: true } : a));
  }

  async function deleteAlert(id) {
    if (removeAlertProp) await removeAlertProp(id);
    else setAlerts(prev => prev.filter(a => a.id !== id));
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <h1 style={{ fontSize: 28, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: 0 }}>Alerts</h1>
          <p style={{ color: "#6b7280", margin: "4px 0 0", fontSize: 14 }}>{alerts.filter(a => !a.resolved).length} unresolved alerts</p>
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          {[["all", "All"], ["unresolved", "Active"], ["resolved", "Resolved"]].map(([val, label]) => (
            <button key={val} onClick={() => setFilter(val)} style={{ padding: "8px 16px", borderRadius: 20, border: "none", background: filter === val ? "#2d5a27" : "#f3f4f6", color: filter === val ? "#fff" : "#6b7280", fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>{label}</button>
          ))}
        </div>
      </div>

      <div style={{ display: "grid", gap: 10 }}>
        {filtered.length === 0 && (
          <Card style={{ textAlign: "center", padding: 48 }}>
            <div style={{ width: 64, height: 64, borderRadius: 20, background: "#f0fdf4", color: "#2d5a27", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
              <Icons.Check style={{ width: 32, height: 32 }} />
            </div>
            <h3 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 6px", color: "#1a1f16" }}>You&apos;re all caught up</h3>
            <p style={{ fontSize: 14, color: "#6b7280", margin: 0 }}>No alerts right now. We&apos;ll notify you when items are expiring or running low.</p>
          </Card>
        )}
        {filtered.map(a => (
          <Card key={a.id} style={{ padding: 16, display: "flex", alignItems: "center", gap: 14, background: a.resolved ? "#fafafa" : sevBg[a.severity], opacity: a.resolved ? 0.6 : 1, border: `1px solid ${a.resolved ? "#e5e7eb" : sevColors[a.severity]}20` }}>
            <div style={{ width: 10, height: 10, borderRadius: 5, background: sevColors[a.severity], flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: 14 }}>{a.message}</div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>{a.type.replace("_", " ")} · {a.severity} · {fmt(a.date)}</div>
            </div>
            {!a.resolved && <button onClick={() => resolveAlert(a.id)} style={{ ...btnSecondary, padding: "6px 14px", fontSize: 12 }}>Resolve</button>}
            <button onClick={() => deleteAlert(a.id)} style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}><Icons.X style={{ width: 14, height: 14, color: "#9ca3af" }} /></button>
          </Card>
        ))}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════
// HOUSEHOLD
// ═══════════════════════════════════════
function HouseholdPage({ settings, isMobile, activeHousehold, householdList = [], switchHousehold, joinHousehold, createHousehold, initialJoinCode, removeMember, currentUserId }: { settings: any; isMobile: boolean; activeHousehold?: Record<string, unknown> | null; householdList?: Array<{ household: Record<string, unknown>; role?: string; joined_at?: string }>; switchHousehold?: (id: string) => void; joinHousehold?: (code: string) => Promise<{ id: string }>; createHousehold?: (name: string) => Promise<Record<string, unknown>>; initialJoinCode?: string; removeMember?: (householdId: string, userId: string) => Promise<void>; currentUserId?: string }) {
  const roleColors = { owner: "#2d5a27", admin: "#1e3a5f", member: "#6b7280", viewer: "#9ca3af" };
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [inviteCode, setInviteCode] = useState<string>("");
  const [members, setMembers] = useState<Array<{ userId?: string; name: string; email?: string; role: string; joined?: string }>>([]);
  const [joinCode, setJoinCode] = useState(initialJoinCode ?? "");
  const [joinStatus, setJoinStatus] = useState<{ type: "ok" | "err"; text: string } | null>(null);
  const [createName, setCreateName] = useState("");
  const [createStatus, setCreateStatus] = useState<{ type: "ok" | "err"; text: string } | null>(null);

  useEffect(() => {
    const hhId = (activeHousehold as { id?: string } | null)?.id;
    if (!hhId) return;
    setLoading(true);
    setLoadError(null);
    (async () => {
      try {
        const { households } = await import("./lib/api-service");
        const hh = await households.get(hhId);
        const code = (hh as { invite_code?: string })?.invite_code ?? "";
        const rawMembers = (hh as { members?: Array<{ role?: string; joined_at?: string; profile?: { id?: string; display_name?: string; email?: string } }> })?.members ?? [];
        setInviteCode(code);
        setMembers(
          rawMembers.map((m) => ({
            userId: m.profile?.id,
            name: m.profile?.display_name ?? "Member",
            email: m.profile?.email,
            role: (m.role ?? "member").toString(),
            joined: m.joined_at ? new Date(m.joined_at).toLocaleDateString("en-US", { month: "short", year: "numeric" }) : undefined,
          }))
        );
      } catch (err) {
        setLoadError(err instanceof Error ? err.message : "Failed to load household");
      } finally {
        setLoading(false);
      }
    })();
  }, [(activeHousehold as { id?: string } | null)?.id]);

  const activeId = (activeHousehold as { id?: string } | null)?.id ?? "";
  const activeRole = householdList.find((h) => (h.household as { id?: string })?.id === activeId)?.role ?? null;
  const canManageMembers = activeRole === "owner";

  return (
    <div>
      <h1 style={{ fontSize: 28, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 6px" }}>Household</h1>
      <p style={{ color: "#6b7280", margin: "0 0 24px", fontSize: 14 }}>Manage your household members and shared access.</p>

      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "2fr 1fr", gap: isMobile ? 12 : 20 }}>
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 16px" }}>Members</h3>
          {loading && <div style={{ fontSize: 13, color: "#9ca3af" }}>Loading members…</div>}
          {loadError && <div style={{ fontSize: 13, color: "#dc2626" }}>{loadError}</div>}
          {!loading && !loadError && members.length === 0 && <div style={{ fontSize: 13, color: "#9ca3af" }}>No members yet.</div>}
          {members.map((m, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 0", borderBottom: "1px solid #f3f4f6" }}>
              <div style={{ width: 40, height: 40, borderRadius: 20, background: `${roleColors[(m.role || "member").toLowerCase()] ?? roleColors.member}20`, color: roleColors[(m.role || "member").toLowerCase()] ?? roleColors.member, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 16 }}>{(m.name || "M")[0]}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{m.name}</div>
                <div style={{ fontSize: 12, color: "#9ca3af" }}>{m.email || "—"}</div>
              </div>
              <span style={{ fontSize: 12, fontWeight: 700, color: roleColors[(m.role || "member").toLowerCase()] ?? roleColors.member, background: `${roleColors[(m.role || "member").toLowerCase()] ?? roleColors.member}15`, padding: "3px 12px", borderRadius: 20, textTransform: "capitalize" }}>{m.role}</span>
              <div style={{ fontSize: 12, color: "#9ca3af" }}>{m.joined ? `Since ${m.joined}` : ""}</div>
              {canManageMembers && m.userId && m.userId !== currentUserId && !!removeMember && (
                <button
                  type="button"
                  onClick={async () => {
                    if (!activeId) return;
                    await removeMember(activeId, m.userId as string);
                    // Refresh members list in-place
                    setMembers((prev) => prev.filter((x) => x.userId !== m.userId));
                  }}
                  style={{ background: "#fef2f2", border: "none", borderRadius: 8, width: 32, height: 32, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                  title="Remove member"
                >
                  <Icons.X style={{ width: 14, height: 14, color: "#dc2626" }} />
                </button>
              )}
            </div>
          ))}
        </Card>

        <div style={{ display: "grid", gap: 20, alignContent: "start" }}>
          <Card>
            <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 12px" }}>{settings.household}</h3>
            {householdList.length > 1 && !!switchHousehold && (
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 6 }}>Switch household</div>
                <select
                  style={{ ...selectStyle, width: "100%" }}
                  value={((activeHousehold as { id?: string } | null)?.id as string) ?? ""}
                  onChange={(e) => switchHousehold(e.target.value)}
                >
                  {householdList.map((h) => (
                    <option key={(h.household as { id?: string })?.id} value={(h.household as { id?: string })?.id}>
                      {(h.household as { name?: string })?.name ?? "Household"}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 12 }}>{members.length} member{members.length === 1 ? "" : "s"}</div>
            {activeRole && activeRole !== "owner" && !!removeMember && !!currentUserId && !!activeId && (
              <button
                type="button"
                onClick={async () => {
                  await removeMember(activeId, currentUserId);
                }}
                style={{ ...btnSecondary, width: "100%", fontSize: 13, marginBottom: 10, background: "#fff7ed", border: "2px solid #fed7aa", color: "#c2410c" }}
              >
                Leave household
              </button>
            )}
            <div style={{ padding: 14, background: "#f9fafb", borderRadius: 10, textAlign: "center" }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 6 }}>Invite Code</div>
              <div style={{ fontSize: 20, fontWeight: 700, fontFamily: "monospace", letterSpacing: "0.1em", color: "#2d5a27", marginBottom: 10 }}>{inviteCode || "—"}</div>
              <div style={{ display: "flex", gap: 8 }}>
                <button
                  type="button"
                  disabled={!inviteCode}
                  onClick={async () => {
                    try {
                      await navigator.clipboard.writeText(inviteCode);
                      setJoinStatus({ type: "ok", text: "Code copied." });
                      setTimeout(() => setJoinStatus(null), 2500);
                    } catch {
                      setJoinStatus({ type: "err", text: "Couldn't copy. Select and copy manually." });
                    }
                  }}
                  style={{ ...btnSecondary, flex: 1, fontSize: 13 }}
                >
                  Copy code
                </button>
                <button
                  type="button"
                  disabled={!inviteCode}
                  onClick={async () => {
                    const base =
                      typeof window !== "undefined" && window.location.origin
                        ? window.location.origin
                        : "https://ingrediable.com";
                    const url = `${base}/?join=${inviteCode}`;
                    try {
                      await navigator.clipboard.writeText(url);
                      setJoinStatus({ type: "ok", text: "Invite link copied." });
                      setTimeout(() => setJoinStatus(null), 2500);
                    } catch {
                      setJoinStatus({ type: "err", text: "Couldn't copy link. Select and copy manually." });
                    }
                  }}
                  style={{ ...btnPrimary, flex: 1, fontSize: 13 }}
                >
                  Copy invite link
                </button>
              </div>
            </div>
          </Card>
          <Card>
            <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 8px" }}>Create a household</h3>
            <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 12px" }}>Start a new kitchen and invite others.</p>
            <input
              value={createName}
              onChange={(e) => setCreateName(e.target.value)}
              placeholder="e.g. Roommates"
              style={inputStyle}
            />
            {createStatus && (
              <div style={{ marginTop: 10, fontSize: 13, color: createStatus.type === "ok" ? "#16a34a" : "#dc2626" }}>
                {createStatus.text}
              </div>
            )}
            <button
              type="button"
              disabled={!createHousehold || !createName.trim()}
              onClick={async () => {
                setCreateStatus(null);
                try {
                  if (!createHousehold) throw new Error("Create is not available.");
                  await createHousehold(createName.trim());
                  setCreateName("");
                  setCreateStatus({ type: "ok", text: "Household created." });
                  setTimeout(() => setCreateStatus(null), 2500);
                } catch (err) {
                  setCreateStatus({ type: "err", text: err instanceof Error ? err.message : "Failed to create household" });
                }
              }}
              style={{ ...btnPrimary, width: "100%", fontSize: 13, marginTop: 10 }}
            >
              Create
            </button>
          </Card>
          <Card>
            <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 8px" }}>Join a household</h3>
            <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 12px" }}>Paste an invite code to join someone else’s household.</p>
            <input
              value={joinCode}
              onChange={(e) => setJoinCode(e.target.value)}
              placeholder="e.g. INGRD-7X9K2"
              style={{ ...inputStyle, fontFamily: "monospace", letterSpacing: "0.04em" }}
            />
            {joinStatus && (
              <div style={{ marginTop: 10, fontSize: 13, color: joinStatus.type === "ok" ? "#16a34a" : "#dc2626" }}>
                {joinStatus.text}
              </div>
            )}
            <button
              type="button"
              disabled={!joinHousehold || !joinCode.trim()}
              onClick={async () => {
                setJoinStatus(null);
                try {
                  if (!joinHousehold) throw new Error("Join is not available.");
                  await joinHousehold(joinCode.trim());
                  setJoinCode("");
                  setJoinStatus({ type: "ok", text: "Joined. Switching households…" });
                } catch (err) {
                  setJoinStatus({ type: "err", text: err instanceof Error ? err.message : "Failed to join household" });
                }
              }}
              style={{ ...btnPrimary, width: "100%", fontSize: 13, marginTop: 10 }}
            >
              Join
            </button>
          </Card>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════
// CIRCLES
// ═══════════════════════════════════════
function CirclesPage({ circles = [], circlesLoading = false, onCreateCircle, onJoinCircle, onLeaveCircle, onUpdateSharing, requests = [], onCreateRequest, onUpdateStatus, householdId, activeHousehold, currentUserId, isMobile, addShopItem, setShopList, shopList = [] }: {
  circles?: any[]; circlesLoading?: boolean;
  onCreateCircle?: (name: string, desc: string) => Promise<any>;
  onJoinCircle?: (code: string) => Promise<any>;
  onLeaveCircle?: (circleId: string) => Promise<void>;
  onUpdateSharing?: (circleId: string, enabled: boolean, cats?: string[] | null) => Promise<void>;
  requests?: any[];
  onCreateRequest?: (req: any) => Promise<any>;
  onUpdateStatus?: (id: string, status: string) => Promise<void>;
  householdId?: string;
  activeHousehold?: any;
  currentUserId?: string;
  isMobile?: boolean;
  addShopItem?: (item: Record<string, unknown>) => Promise<unknown>;
  setShopList?: (fn: (prev: any[]) => any[]) => void;
  shopList?: any[];
}) {
  const [view, setView] = useState<"list" | "circle" | "request">("list");
  const [selectedCircle, setSelectedCircle] = useState<any>(null);
  const [selectedRequest, setSelectedRequest] = useState<any>(null);
  const [circleTab, setCircleTab] = useState<"browse" | "requests" | "chat" | "orders">("browse");
  const [showCreate, setShowCreate] = useState(false);
  const [showJoin, setShowJoin] = useState(false);
  const [showNewReq, setShowNewReq] = useState(false);
  const [sharedInventory, setSharedInventory] = useState<any[]>([]);
  const [members, setMembers] = useState<any[]>([]);
  const [messages, setMessages] = useState<any[]>([]);
  const [reqMessages, setReqMessages] = useState<any[]>([]);
  const [msgInput, setMsgInput] = useState("");
  const [reqMsgInput, setReqMsgInput] = useState("");
  const [loadingShared, setLoadingShared] = useState(false);

  // Group orders state
  const [groupOrders, setGroupOrders] = useState<any[]>([]);
  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const [orderItems, setOrderItems] = useState<any[]>([]);
  const [showCreateOrder, setShowCreateOrder] = useState(false);
  const [showAddItems, setShowAddItems] = useState(false);
  const [orderLoading, setOrderLoading] = useState(false);
  const [myOrderItems, setMyOrderItems] = useState<Array<{item_name: string; quantity: string; unit: string; notes: string}>>([{ item_name: "", quantity: "1", unit: "", notes: "" }]);
  const [createOrderForm, setCreateOrderForm] = useState({ store_name: "Costco", pickup_day: "Saturday", deadline_days: "3", notes: "" });
  const [copyToast, setCopyToast] = useState<string | null>(null);

  // Realtime subscription refs — cleaned up when leaving a circle/request
  const circleChatChannelRef = useRef<any>(null);
  const reqChatChannelRef = useRef<any>(null);

  function unsubCircleChat() {
    if (circleChatChannelRef.current) {
      circleChatChannelRef.current.unsubscribe?.();
      circleChatChannelRef.current = null;
    }
  }
  function unsubReqChat() {
    if (reqChatChannelRef.current) {
      reqChatChannelRef.current.unsubscribe?.();
      reqChatChannelRef.current = null;
    }
  }

  // Form state
  const [createName, setCreateName] = useState("");
  const [createDesc, setCreateDesc] = useState("");
  const [joinCode, setJoinCode] = useState("");
  const [formErr, setFormErr] = useState<string | null>(null);
  const [formLoading, setFormLoading] = useState(false);
  const [sharingEnabled, setSharingEnabled] = useState(false);

  // New request form
  const [reqItem, setReqItem] = useState("");
  const [reqQty, setReqQty] = useState("1");
  const [reqUnit, setReqUnit] = useState("");
  const [reqNote, setReqNote] = useState("");
  const [reqTargetHousehold, setReqTargetHousehold] = useState("");
  const [reqTargetItem, setReqTargetItem] = useState<any | null>(null);

  // householdId prop may be undefined — fall back to activeHousehold.id from pageProps
  const hid: string | undefined = householdId ?? (activeHousehold as any)?.id;

  const statusColors: Record<string, string> = { pending: "#ca8a04", accepted: "#16a34a", rejected: "#dc2626", completed: "#6366f1", cancelled: "#9ca3af", expired: "#9ca3af" };
  const statusBg: Record<string, string> = { pending: "#fefce8", accepted: "#f0fdf4", rejected: "#fef2f2", completed: "#eef2ff", cancelled: "#f9fafb", expired: "#f9fafb" };

  async function loadGroupOrders(circleId: string) {
    const { groupOrdersApi } = await import("./lib/api-service").catch(() => ({} as any));
    if (!groupOrdersApi) return;
    const orders = await groupOrdersApi.list(circleId).catch((e: unknown) => { console.error("[loadGroupOrders]:", e); return []; });
    setGroupOrders(orders ?? []);
  }

  async function openOrderDetail(order: any) {
    setSelectedOrder(order);
    setOrderLoading(true);
    const { groupOrdersApi } = await import("./lib/api-service").catch(() => ({} as any));
    if (groupOrdersApi) {
      const items = await groupOrdersApi.getItems(order.id).catch(() => []);
      setOrderItems(items ?? []);
    }
    setOrderLoading(false);
  }

  async function createGroupOrder() {
    if (!selectedCircle || !hid) return;
    const { groupOrdersApi } = await import("./lib/api-service").catch(() => ({} as any));
    if (!groupOrdersApi) return;
    setOrderLoading(true);
    try {
      const deadline = new Date();
      deadline.setDate(deadline.getDate() + parseInt(createOrderForm.deadline_days || "3"));
      await groupOrdersApi.create({
        circleId: selectedCircle.id,
        shopperHouseholdId: hid,
        storeName: createOrderForm.store_name,
        pickupDay: createOrderForm.pickup_day,
        deadline: deadline.toISOString(),
        notes: createOrderForm.notes || undefined,
      });
      setShowCreateOrder(false);
      setCreateOrderForm({ store_name: "Costco", pickup_day: "Saturday", deadline_days: "3", notes: "" });
      await loadGroupOrders(selectedCircle.id);
    } catch (e: any) {
      alert("Failed to create order: " + (e?.message ?? "unknown error"));
    } finally { setOrderLoading(false); }
  }

  async function submitMyItems() {
    if (!selectedOrder || !hid) return;
    const { groupOrdersApi } = await import("./lib/api-service").catch(() => ({} as any));
    if (!groupOrdersApi) return;
    const validItems = myOrderItems.filter(i => i.item_name.trim());
    if (!validItems.length) { alert("Add at least one item"); return; }
    setOrderLoading(true);
    try {
      await groupOrdersApi.submitItems(selectedOrder.id, hid, validItems.map(i => ({
        item_name: i.item_name.trim(),
        quantity: parseFloat(i.quantity) || 1,
        unit: i.unit.trim() || undefined,
        est_cost: parseFloat(i.notes) || undefined,
      })));
      setShowAddItems(false);
      setMyOrderItems([{ item_name: "", quantity: "1", unit: "", notes: "" }]);
      await openOrderDetail(selectedOrder);
      await loadGroupOrders(selectedCircle.id);
    } catch (e: any) {
      alert("Failed to submit items: " + (e?.message ?? "unknown error"));
    } finally { setOrderLoading(false); }
  }

  async function toggleItemChecked(item: any) {
    const { groupOrdersApi } = await import("./lib/api-service").catch(() => ({} as any));
    if (!groupOrdersApi) return;
    await groupOrdersApi.checkItem(item.item_id, !item.checked).catch(() => {});
    setOrderItems(prev => prev.map(i => i.item_id === item.item_id ? { ...i, checked: !i.checked } : i));
  }

  async function advanceOrderStatus(order: any) {
    const nextStatus: Record<string, string> = { open: "shopping", shopping: "delivered" };
    const next = nextStatus[order.status];
    if (!next) return;
    const { groupOrdersApi } = await import("./lib/api-service").catch(() => ({} as any));
    if (!groupOrdersApi) return;
    await groupOrdersApi.updateStatus(order.id, next).catch(() => {});
    setSelectedOrder((o: any) => o ? { ...o, status: next } : o);
    await loadGroupOrders(selectedCircle.id);
  }

  async function openCircle(circle: any) {
    unsubCircleChat();
    unsubReqChat();
    setSelectedCircle(circle);
    setView("circle");
    setCircleTab("browse");
    setGroupOrders([]);
    const { circlesApi: cApi, circleChatApi: chatApi } = await import("./lib/api-service").catch(() => ({} as any));
    if (cApi && hid) {
      setLoadingShared(true);
      // Run independently so one failure doesn't wipe out everything else
      const [mem, shared, msgs] = await Promise.all([
        cApi.listMembers(circle.id).catch((e: unknown) => { console.error("[openCircle] listMembers:", e); return []; }),
        cApi.getSharedInventory(circle.id, hid).catch((e: unknown) => { console.error("[openCircle] getSharedInventory:", e); return []; }),
        chatApi ? chatApi.getMessages(circle.id).catch((e: unknown) => { console.error("[openCircle] getMessages:", e); return []; }) : Promise.resolve([]),
      ]);
      setMembers(mem ?? []);
      setSharedInventory(shared ?? []);
      setMessages(msgs ?? []);
      const myMember = (mem ?? []).find((m: any) => m.household_id === hid);
      setSharingEnabled(myMember?.sharing_enabled ?? false);
      setLoadingShared(false);
      // Load group orders in background
      loadGroupOrders(circle.id);
    }
    // Realtime: subscribe to new circle_messages for this circle
    const { supabase } = await import("./lib/supabase-client").catch(() => ({} as any));
    if (supabase) {
      const ch = supabase
        .channel(`circle-chat-${circle.id}`)
        .on("postgres_changes", {
          event: "INSERT",
          schema: "public",
          table: "circle_messages",
          filter: `circle_id=eq.${circle.id}`,
        }, (payload: any) => {
          setMessages(prev => {
            if (prev.some(m => m.id === payload.new.id)) return prev;
            return [...prev, payload.new];
          });
        })
        .subscribe();
      circleChatChannelRef.current = ch;
    }
  }

  async function openRequest(req: any) {
    unsubReqChat();
    setSelectedRequest(req);
    setView("request");
    const { itemRequestsApi: irApi } = await import("./lib/api-service").catch(() => ({} as any));
    if (irApi) {
      const msgs = await irApi.getMessages(req.id).catch(() => []);
      setReqMessages(msgs ?? []);
    }
    // Realtime: subscribe to new request_messages for this request
    const { supabase } = await import("./lib/supabase-client").catch(() => ({} as any));
    if (supabase) {
      const ch = supabase
        .channel(`req-chat-${req.id}`)
        .on("postgres_changes", {
          event: "INSERT",
          schema: "public",
          table: "request_messages",
          filter: `request_id=eq.${req.id}`,
        }, (payload: any) => {
          setReqMessages(prev => {
            if (prev.some(m => m.id === payload.new.id)) return prev;
            return [...prev, payload.new];
          });
        })
        .subscribe();
      reqChatChannelRef.current = ch;
    }
  }

  async function sendCircleMsg() {
    if (!msgInput.trim() || !selectedCircle || !hid) return;
    const { circleChatApi: chatApi } = await import("./lib/api-service").catch(() => ({} as any));
    if (!chatApi) return;
    const text = msgInput.trim();
    const optimisticId = `opt-${Date.now()}`;
    const optimistic = { id: optimisticId, circle_id: selectedCircle.id, household_id: hid, message: text, created_at: new Date().toISOString() };
    setMessages(prev => [...prev, optimistic]);
    setMsgInput("");
    try {
      const msg = await chatApi.postMessage(selectedCircle.id, hid, text);
      setMessages(prev => prev.map(m => m.id === optimisticId ? msg : m));
    } catch (e: any) {
      console.error("[sendCircleMsg] failed:", e);
      // Remove failed optimistic message and restore input
      setMessages(prev => prev.filter(m => m.id !== optimisticId));
      setMsgInput(text);
      alert("Message failed to send: " + (e?.message ?? "unknown error"));
    }
  }

  async function sendReqMsg() {
    if (!reqMsgInput.trim() || !selectedRequest || !hid) return;
    const { itemRequestsApi: irApi } = await import("./lib/api-service").catch(() => ({} as any));
    if (!irApi) return;
    const text = reqMsgInput.trim();
    const optimisticId = `opt-${Date.now()}`;
    const optimistic = { id: optimisticId, request_id: selectedRequest.id, household_id: hid, message: text, created_at: new Date().toISOString() };
    setReqMessages(prev => [...prev, optimistic]);
    setReqMsgInput("");
    try {
      const msg = await irApi.postMessage(selectedRequest.id, hid, text);
      setReqMessages(prev => prev.map(m => m.id === optimisticId ? msg : m));
    } catch (e: any) {
      console.error("[sendReqMsg] failed:", e);
      setReqMessages(prev => prev.filter(m => m.id !== optimisticId));
      setReqMsgInput(text);
      alert("Message failed to send: " + (e?.message ?? "unknown error"));
    }
  }

  const circleRequests = selectedCircle ? requests.filter((r: any) => r.circle_id === selectedCircle.id) : [];
  const incomingRequests = requests.filter((r: any) => r.lending_household_id === hid && r.status === "pending");

  // ── Empty state ──
  if (!circlesLoading && circles.length === 0 && view === "list") return (
    <div>
      <h1 style={{ fontSize: 28, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 6px" }}>Circles</h1>
      <p style={{ color: "#6b7280", margin: "0 0 32px", fontSize: 14 }}>Share inventory with trusted households in a private, controlled way.</p>
      <Card style={{ padding: 48, textAlign: "center", maxWidth: 480, margin: "0 auto" }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>⭕</div>
        <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 8 }}>No circles yet</div>
        <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 24 }}>Create a circle and invite trusted households, or join one with an invite code.</p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={() => setShowCreate(true)} style={{ ...btnPrimary, display: "inline-flex", alignItems: "center", gap: 6 }}><Icons.Plus style={{ width: 16, height: 16 }} /> Create circle</button>
          <button onClick={() => setShowJoin(true)} style={{ ...btnSecondary, display: "inline-flex", alignItems: "center", gap: 6 }}>Join with code</button>
        </div>
      </Card>
      {showCreate && <CreateCircleModal onClose={() => setShowCreate(false)} onCreate={async (n, d) => { setFormLoading(true); setFormErr(null); try { await onCreateCircle?.(n, d); setShowCreate(false); } catch(e: any) { setFormErr(e.message); } finally { setFormLoading(false); } }} loading={formLoading} err={formErr} />}
      {showJoin && <JoinCircleModal onClose={() => setShowJoin(false)} onJoin={async (code) => { setFormLoading(true); setFormErr(null); try { await onJoinCircle?.(code); setShowJoin(false); } catch(e: any) { setFormErr(e.message); } finally { setFormLoading(false); } }} loading={formLoading} err={formErr} />}
    </div>
  );

  // ── Request detail view ──
  if (view === "request" && selectedRequest) {
    const req = selectedRequest;
    const isLender = req.lending_household_id === hid;
    const isRequester = req.requesting_household_id === hid;
    return (
      <div>
        <button onClick={() => { unsubReqChat(); setView("circle"); setSelectedRequest(null); }} style={{ background: "none", border: "none", color: "#2d5a27", fontWeight: 600, fontSize: 14, cursor: "pointer", padding: "0 0 16px", display: "flex", alignItems: "center", gap: 6, fontFamily: "inherit" }}>← Back</button>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24, flexWrap: "wrap" }}>
          <h2 style={{ fontSize: 22, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: 0 }}>Request: {req.item_name}</h2>
          <span style={{ padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, background: statusBg[req.status] ?? "#f9fafb", color: statusColors[req.status] ?? "#6b7280", textTransform: "capitalize" }}>{req.status}</span>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 16, marginBottom: 20 }}>
          <Card style={{ padding: 20 }}>
            <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 4, fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.05em" }}>Item</div>
            <div style={{ fontWeight: 600, fontSize: 18 }}>{req.item_name}</div>
            <div style={{ color: "#6b7280", fontSize: 14, marginTop: 4 }}>{req.quantity} {req.unit ?? "unit(s)"}</div>
          </Card>
          <Card style={{ padding: 20 }}>
            <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 4, fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.05em" }}>From → To</div>
            <div style={{ fontSize: 14, color: "#374151" }}><strong>{req.requesting_household_name ?? "Requesting household"}</strong> is asking <strong>{req.lending_household_name ?? "your household"}</strong></div>
          </Card>
        </div>
        {req.note && <Card style={{ padding: 16, marginBottom: 16, background: "#fafaf9" }}><div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 4, fontWeight: 500 }}>NOTE</div><div style={{ fontSize: 14, color: "#374151" }}>{req.note}</div></Card>}
        {req.status === "pending" && (
          <div style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap" }}>
            {isLender && <>
              <button onClick={() => { onUpdateStatus?.(req.id, "accepted"); setSelectedRequest({ ...req, status: "accepted" }); }} style={{ ...btnPrimary, background: "#16a34a" }}>✓ Accept</button>
              <button onClick={() => { onUpdateStatus?.(req.id, "rejected"); setSelectedRequest({ ...req, status: "rejected" }); }} style={{ ...btnSecondary, color: "#dc2626", borderColor: "#dc2626" }}>✗ Reject</button>
            </>}
            {req.status === "accepted" && isLender && <button onClick={() => { onUpdateStatus?.(req.id, "completed"); setSelectedRequest({ ...req, status: "completed" }); }} style={{ ...btnPrimary }}>Mark as completed</button>}
            {isRequester && <button onClick={() => { onUpdateStatus?.(req.id, "cancelled"); setSelectedRequest({ ...req, status: "cancelled" }); }} style={{ ...btnSecondary, color: "#6b7280" }}>Cancel request</button>}
          </div>
        )}
        {req.status === "accepted" && (
          <div style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap" }}>
            {isLender && <button onClick={() => { onUpdateStatus?.(req.id, "completed"); setSelectedRequest({ ...req, status: "completed" }); }} style={{ ...btnPrimary }}>✓ Mark as completed</button>}
          </div>
        )}
        <Card style={{ padding: 20 }}>
          <div style={{ fontWeight: 600, marginBottom: 16, fontSize: 15 }}>Conversation</div>
          <div style={{ minHeight: 120, maxHeight: 300, overflowY: "auto", display: "flex", flexDirection: "column", gap: 10, marginBottom: 16 }}>
            {reqMessages.length === 0 && <div style={{ color: "#9ca3af", fontSize: 13, textAlign: "center", paddingTop: 24 }}>No messages yet. Use this to coordinate pickup details.</div>}
            {reqMessages.map((m: any) => {
              const isMine = m.sender_id === currentUserId;
              const reqSenderName = m.sender_name ?? (m.household_id === hid ? "You" : "Them");
              return <div key={m.id} style={{ alignSelf: isMine ? "flex-end" : "flex-start", maxWidth: "75%", background: isMine ? "#2d5a27" : "#f3f4f6", color: isMine ? "#fff" : "#1a1a1a", borderRadius: isMine ? "16px 16px 4px 16px" : "16px 16px 16px 4px", padding: "10px 14px", fontSize: 14 }}>
                {!isMine && <div style={{ fontSize: 11, fontWeight: 600, marginBottom: 4, opacity: 0.6 }}>{reqSenderName}</div>}
                {m.message}
                <div style={{ fontSize: 10, opacity: 0.5, marginTop: 4, textAlign: isMine ? "right" : "left" }}>{new Date(m.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</div>
              </div>;
            })}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <input value={reqMsgInput} onChange={e => setReqMsgInput(e.target.value)} onKeyDown={e => { if (e.key === "Enter") sendReqMsg(); }} placeholder="Type a message…" style={{ flex: 1, padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", outline: "none" }} />
            <button onClick={sendReqMsg} disabled={!reqMsgInput.trim()} style={{ ...btnPrimary, padding: "10px 16px" }}>Send</button>
          </div>
        </Card>
      </div>
    );
  }

  // ── Circle detail view ──
  if (view === "circle" && selectedCircle) {
    const myMember = members.find((m: any) => m.household_id === hid);
    const isAdmin = myMember?.role === "admin";
    return (
      <div>
        <button onClick={() => { unsubCircleChat(); unsubReqChat(); setView("list"); setSelectedCircle(null); }} style={{ background: "none", border: "none", color: "#2d5a27", fontWeight: 600, fontSize: 14, cursor: "pointer", padding: "0 0 16px", display: "flex", alignItems: "center", gap: 6, fontFamily: "inherit" }}>← All circles</button>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
          <div>
            <h2 style={{ fontSize: 24, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 4px" }}>{selectedCircle.name}</h2>
            {selectedCircle.description && <p style={{ color: "#6b7280", fontSize: 14, margin: 0 }}>{selectedCircle.description}</p>}
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            <div style={{ background: "#f3f4f6", borderRadius: 8, padding: "6px 12px", fontSize: 12, fontWeight: 600, color: "#374151", display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ opacity: 0.5 }}>Code:</span> <span style={{ fontFamily: "monospace", letterSpacing: "0.1em" }}>{selectedCircle.invite_code}</span>
            </div>
            {isAdmin && <button onClick={async () => { await navigator.clipboard.writeText(selectedCircle.invite_code).catch(() => {}); }} style={{ ...btnSecondary, fontSize: 12, padding: "6px 12px" }}>Copy invite code</button>}
          </div>
        </div>

        {/* Sharing toggle */}
        <Card style={{ padding: 16, marginBottom: 16, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, flexWrap: "wrap" }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 14 }}>Share your inventory with this circle</div>
            <div style={{ color: "#6b7280", fontSize: 13 }}>When on, other members can browse your items and make requests.</div>
          </div>
          <button onClick={async () => { const next = !sharingEnabled; setSharingEnabled(next); await onUpdateSharing?.(selectedCircle.id, next, null); }} style={{ width: 48, height: 26, borderRadius: 13, background: sharingEnabled ? "#2d5a27" : "#d1d5db", border: "none", cursor: "pointer", position: "relative", transition: "background 0.2s", flexShrink: 0 }}>
            <span style={{ position: "absolute", top: 3, left: sharingEnabled ? 25 : 3, width: 20, height: 20, borderRadius: "50%", background: "#fff", transition: "left 0.2s", boxShadow: "0 1px 4px rgba(0,0,0,0.2)" }} />
          </button>
        </Card>

        {/* Members strip */}
        <div style={{ display: "flex", gap: 8, marginBottom: 20, overflowX: "auto", paddingBottom: 4 }}>
          {members.map((m: any) => (
            <div key={m.id} style={{ flexShrink: 0, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 12, padding: "10px 16px", textAlign: "center", minWidth: 100 }}>
              <div style={{ width: 36, height: 36, borderRadius: "50%", background: "linear-gradient(135deg, #4ade80, #2d5a27)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 6px", fontSize: 16, color: "#fff", fontWeight: 700 }}>
                {(m.household_name ?? "H")[0].toUpperCase()}
              </div>
              <div style={{ fontSize: 13, fontWeight: 600, maxWidth: 80, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{m.household_name ?? "Household"}</div>
              <div style={{ fontSize: 11, color: m.household_id === hid ? "#2d5a27" : "#9ca3af", marginTop: 2 }}>{m.household_id === hid ? "You" : m.sharing_enabled ? "Sharing" : "Private"}</div>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <div style={{ display: "flex", gap: 2, marginBottom: 20, background: "#f3f4f6", borderRadius: 12, padding: 4, overflowX: "auto" }}>
          {(["browse", "orders", "requests", "chat"] as const).map(t => (
            <button key={t} onClick={() => { setCircleTab(t); if (t === "orders") loadGroupOrders(selectedCircle.id); }} style={{ padding: "8px 16px", borderRadius: 10, border: "none", cursor: "pointer", fontSize: 13, fontWeight: circleTab === t ? 600 : 400, background: circleTab === t ? "#fff" : "transparent", color: circleTab === t ? "#2d5a27" : "#6b7280", boxShadow: circleTab === t ? "0 1px 4px rgba(0,0,0,0.08)" : "none", transition: "all 0.15s", fontFamily: "inherit", textTransform: "capitalize", position: "relative", flexShrink: 0 }}>
              {t === "orders" ? "🛒 Group Orders" : t}
              {t === "requests" && circleRequests.filter((r: any) => r.status === "pending" && r.lending_household_id === hid).length > 0 && (
                <span style={{ position: "absolute", top: 4, right: 4, width: 8, height: 8, background: "#dc2626", borderRadius: "50%" }} />
              )}
            </button>
          ))}
        </div>

        {/* Browse tab */}
        {circleTab === "browse" && (
          <div>
            {loadingShared && <div style={{ color: "#9ca3af", fontSize: 14, textAlign: "center", padding: 32 }}>Loading shared items…</div>}
            {!loadingShared && sharedInventory.length === 0 && (
              <Card style={{ padding: 40, textAlign: "center" }}>
                <div style={{ fontSize: 36, marginBottom: 12 }}>📦</div>
                <div style={{ fontWeight: 600, marginBottom: 6 }}>No shared inventory yet</div>
                <p style={{ color: "#6b7280", fontSize: 14 }}>Other members need to turn on sharing before their items appear here.</p>
              </Card>
            )}
            {sharedInventory.map((hh: any) => (
              <div key={hh.householdId} style={{ marginBottom: 20 }}>
                <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 10, display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ width: 28, height: 28, borderRadius: "50%", background: "linear-gradient(135deg, #4ade80, #2d5a27)", display: "inline-flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 13, fontWeight: 700 }}>{hh.householdName[0]?.toUpperCase()}</span>
                  {hh.householdName}
                </div>
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(auto-fill, minmax(200px, 1fr))", gap: 10 }}>
                  {hh.items.map((item: any) => (
                    <div key={item.id} style={{ background: "#fff", borderRadius: 12, border: "1.5px solid #e5e7eb", padding: "12px 14px", display: "flex", flexDirection: "column", gap: 4 }}>
                      <div style={{ fontWeight: 600, fontSize: 14 }}>{item.name}</div>
                      <div style={{ fontSize: 12, color: "#6b7280" }}>{item.quantity} {item.unit ?? ""} · {item.category}</div>
                      {item.expiry && <div style={{ fontSize: 11, color: "#9ca3af" }}>Exp {item.expiry}</div>}
                      <button onClick={() => { setReqTargetHousehold(hh.householdId); setReqTargetItem(item); setReqItem(item.name); setReqQty("1"); setReqUnit(item.unit ?? ""); setShowNewReq(true); }} style={{ marginTop: 6, padding: "6px 0", borderRadius: 8, border: "1.5px solid #2d5a27", background: "#f0fdf4", color: "#2d5a27", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>+ Request</button>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Requests tab */}
        {circleTab === "requests" && (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <div style={{ fontWeight: 600, fontSize: 15 }}>Requests</div>
              <button onClick={() => { setReqTargetHousehold(""); setReqItem(""); setReqQty("1"); setReqUnit(""); setReqNote(""); setShowNewReq(true); }} style={{ ...btnPrimary, fontSize: 13, padding: "8px 14px", display: "flex", alignItems: "center", gap: 6 }}><Icons.Plus style={{ width: 14, height: 14 }} /> New request</button>
            </div>
            {circleRequests.length === 0 && <Card style={{ padding: 40, textAlign: "center" }}><div style={{ fontSize: 36, marginBottom: 12 }}>🤝</div><div style={{ fontWeight: 600, marginBottom: 6 }}>No requests yet</div><p style={{ color: "#6b7280", fontSize: 14 }}>Browse shared inventory and tap "+ Request" to ask a household for an item.</p></Card>}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {circleRequests.map((req: any) => {
                const isIncoming = req.lending_household_id === hid;
                return (
                  <div key={req.id} onClick={() => openRequest(req)} style={{ background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 14, padding: "16px 18px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
                    <div>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4, flexWrap: "wrap" }}>
                        <span style={{ fontWeight: 600, fontSize: 15 }}>{req.item_name}</span>
                        <span style={{ fontSize: 13, color: "#6b7280" }}>{req.quantity} {req.unit ?? "unit(s)"}</span>
                        <span style={{ padding: "2px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600, background: statusBg[req.status] ?? "#f9fafb", color: statusColors[req.status] ?? "#6b7280", textTransform: "capitalize" }}>{req.status}</span>
                        {isIncoming && req.status === "pending" && <span style={{ padding: "2px 8px", borderRadius: 8, fontSize: 11, fontWeight: 600, background: "#fef3c7", color: "#92400e" }}>Action needed</span>}
                      </div>
                      <div style={{ fontSize: 12, color: "#9ca3af" }}>
                        {isIncoming ? `From ${req.requesting_household_name ?? "another household"}` : `To ${req.lending_household_name ?? "another household"}`}
                        {" · "}{new Date(req.created_at).toLocaleDateString()}
                      </div>
                    </div>
                    <Icons.Share style={{ width: 16, height: 16, color: "#9ca3af", flexShrink: 0 }} />
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Chat tab */}
        {circleTab === "chat" && (
          <Card style={{ padding: 20 }}>
            <div style={{ fontWeight: 600, marginBottom: 16, fontSize: 15 }}>Circle chat</div>
            <div style={{ minHeight: 200, maxHeight: 400, overflowY: "auto", display: "flex", flexDirection: "column", gap: 10, marginBottom: 16 }}>
              {messages.length === 0 && <div style={{ color: "#9ca3af", fontSize: 13, textAlign: "center", paddingTop: 48 }}>No messages yet. Say hi!</div>}
              {messages.map((m: any) => {
                const isMine = m.sender_id === currentUserId;
                const householdName = members.find((mem: any) => mem.household_id === m.household_id)?.household_name ?? "";
                const displayName = m.sender_name ? (householdName ? `${m.sender_name} · ${householdName}` : m.sender_name) : (householdName || "Someone");
                return <div key={m.id} style={{ alignSelf: isMine ? "flex-end" : "flex-start", maxWidth: "75%", background: isMine ? "#2d5a27" : "#f3f4f6", color: isMine ? "#fff" : "#1a1a1a", borderRadius: isMine ? "16px 16px 4px 16px" : "16px 16px 16px 4px", padding: "10px 14px", fontSize: 14 }}>
                  {!isMine && <div style={{ fontSize: 11, fontWeight: 600, marginBottom: 4, opacity: 0.7 }}>{displayName}</div>}
                  {m.message}
                  <div style={{ fontSize: 10, opacity: 0.5, marginTop: 4, textAlign: isMine ? "right" : "left" }}>{new Date(m.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</div>
                </div>;
              })}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <input value={msgInput} onChange={e => setMsgInput(e.target.value)} onKeyDown={e => { if (e.key === "Enter") sendCircleMsg(); }} placeholder="Message the circle…" style={{ flex: 1, padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", outline: "none" }} />
              <button onClick={sendCircleMsg} disabled={!msgInput.trim()} style={{ ...btnPrimary, padding: "10px 16px" }}>Send</button>
            </div>
          </Card>
        )}

        {/* Group Orders tab */}
        {circleTab === "orders" && (
          <div>
            {/* Order detail view */}
            {selectedOrder ? (
              <div>
                <button onClick={() => setSelectedOrder(null)} style={{ background: "none", border: "none", color: "#2d5a27", fontWeight: 600, fontSize: 14, cursor: "pointer", padding: "0 0 16px", display: "flex", alignItems: "center", gap: 6, fontFamily: "inherit" }}>← Back to orders</button>
                {/* Order header */}
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
                  <div>
                    <h2 style={{ fontSize: 20, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 4px" }}>{selectedOrder.store_name} Run</h2>
                    <div style={{ fontSize: 13, color: "#6b7280" }}>Pickup: {selectedOrder.pickup_day} · Deadline: {new Date(selectedOrder.deadline).toLocaleDateString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })}</div>
                    <div style={{ fontSize: 13, color: "#6b7280", marginTop: 2 }}>Shopper: {selectedOrder.shopper_household_name}</div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                    {({"open":"🟢 Open","shopping":"🛍️ Shopping","delivered":"✅ Delivered","cancelled":"❌ Cancelled"} as Record<string,string>)[selectedOrder.status] && (
                      <span style={{ padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, background: ({open:"#f0fdf4",shopping:"#fffbeb",delivered:"#eef2ff",cancelled:"#f9fafb"} as Record<string,string>)[selectedOrder.status] ?? "#f9fafb", color: ({open:"#16a34a",shopping:"#92400e",delivered:"#6366f1",cancelled:"#9ca3af"} as Record<string,string>)[selectedOrder.status] ?? "#6b7280" }}>
                        {({"open":"Open","shopping":"Shopping","delivered":"Delivered","cancelled":"Cancelled"} as Record<string,string>)[selectedOrder.status]}
                      </span>
                    )}
                    {/* Shopper advance status button */}
                    {selectedOrder.shopper_household_id === hid && selectedOrder.status !== "delivered" && selectedOrder.status !== "cancelled" && (
                      <button onClick={() => advanceOrderStatus(selectedOrder)} style={{ ...btnPrimary, fontSize: 13, padding: "6px 14px" }}>
                        {selectedOrder.status === "open" ? "Start Shopping →" : "Mark Delivered ✓"}
                      </button>
                    )}
                  </div>
                </div>
                {/* Copy toast */}
                {copyToast && (
                  <div style={{ position: "fixed", bottom: 80, left: "50%", transform: "translateX(-50%)", background: "#1a1a1a", color: "#fff", padding: "10px 20px", borderRadius: 20, fontSize: 13, fontWeight: 600, zIndex: 9999, whiteSpace: "nowrap", boxShadow: "0 4px 20px rgba(0,0,0,0.3)" }}>
                    {copyToast}
                  </div>
                )}

                {/* Action buttons row */}
                <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
                  {selectedOrder.status === "open" && (
                    <button onClick={() => { setShowAddItems(true); setMyOrderItems([{ item_name: "", quantity: "1", unit: "", notes: "" }]); }} style={{ ...btnSecondary, fontSize: 13 }}>
                      ✏️ Add / edit my items
                    </button>
                  )}
                </div>

                {/* Order on delivery services — copies list + opens tab */}
                {orderItems.length > 0 && (
                  <div style={{ marginBottom: 20, padding: 16, background: "#f8f7f4", borderRadius: 14, border: "1.5px solid #e5e7eb" }}>
                    <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 4 }}>🛒 Order for delivery</div>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 12 }}>
                      Tap a service — your full item list is copied to clipboard automatically. Just paste it in the app's search bar.
                    </div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      {[
                        { label: "Instacart", emoji: "🛒", url: "https://www.instacart.com/store?utm_source=ingrediable&utm_medium=group_order", bg: "#f0fdf4", border: "#86efac", color: "#166534" },
                        { label: "Walmart", emoji: "🏪", url: `https://www.walmart.com/search?q=${encodeURIComponent(orderItems.slice(0,3).map((i:any)=>i.item_name).join(' '))}`, bg: "#eff6ff", border: "#bfdbfe", color: "#1e40af" },
                      ].map(({ label, emoji, url, bg, border, color }) => (
                        <button key={label} onClick={() => {
                          // Build formatted list
                          const lines = orderItems.map((i: any) => `${i.item_name}${i.quantity !== 1 ? ` (${i.quantity}${i.unit ? ' ' + i.unit : ''})` : ''}`);
                          const text = `Shopping list for ${selectedOrder.store_name} run:\n` + lines.map(l => `• ${l}`).join('\n');
                          navigator.clipboard.writeText(text).catch(() => {});
                          window.open(url, '_blank');
                          setCopyToast(`📋 List copied! Paste it in ${label}'s search bar`);
                          setTimeout(() => setCopyToast(null), 3500);
                        }} style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 14px", background: bg, border: `1.5px solid ${border}`, color, borderRadius: 10, fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
                          {emoji} {label}
                        </button>
                      ))}
                    </div>
                    <div style={{ marginTop: 10, fontSize: 11, color: "#9ca3af" }}>
                      Tip: Instacart has a "Create a list" feature — paste there to save the whole order at once.
                    </div>
                  </div>
                )}
                {/* Master list grouped by household */}
                {orderLoading ? (
                  <div style={{ color: "#9ca3af", textAlign: "center", padding: 32 }}>Loading items…</div>
                ) : orderItems.length === 0 ? (
                  <Card style={{ padding: 32, textAlign: "center" }}>
                    <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
                    <div style={{ color: "#6b7280", fontSize: 14 }}>No items yet. Be the first to add yours!</div>
                  </Card>
                ) : (
                  <div>
                    {/* Group items by household */}
                    {Array.from(new Set(orderItems.map((i: any) => i.household_id))).map((hhId: any) => {
                      const hhItems = orderItems.filter((i: any) => i.household_id === hhId);
                      const hhName = hhItems[0]?.household_name ?? "Unknown";
                      const subtotal = hhItems.reduce((sum: number, i: any) => sum + (i.est_cost ?? 0), 0);
                      const isMyHousehold = hhId === hid;
                      return (
                        <Card key={hhId} style={{ padding: 16, marginBottom: 12, border: isMyHousehold ? "2px solid #2d5a27" : "1.5px solid #e5e7eb" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                            <div style={{ fontWeight: 600, fontSize: 14, color: isMyHousehold ? "#2d5a27" : "#1a1a1a" }}>
                              {hhName}{isMyHousehold ? " (you)" : ""}
                            </div>
                            {subtotal > 0 && <div style={{ fontSize: 12, color: "#6b7280" }}>~${subtotal.toFixed(2)}</div>}
                          </div>
                          {hhItems.map((item: any) => (
                            <div key={item.item_id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderTop: "1px solid #f3f4f6" }}>
                              {/* Shopper can check items off */}
                              {selectedOrder.shopper_household_id === hid ? (
                                <button onClick={() => toggleItemChecked(item)} style={{ width: 20, height: 20, borderRadius: 4, border: "2px solid", borderColor: item.checked ? "#2d5a27" : "#d1d5db", background: item.checked ? "#2d5a27" : "#fff", cursor: "pointer", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  {item.checked && <span style={{ color: "#fff", fontSize: 11 }}>✓</span>}
                                </button>
                              ) : (
                                <div style={{ width: 20, height: 20, borderRadius: 4, border: "2px solid", borderColor: item.checked ? "#2d5a27" : "#d1d5db", background: item.checked ? "#f0fdf4" : "#fff", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  {item.checked && <span style={{ color: "#2d5a27", fontSize: 11 }}>✓</span>}
                                </div>
                              )}
                              <div style={{ flex: 1 }}>
                                <span style={{ fontSize: 14, textDecoration: item.checked ? "line-through" : "none", color: item.checked ? "#9ca3af" : "#1a1a1a" }}>{item.item_name}</span>
                                <span style={{ fontSize: 12, color: "#9ca3af", marginLeft: 6 }}>{item.quantity} {item.unit ?? ""}</span>
                                {item.notes && <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 1 }}>{item.notes}</div>}
                              </div>
                              {item.est_cost != null && <div style={{ fontSize: 12, color: "#6b7280", flexShrink: 0 }}>${Number(item.est_cost).toFixed(2)}</div>}
                            </div>
                          ))}
                        </Card>
                      );
                    })}

                    {/* Settlement section — show after delivered */}
                    {(selectedOrder.status === "delivered" || selectedOrder.status === "shopping") && (
                      <Card style={{ padding: 20, marginTop: 16, background: "#fafaf9" }}>
                        <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12 }}>💰 Settlement</div>
                        <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 12 }}>Each household owes the shopper for their estimated costs. Settle up via:</div>
                        {Array.from(new Set(orderItems.map((i: any) => i.household_id)))
                          .filter(hhId => hhId !== selectedOrder.shopper_household_id)
                          .map((hhId: any) => {
                            const hhItems = orderItems.filter((i: any) => i.household_id === hhId);
                            const hhName = hhItems[0]?.household_name ?? "Unknown";
                            const subtotal = hhItems.reduce((sum: number, i: any) => sum + (i.est_cost ?? 0), 0);
                            return (
                              <div key={hhId} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #f3f4f6" }}>
                                <div>
                                  <div style={{ fontWeight: 600, fontSize: 14 }}>{hhName}</div>
                                  {subtotal > 0 && <div style={{ fontSize: 12, color: "#6b7280" }}>owes ~${subtotal.toFixed(2)}</div>}
                                </div>
                                <div style={{ display: "flex", gap: 8 }}>
                                  <a href={`https://venmo.com/?txn=charge&audience=private&amount=${subtotal.toFixed(2)}&note=${encodeURIComponent(`${selectedOrder.store_name} run - ${selectedOrder.pickup_day}`)}`} target="_blank" rel="noopener noreferrer" style={{ padding: "5px 12px", borderRadius: 8, background: "#3d95ce", color: "#fff", fontSize: 12, fontWeight: 600, textDecoration: "none" }}>Venmo</a>
                                  <a href="https://tricount.com" target="_blank" rel="noopener noreferrer" style={{ padding: "5px 12px", borderRadius: 8, background: "#2d5a27", color: "#fff", fontSize: 12, fontWeight: 600, textDecoration: "none" }}>Tricount</a>
                                </div>
                              </div>
                            );
                          })}
                        <div style={{ marginTop: 12, padding: 10, background: "#fff7ed", borderRadius: 8, fontSize: 12, color: "#92400e" }}>
                          💡 Tip: Add estimated costs when submitting items for accurate settlement
                        </div>
                      </Card>
                    )}
                  </div>
                )}

              </div>
            ) : (
              /* Orders list view */
              <div>
                <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 4 }}>How do you want to shop?</div>
                <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 16 }}>Pool grocery lists with the circle, or order delivery straight to your door.</div>

                {/* Two main options */}
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 12, marginBottom: 24 }}>

                  {/* Option 1 — Group run */}
                  <div onClick={() => setShowCreateOrder(true)} style={{ background: "#f0fdf4", border: "2px solid #86efac", borderRadius: 16, padding: 20, cursor: "pointer", transition: "box-shadow 0.15s" }}
                    onMouseEnter={e => (e.currentTarget.style.boxShadow = "0 4px 16px rgba(45,90,39,0.15)")}
                    onMouseLeave={e => (e.currentTarget.style.boxShadow = "none")}>
                    <div style={{ fontSize: 28, marginBottom: 8 }}>🧑‍🛒</div>
                    <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4, color: "#2d5a27" }}>Start a Group Run</div>
                    <div style={{ fontSize: 13, color: "#166534", marginBottom: 12 }}>
                      You or a neighbor volunteers to shop. Everyone adds their items — one trip, everyone saves time.
                    </div>
                    <div style={{ display: "inline-block", padding: "7px 16px", background: "#2d5a27", color: "#fff", borderRadius: 10, fontSize: 13, fontWeight: 600 }}>
                      Volunteer to shop →
                    </div>
                  </div>

                  {/* Option 2 — Delivery affiliates */}
                  <div style={{ background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 16, padding: 20 }}>
                    <div style={{ fontSize: 28, marginBottom: 8 }}>🚚</div>
                    <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>Order Delivery</div>
                    <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 14 }}>
                      Get groceries delivered without leaving home. Use your shopping list directly.
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                      <a href="https://www.instacart.com/store?utm_source=ingrediable&utm_medium=circles&utm_campaign=group_orders" target="_blank" rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 14px", background: "#f0fdf4", borderRadius: 10, textDecoration: "none", border: "1.5px solid #86efac" }}>
                        <span style={{ fontSize: 18 }}>🛒</span>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 13, color: "#166534" }}>Instacart</div>
                          <div style={{ fontSize: 11, color: "#6b7280" }}>Same-day delivery from 1,000+ stores</div>
                        </div>
                        <span style={{ marginLeft: "auto", fontSize: 11, fontWeight: 600, color: "#16a34a", background: "#dcfce7", padding: "2px 7px", borderRadius: 6 }}>Popular</span>
                      </a>
                      <a href="https://www.walmart.com/grocery?utm_source=ingrediable&utm_medium=circles" target="_blank" rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 14px", background: "#eff6ff", borderRadius: 10, textDecoration: "none", border: "1.5px solid #bfdbfe" }}>
                        <span style={{ fontSize: 18 }}>🏪</span>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 13, color: "#1e40af" }}>Walmart</div>
                          <div style={{ fontSize: 11, color: "#6b7280" }}>Grocery pickup & delivery</div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>

                {/* Active orders below the choice cards */}
                {groupOrders.length > 0 && (
                  <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 10, color: "#374151" }}>Active group runs</div>
                )}

                {orderLoading && <div style={{ color: "#9ca3af", textAlign: "center", padding: 32 }}>Loading orders…</div>}

                {groupOrders.map((order: any) => {
                  const isMyOrder = order.shopper_household_id === hid;
                  const statusColor: Record<string,string> = { open: "#16a34a", shopping: "#ca8a04", delivered: "#6366f1", cancelled: "#9ca3af" };
                  const statusBg2: Record<string,string> = { open: "#f0fdf4", shopping: "#fefce8", delivered: "#eef2ff", cancelled: "#f9fafb" };
                  const deadline = new Date(order.deadline);
                  const isUrgent = order.status === "open" && (deadline.getTime() - Date.now()) < 24 * 60 * 60 * 1000;
                  return (
                    <Card key={order.id} onClick={() => openOrderDetail(order)} style={{ padding: 16, marginBottom: 10, cursor: "pointer", border: isUrgent ? "2px solid #f97316" : isMyOrder ? "2px solid #2d5a27" : "1.5px solid #e5e7eb", transition: "box-shadow 0.15s" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                            <span style={{ fontWeight: 700, fontSize: 15 }}>{order.store_name}</span>
                            <span style={{ padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 600, background: statusBg2[order.status] ?? "#f9fafb", color: statusColor[order.status] ?? "#6b7280", textTransform: "capitalize" }}>
                              {order.status}
                            </span>
                            {isMyOrder && <span style={{ padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 600, background: "#f0fdf4", color: "#2d5a27" }}>You're shopper</span>}
                          </div>
                          <div style={{ fontSize: 13, color: "#6b7280" }}>
                            Pickup: {order.pickup_day} · Deadline: {deadline.toLocaleDateString([], { month: "short", day: "numeric" })}
                            {isUrgent && <span style={{ color: "#f97316", fontWeight: 600 }}> · Closes soon!</span>}
                          </div>
                          <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 4 }}>
                            {order.item_count ?? 0} total items · {order.my_item_count ?? 0} yours
                          </div>
                        </div>
                        <Icons.Arrow style={{ width: 18, height: 18, color: "#9ca3af", flexShrink: 0, marginTop: 2 }} />
                      </div>
                    </Card>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* Create order modal */}
        {showCreateOrder && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={e => { if (e.target === e.currentTarget) setShowCreateOrder(false); }}>
            <div style={{ background: "#fff", borderRadius: 20, padding: 28, width: "100%", maxWidth: 400, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
              <h3 style={{ margin: "0 0 6px", fontSize: 20, fontFamily: "'DM Serif Display', serif" }}>Start a Group Order</h3>
              <p style={{ margin: "0 0 20px", fontSize: 13, color: "#6b7280" }}>You're volunteering to shop for the circle. Everyone adds their items, you pick them up.</p>
              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Store *</label>
                  <input value={createOrderForm.store_name} onChange={e => setCreateOrderForm(f => ({ ...f, store_name: e.target.value }))} placeholder="e.g. Costco, Walmart, Trader Joe's" style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", outline: "none" }} />
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Pickup day</label>
                    <select value={createOrderForm.pickup_day} onChange={e => setCreateOrderForm(f => ({ ...f, pickup_day: e.target.value }))} style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", background: "#fff", outline: "none" }}>
                      {["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"].map(d => <option key={d} value={d}>{d}</option>)}
                    </select>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Deadline (days)</label>
                    <input type="number" min="1" max="14" value={createOrderForm.deadline_days} onChange={e => setCreateOrderForm(f => ({ ...f, deadline_days: e.target.value }))} style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", outline: "none" }} />
                  </div>
                </div>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Notes (optional)</label>
                  <textarea value={createOrderForm.notes} onChange={e => setCreateOrderForm(f => ({ ...f, notes: e.target.value }))} rows={2} placeholder="e.g. Bringing a van, can fit large items" style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", resize: "vertical", outline: "none" }} />
                </div>
              </div>
              <div style={{ display: "flex", gap: 10, marginTop: 24 }}>
                <button onClick={() => setShowCreateOrder(false)} style={{ ...btnSecondary, flex: 1 }}>Cancel</button>
                <button disabled={!createOrderForm.store_name.trim() || orderLoading} onClick={createGroupOrder} style={{ ...btnPrimary, flex: 2 }}>{orderLoading ? "Creating…" : "Create order"}</button>
              </div>
            </div>
          </div>
        )}

        {/* Add my items modal */}
        {showAddItems && selectedOrder && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "flex-end", justifyContent: "center" }} onClick={e => { if (e.target === e.currentTarget) setShowAddItems(false); }}>
            <div style={{ background: "#fff", borderRadius: "20px 20px 0 0", padding: 28, width: "100%", maxWidth: 520, maxHeight: "85vh", overflowY: "auto", boxShadow: "0 -10px 40px rgba(0,0,0,0.2)" }}>
              <h3 style={{ margin: "0 0 4px", fontSize: 18, fontFamily: "'DM Serif Display', serif" }}>My items for {selectedOrder.store_name}</h3>
              <p style={{ margin: "0 0 12px", fontSize: 13, color: "#6b7280" }}>Add what you need. Estimate cost if you can — helps with settlement.</p>

              {/* Import from shopping list */}
              {shopList.length > 0 && (
                <button onClick={() => {
                  const imported = shopList
                    .filter((s: any) => !s.checked)
                    .map((s: any) => ({ item_name: s.name ?? "", quantity: String(s.quantity ?? 1), unit: s.unit ?? "", notes: s.estCost ? String(s.estCost) : "" }));
                  if (!imported.length) return;
                  setMyOrderItems(prev => {
                    const hasContent = prev.some(i => i.item_name.trim());
                    return hasContent ? [...prev, ...imported] : imported;
                  });
                }} style={{ ...btnSecondary, fontSize: 12, marginBottom: 16, width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                  📥 Import from my shopping list ({shopList.filter((s: any) => !s.checked).length} unchecked items)
                </button>
              )}

              {myOrderItems.map((item, idx) => (
                <div key={idx} style={{ display: "flex", gap: 8, marginBottom: 10, alignItems: "flex-start" }}>
                  <div style={{ flex: 2 }}>
                    {idx === 0 && <label style={{ fontSize: 11, fontWeight: 600, color: "#9ca3af", display: "block", marginBottom: 4 }}>ITEM</label>}
                    <input value={item.item_name} onChange={e => setMyOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, item_name: e.target.value } : it))} placeholder="e.g. Olive oil" style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1.5px solid #e5e7eb", fontSize: 13, fontFamily: "inherit", boxSizing: "border-box", outline: "none" }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    {idx === 0 && <label style={{ fontSize: 11, fontWeight: 600, color: "#9ca3af", display: "block", marginBottom: 4 }}>QTY</label>}
                    <input type="number" min="0.1" step="0.1" value={item.quantity} onChange={e => setMyOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, quantity: e.target.value } : it))} style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1.5px solid #e5e7eb", fontSize: 13, fontFamily: "inherit", boxSizing: "border-box", outline: "none" }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    {idx === 0 && <label style={{ fontSize: 11, fontWeight: 600, color: "#9ca3af", display: "block", marginBottom: 4 }}>UNIT</label>}
                    <input value={item.unit} onChange={e => setMyOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, unit: e.target.value } : it))} placeholder="lbs" style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1.5px solid #e5e7eb", fontSize: 13, fontFamily: "inherit", boxSizing: "border-box", outline: "none" }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    {idx === 0 && <label style={{ fontSize: 11, fontWeight: 600, color: "#9ca3af", display: "block", marginBottom: 4 }}>~COST</label>}
                    <input type="number" min="0" step="0.5" value={item.notes} onChange={e => setMyOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, notes: e.target.value } : it))} placeholder="$" style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1.5px solid #e5e7eb", fontSize: 13, fontFamily: "inherit", boxSizing: "border-box", outline: "none" }} />
                  </div>
                  {myOrderItems.length > 1 && (
                    <button onClick={() => setMyOrderItems(prev => prev.filter((_, i) => i !== idx))} style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", fontSize: 18, padding: "8px 2px", marginTop: idx === 0 ? 20 : 0 }}>×</button>
                  )}
                </div>
              ))}
              <button onClick={() => setMyOrderItems(prev => [...prev, { item_name: "", quantity: "1", unit: "", notes: "" }])} style={{ ...btnSecondary, fontSize: 13, marginBottom: 20, width: "100%" }}>+ Add another item</button>
              <div style={{ display: "flex", gap: 10 }}>
                <button onClick={() => setShowAddItems(false)} style={{ ...btnSecondary, flex: 1 }}>Cancel</button>
                <button disabled={orderLoading} onClick={submitMyItems} style={{ ...btnPrimary, flex: 2 }}>{orderLoading ? "Saving…" : "Save my items"}</button>
              </div>
            </div>
          </div>
        )}

        {/* New request modal */}
        {showNewReq && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={e => { if (e.target === e.currentTarget) setShowNewReq(false); }}>
            <div style={{ background: "#fff", borderRadius: 20, padding: 28, width: "100%", maxWidth: 420, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
              <h3 style={{ margin: "0 0 20px", fontSize: 20, fontFamily: "'DM Serif Display', serif" }}>New request</h3>
              {formErr && <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", color: "#dc2626", fontSize: 13, marginBottom: 16 }}>{formErr}</div>}
              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Item *</label>
                  <input value={reqItem} onChange={e => setReqItem(e.target.value)} placeholder="e.g. Eggs" style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", outline: "none" }} />
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Quantity *</label>
                    <input type="number" min="0.1" step="0.1" value={reqQty} onChange={e => setReqQty(e.target.value)} style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", outline: "none" }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Unit</label>
                    <input value={reqUnit} onChange={e => setReqUnit(e.target.value)} placeholder="lbs, cups…" style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", outline: "none" }} />
                  </div>
                </div>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Request from *</label>
                  <select value={reqTargetHousehold} onChange={e => setReqTargetHousehold(e.target.value)} style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", background: "#fff", outline: "none" }}>
                    <option value="">Select a household…</option>
                    {members.filter((m: any) => m.household_id !== hid).map((m: any) => (
                      <option key={m.household_id} value={m.household_id}>{m.household_name ?? m.household_id}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Note (optional)</label>
                  <textarea value={reqNote} onChange={e => setReqNote(e.target.value)} rows={2} placeholder="Any details for the lender…" style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", resize: "vertical", outline: "none" }} />
                </div>
              </div>
              <div style={{ display: "flex", gap: 10, marginTop: 24 }}>
                <button onClick={() => setShowNewReq(false)} style={{ ...btnSecondary, flex: 1 }}>Cancel</button>
                <button disabled={!reqItem.trim() || !reqTargetHousehold || formLoading} onClick={async () => {
                  if (!reqItem.trim() || !reqTargetHousehold) return;
                  setFormLoading(true); setFormErr(null);
                  try {
                    await onCreateRequest?.({ circleId: selectedCircle.id, lendingHouseholdId: reqTargetHousehold, itemName: reqItem.trim(), itemId: reqTargetItem?.id, quantity: parseFloat(reqQty) || 1, unit: reqUnit.trim() || undefined, note: reqNote.trim() || undefined });
                    setShowNewReq(false); setReqItem(""); setReqQty("1"); setReqUnit(""); setReqNote(""); setReqTargetHousehold(""); setReqTargetItem(null);
                  } catch(e: any) { setFormErr(e.message); }
                  finally { setFormLoading(false); }
                }} style={{ ...btnPrimary, flex: 2 }}>{formLoading ? "Sending…" : "Send request"}</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ── Circles list view ──
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6, flexWrap: "wrap", gap: 12 }}>
        <h1 style={{ fontSize: 28, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: 0 }}>Circles</h1>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => setShowJoin(true)} style={{ ...btnSecondary, fontSize: 13, padding: "8px 14px" }}>Join with code</button>
          <button onClick={() => setShowCreate(true)} style={{ ...btnPrimary, fontSize: 13, padding: "8px 14px", display: "flex", alignItems: "center", gap: 6 }}><Icons.Plus style={{ width: 14, height: 14 }} /> Create</button>
        </div>
      </div>
      <p style={{ color: "#6b7280", margin: "0 0 24px", fontSize: 14 }}>Share inventory with trusted households in a private, controlled way.</p>

      {/* Incoming requests banner */}
      {incomingRequests.length > 0 && (
        <div style={{ background: "#fef3c7", border: "1.5px solid #fcd34d", borderRadius: 14, padding: "14px 18px", marginBottom: 20, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <span style={{ fontSize: 20 }}>🔔</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 600, fontSize: 14 }}>{incomingRequests.length} pending request{incomingRequests.length > 1 ? "s" : ""} need your response</div>
            <div style={{ fontSize: 13, color: "#92400e", marginTop: 2 }}>
              {incomingRequests.slice(0, 2).map((r: any) => r.item_name).join(", ")}{incomingRequests.length > 2 ? " and more" : ""}
            </div>
          </div>
        </div>
      )}

      {circlesLoading && <div style={{ color: "#9ca3af", fontSize: 14, textAlign: "center", padding: 32 }}>Loading circles…</div>}

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {circles.map((circle: any) => {
          const circPending = requests.filter((r: any) => r.circle_id === circle.id && r.status === "pending" && r.lending_household_id === hid).length;
          return (
            <div key={circle.id} onClick={() => openCircle(circle)} style={{ background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 16, padding: "18px 20px", cursor: "pointer", display: "flex", alignItems: "center", gap: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.04)", transition: "box-shadow 0.15s" }}>
              <div style={{ width: 44, height: 44, borderRadius: "50%", background: "linear-gradient(135deg, #4ade80, #2d5a27)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 20, color: "#fff", fontWeight: 700 }}>
                {circle.name[0]?.toUpperCase()}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 2 }}>{circle.name}</div>
                {circle.description && <div style={{ fontSize: 13, color: "#6b7280", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{circle.description}</div>}
              </div>
              {circPending > 0 && <span style={{ background: "#dc2626", color: "#fff", borderRadius: "50%", width: 22, height: 22, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, flexShrink: 0 }}>{circPending}</span>}
              <Icons.Share style={{ width: 16, height: 16, color: "#9ca3af", flexShrink: 0 }} />
            </div>
          );
        })}
      </div>

      {showCreate && <CreateCircleModal onClose={() => setShowCreate(false)} onCreate={async (n, d) => { setFormLoading(true); setFormErr(null); try { await onCreateCircle?.(n, d); setShowCreate(false); } catch(e: any) { setFormErr(e.message); } finally { setFormLoading(false); } }} loading={formLoading} err={formErr} />}
      {showJoin && <JoinCircleModal onClose={() => setShowJoin(false)} onJoin={async (code) => { setFormLoading(true); setFormErr(null); try { await onJoinCircle?.(code); setShowJoin(false); } catch(e: any) { setFormErr(e.message); } finally { setFormLoading(false); } }} loading={formLoading} err={formErr} />}
    </div>
  );
}

function CreateCircleModal({ onClose, onCreate, loading, err }: { onClose: () => void; onCreate: (name: string, desc: string) => Promise<void>; loading: boolean; err: string | null }) {
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: "#fff", borderRadius: 20, padding: 28, width: "100%", maxWidth: 400, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        <h3 style={{ margin: "0 0 20px", fontSize: 20, fontFamily: "'DM Serif Display', serif" }}>Create a circle</h3>
        {err && <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", color: "#dc2626", fontSize: 13, marginBottom: 16 }}>{err}</div>}
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Circle name *</label>
            <input value={name} onChange={e => setName(e.target.value)} placeholder="e.g. The Kowalski Family" autoFocus style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", outline: "none" }} />
          </div>
          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Description (optional)</label>
            <input value={desc} onChange={e => setDesc(e.target.value)} placeholder="A short description" style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", outline: "none" }} />
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, marginTop: 24 }}>
          <button onClick={onClose} style={{ ...btnSecondary, flex: 1 }}>Cancel</button>
          <button disabled={!name.trim() || loading} onClick={() => onCreate(name.trim(), desc.trim())} style={{ ...btnPrimary, flex: 2 }}>{loading ? "Creating…" : "Create circle"}</button>
        </div>
      </div>
    </div>
  );
}

function JoinCircleModal({ onClose, onJoin, loading, err }: { onClose: () => void; onJoin: (code: string) => Promise<void>; loading: boolean; err: string | null }) {
  const [code, setCode] = useState("");
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: "#fff", borderRadius: 20, padding: 28, width: "100%", maxWidth: 380, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        <h3 style={{ margin: "0 0 8px", fontSize: 20, fontFamily: "'DM Serif Display', serif" }}>Join a circle</h3>
        <p style={{ color: "#6b7280", fontSize: 14, margin: "0 0 20px" }}>Ask the circle owner for the invite code, then enter it below.</p>
        {err && <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", color: "#dc2626", fontSize: 13, marginBottom: 16 }}>{err}</div>}
        <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Invite code</label>
        <input value={code} onChange={e => setCode(e.target.value)} placeholder="e.g. a1b2c3d4" autoFocus style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, fontFamily: "inherit", boxSizing: "border-box", outline: "none", letterSpacing: "0.08em", marginBottom: 20 }} />
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onClose} style={{ ...btnSecondary, flex: 1 }}>Cancel</button>
          <button disabled={!code.trim() || loading} onClick={() => onJoin(code.trim())} style={{ ...btnPrimary, flex: 2 }}>{loading ? "Joining…" : "Join circle"}</button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════
// SETTINGS
// ═══════════════════════════════════════
function SettingsPage({ settings, setSettings, isMobile, onSignOut, activeHousehold, householdList = [], switchHousehold, deleteHousehold, reviewExpiryBeforeAdd = true, setReviewExpiryBeforeAdd, setPage, inventory = [], shopList = [], wasteLog = [], currentUserId }) {
  const [dangerOpen, setDangerOpen] = useState(false);
  const [confirmName, setConfirmName] = useState("");
  const [deleteStatus, setDeleteStatus] = useState<{ type: "ok" | "err"; text: string } | null>(null);

  const activeName = (activeHousehold as { name?: string } | null)?.name ?? "";
  const activeId = (activeHousehold as { id?: string } | null)?.id ?? "";
  const activeRole =
    householdList.find((h) => (h.household as { id?: string } | null)?.id === activeId)?.role ?? null;
  const canDelete = !!deleteHousehold && !!activeId && activeRole === "owner";

  function errText(err: unknown, fallback: string) {
    if (err instanceof Error) return err.message || fallback;
    if (typeof err === "string") return err;
    if (err && typeof err === "object" && "message" in err && typeof (err as { message?: unknown }).message === "string") {
      return (err as { message: string }).message || fallback;
    }
    return fallback;
  }

  return (
    <div>
      <h1 style={{ fontSize: 28, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 6px" }}>Settings</h1>
      <p style={{ color: "#6b7280", margin: "0 0 24px", fontSize: 14 }}>Customize your Ingrediable experience.</p>

      <div style={{ display: "grid", gap: 20, maxWidth: 600 }}>
        {/* Profile */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 16px" }}>Profile</h3>
          <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 20 }}>
            <div style={{ width: 60, height: 60, borderRadius: 30, background: "linear-gradient(135deg, #4ade80, #2d5a27)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 24, fontWeight: 700 }}>{settings.userName?.[0] || "Y"}</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 16 }}>{settings.userName || "You"}</div>
              <div style={{ fontSize: 13, color: "#6b7280" }}>you@email.com</div>
              <div style={{ fontSize: 12, color: "#9ca3af" }}>Member since January 2026</div>
            </div>
          </div>
          <div style={{ display: "grid", gap: 14 }}>
            <div>
              <label style={labelStyle}>Display Name</label>
              <input style={inputStyle} value={settings.userName || ""} onChange={e => setSettings(prev => ({ ...prev, userName: e.target.value }))} />
            </div>
            <div>
              <label style={labelStyle}>Household Name</label>
              <input style={inputStyle} value={settings.household || ""} onChange={e => setSettings(prev => ({ ...prev, household: e.target.value }))} />
            </div>
          </div>
        </Card>

        {/* Measurement */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 16px" }}>Measurement Preferences</h3>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 14 }}>
            <div>
              <label style={labelStyle}>Regional System</label>
              <select style={selectStyle} value={settings.measurement} onChange={e => setSettings(prev => ({ ...prev, measurement: e.target.value }))}>
                <option value="US">US (Imperial)</option>
                <option value="Metric">Metric</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Mass Unit</label>
              <select style={selectStyle} value={settings.massUnit} onChange={e => setSettings(prev => ({ ...prev, massUnit: e.target.value }))}>
                <option value="lbs">Pounds (lbs)</option>
                <option value="oz">Ounces (oz)</option>
                <option value="kg">Kilograms (kg)</option>
                <option value="g">Grams (g)</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Volume Unit</label>
              <select style={selectStyle} value={settings.volumeUnit} onChange={e => setSettings(prev => ({ ...prev, volumeUnit: e.target.value }))}>
                <option value="cups">Cups</option>
                <option value="fl_oz">Fluid Ounces</option>
                <option value="ml">Milliliters</option>
                <option value="l">Liters</option>
              </select>
            </div>
          </div>
        </Card>

        {/* Scan Preferences */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 8px" }}>Scan Preferences</h3>
          <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 12px" }}>Control scanner add behavior.</p>
          <label style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, padding: "10px 12px", border: "1px solid #e5e7eb", borderRadius: 10, cursor: "pointer" }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600 }}>Review expiry before adding scanned item</div>
              <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>Recommended: on</div>
            </div>
            <input
              type="checkbox"
              checked={reviewExpiryBeforeAdd}
              onChange={(e) => setReviewExpiryBeforeAdd?.(e.target.checked)}
              style={{ width: 18, height: 18 }}
            />
          </label>
        </Card>

        {/* Account (Supabase only) */}
        {onSignOut && (
          <Card>
            <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 16px" }}>Account</h3>
            <button
              onClick={() => onSignOut()}
              style={{ ...btnSecondary, display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}
            >
              <Icons.LogOut style={{ width: 14, height: 14 }} />Log out
            </button>
          </Card>
        )}

        {/* Household management (Supabase only) */}
        {onSignOut && (
          <Card>
            <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 8px" }}>Household</h3>
            <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 12px" }}>Switch households or delete one you own.</p>
            {householdList.length > 1 && !!switchHousehold && (
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 6 }}>Active household</div>
                <select
                  style={{ ...selectStyle, width: "100%" }}
                  value={activeId}
                  onChange={(e) => switchHousehold(e.target.value)}
                >
                  {householdList.map((h) => (
                    <option key={(h.household as { id?: string })?.id} value={(h.household as { id?: string })?.id}>
                      {(h.household as { name?: string })?.name ?? "Household"}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {deleteStatus && (
              <div style={{ marginBottom: 10, fontSize: 13, color: deleteStatus.type === "ok" ? "#16a34a" : "#dc2626" }}>
                {deleteStatus.text}
              </div>
            )}
            <button
              type="button"
              onClick={() => { setDangerOpen(true); setDeleteStatus(null); setConfirmName(""); }}
              disabled={!canDelete}
              style={{ ...btnSecondary, background: "#fef2f2", color: "#dc2626", border: "2px solid #fecaca", width: "100%", fontSize: 13 }}
            >
              Delete this household
            </button>
            <Modal open={dangerOpen} onClose={() => setDangerOpen(false)} title="Delete household">
              <p style={{ margin: "0 0 12px", fontSize: 14, color: "#374151", lineHeight: 1.5 }}>
                This permanently deletes <b>{activeName || "this household"}</b> and all its inventory, shopping list items, alerts, and waste logs.
                Only the <b>owner</b> can do this.
              </p>
              <label style={labelStyle}>Type the household name to confirm</label>
              <input value={confirmName} onChange={(e) => setConfirmName(e.target.value)} style={inputStyle} placeholder={activeName || "Household name"} />
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 16 }}>
                <button type="button" onClick={() => setDangerOpen(false)} style={btnSecondary}>Cancel</button>
                <button
                  type="button"
                  disabled={!canDelete || !activeName || confirmName.trim() !== activeName}
                  onClick={async () => {
                    try {
                      if (!deleteHousehold) throw new Error("Delete is not available.");
                      await deleteHousehold(activeId);
                      setDangerOpen(false);
                      setDeleteStatus({ type: "ok", text: "Household deleted." });
                    } catch (err) {
                      setDeleteStatus({ type: "err", text: errText(err, "Failed to delete household") });
                    }
                  }}
                  style={{ ...btnPrimary, background: "#dc2626" }}
                >
                  Delete permanently
                </button>
              </div>
            </Modal>
          </Card>
        )}

        {/* Subscription */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 8px" }}>Subscription</h3>
          <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 12px" }}>Manage your plan and billing.</p>
          <button onClick={() => setPage?.("pricing")} style={{ ...btnPrimary, fontSize: 13, display: "flex", alignItems: "center", gap: 6 }}>View Plans & Pricing</button>
        </Card>

        {/* Data & Privacy */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 16px" }}>Data & Privacy</h3>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <button onClick={() => {
              try {
                const data = { inventory, shopList, wasteLog, settings, exportedAt: new Date().toISOString() };
                const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `ingrediable-export-${new Date().toISOString().slice(0, 10)}.json`;
                a.click();
                URL.revokeObjectURL(url);
              } catch (e) { console.error("Export failed:", e); }
            }} style={{ ...btnSecondary, display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}><Icons.Download style={{ width: 14, height: 14 }} />Export My Data</button>
            <button onClick={async () => {
              if (!confirm("Are you sure you want to delete your account? This action cannot be undone.")) return;
              if (!confirm("This will permanently delete all your data, inventory, and settings. Type OK to continue.")) return;
              try {
                if (currentUserId) {
                  const { supabase } = await import("./lib/supabase-client");
                  // Delete user data from all tables
                  await supabase.from("inventory_items").delete().eq("added_by", currentUserId);
                  await supabase.from("shopping_list_items").delete().eq("added_by", currentUserId);
                  await supabase.from("waste_log").delete().eq("user_id", currentUserId);
                  await supabase.from("profiles").delete().eq("id", currentUserId);
                  // Sign out
                  await supabase.auth.signOut();
                } else {
                  // Local mode: clear all storage
                  await window.storage.delete("sm-inventory");
                  await window.storage.delete("sm-shoplist");
                  await window.storage.delete("sm-alerts");
                  await window.storage.delete("sm-waste");
                  await window.storage.delete("sm-settings");
                  await window.storage.delete("sm-recipes");
                  await window.storage.delete("sm-mealplan");
                  await window.storage.delete("sm-scan-prefs");
                }
                window.location.reload();
              } catch (e) { console.error("Delete account failed:", e); alert("Failed to delete account. Please try again."); }
            }} style={{ ...btnSecondary, background: "#fef2f2", color: "#dc2626", display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}><Icons.Trash style={{ width: 14, height: 14 }} />Delete Account</button>
          </div>
          <div style={{ marginTop: 12, display: "flex", gap: 16 }}>
            <button onClick={() => setPage?.("privacy")} style={{ background: "none", border: "none", color: "#2d5a27", fontSize: 13, fontWeight: 600, cursor: "pointer", padding: 0, fontFamily: "inherit", textDecoration: "underline" }}>Privacy Policy</button>
            <button onClick={() => setPage?.("terms")} style={{ background: "none", border: "none", color: "#2d5a27", fontSize: 13, fontWeight: 600, cursor: "pointer", padding: 0, fontFamily: "inherit", textDecoration: "underline" }}>Terms of Service</button>
          </div>
        </Card>

        {/* Reset */}
        <Card>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 8px" }}>Reset App Data</h3>
          <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 12px" }}>Clear all stored data and start fresh.</p>
          <button onClick={async () => {
            try {
              await window.storage.delete("sm-inventory");
              await window.storage.delete("sm-shoplist");
              await window.storage.delete("sm-alerts");
              await window.storage.delete("sm-waste");
              await window.storage.delete("sm-settings");
              window.location.reload();
            } catch {}
          }} style={{ ...btnSecondary, background: "#fef2f2", color: "#dc2626", fontSize: 13 }}>Reset All Data</button>
        </Card>
      </div>
    </div>
  );
}
